
export const translations = {
    vi: {
        NạptiềnTRANSFER: 'Chuyển tiền',
        Tout: "Chuyển ra",
        Tin: "Chuyển vào",
        ToBuy: "để mua Quyền Thành viên VIP. Bạn muốn tiếp tục?",
        VipDuty: "Nghĩa vũ thành viên VIP",
        Rule: "Người dùng chỉ có thể giao dịch Tăng hoặc Giảm trong một phiên và phải giao dịch trong các phiên liên tiếp nhau. Mỗi giao dịch trong một phiên phải tối thiểu là $10. Số chuỗi thắng hoặc số chuỗi thua phải là 9 lần. Trong trường hợp có nhiều người dùng cùng trúng giải Độc Đắc trong cùng một phiên, giải thưởng sẽ được chia đều cho tất cả người dùng trúng giải trong cùng thời điểm. Người dùng phải hoàn thành xác minh danh tính (KYC) trên hệ thống của chúng tôi để đủ điều kiện tham gia thử thách này. Ngoài ra, hàng ngày sẽ có một giải Mega x5 giá trị thưởng được chọn ngẫu nhiên từ những người dùng trúng giải Độc Đắc trong ngày hiện tại. Nếu không có người dùng trúng giải Độc Đắc nào trong ngày hiện tại thì cũng sẽ không có giải Mega. Xin lưu ý rằng phần thưởng sẽ được chuyển vào Ví của tài khoản sau khoảng 48 giờ.</p><p>Chúng tôi có quyền thay đổi/ sửa đổi bất kỳ thông tin trong Điều khoản và Điều kiện hoặc bất kỳ chính sách/ hướng dẫn nào của nền tảng của chúng tôi, vào bất cứ thời gian nào và theo quyết định riêng của chúng tôi. Mọi thay đổi/ sửa đổi sẽ có hiệu lực ngay sau khi thông tin điều chỉnh được đăng trên nền tảng của chúng tôi hoặc sẽ thông báo cho bạn về những thay đổi/ sửa đổi đó qua email.</p><p>Chương trình Thử Thách Liên Hoàn và các lợi ích của nó được cung cấp theo quyết định riêng của chúng tôi. Chúng tôi có quyền sửa đổi hoặc hủy bỏ giải Độc Đắc cũng như cách mà chúng tôi đánh giá và trao thưởng cho các giao dịch đủ điều kiện của bạn.</p><p>Chúng tôi có quyền sửa đổi hoặc chấm dứt quyền nhận giải Độc Đắc của bạn khi phát hiện ra bất kỳ hành vi gian lận và không trung thực nào do bạn thực hiện để nhận thêm giải theo ưu đãi chương trình. Bạn sẽ bị tước quyền tham gia vào chương trình Thử Thách Liên Hoàn hoặc bị cấm sử dụng vĩnh viễn dịch vụ của chúng tôi mà sẽ không có thông báo trước đối với những trường hợp như vậy. Quyết định của chúng tôi sẽ là quyết định cuối cùng và chúng tôi sẽ không tham gia vào bất kỳ cuộc tranh luận nào liên quan đến vấn đề này.",
        TradeandMakeProfit: "Giao dịch và kiếm lợi nhuận",
        Prize: "Phần thưởng",
        YourHistory: "Lịch sử của bạn",
        PrizeReceiveHistory: "Lịch sử nhận giải",
        PrizeWinnerList: "Danh sách người nhận giải",
        ViewMoreInfo: "Xem thêm thông tin",
        TradeandWin: "Giao dịch và Thắng Giải",
        ShowBollinger: "Hiện dải Bollinger",
        OpenOrder: "Lệnh đã mở",
        CloseOrder: "Lệnh đã khớp",
        Up: "Tăng",
        Down: "Giảm",
        NạptiềnBANK: "Nạp tiền (USDT)",
        NạptiềnUSDT: "Nạp tiền (USDT)",
        Chuyểntiềntừvíchínhsangvígiaodịch: "Chuyển tiền từ ví chính sang ví giao dịch",
        Chuyểntiềntừvígiaodịchsangvíchính: "Chuyển tiền từ ví giao dịch sang ví chính",
        Last30days: "30 ngày gần nhất",
        Last7days: "7 ngày gần nhất",
        EnterUserName: "Nhập tên người dùng",
        TotalNewCommissions: "Tổng số hoa hồng mới",
        New: "mới",
        Week: "Tuần",
        DevelopeSkill: "Kỹ năng phát triển",
        StartFree: "Bắt đầu miễn phí",
        Saying: "PUTEX là nền tảng giao dịch hàng đầu thế giới, kết hợp những cải tiến mới nhất với công nghệ tiên tiến để cung cấp cho các nhà giao dịch trải nghiệm giao dịch tốt nhất",
        IdealPlatform: "Nền tảng lý tưởng để kiếm tiền",
        VipNotice: "Cấp bậc VIP mặc định của bạn sau khi trở thành thành viên VIP là Cấp 1. Để có thể nâng cấp Cấp bậc VIP, bạn phải trả phí nâng cấp và có đủ số lượng F1 đã mua thành viên VIP. Vào lúc 00:00:00 (UTC) Chủ nhật hàng tuần, Cấp bậc VIP mà bạn đã nâng cấp sẽ hết hạn, Cấp bậc mới của bạn sẽ được cập nhật dựa trên Khối lượng giao dịch hàng tuần của F1 và F1 đã mua Số lượng thành viên VIP trong 7 ngày qua.",
        YouHaveReachMaxLevel: "Chúc mừng! Bạn đa đạt Cấp tối đa.",
        AmountF1BuyVip: "Số lượng F1 đã mua thành viên VIP",
        UpgradeCharge: "Phí nâng cấp",
        Upgrade: "Nâng",
        ShowReferersByName: "Xem Người bạn giới thiệu bằng tên",
        ShowReferers: "Xem Người bạn giới thiệu bằng Cấp bậc",
        VipMemberManagement: "Quản lý thành viên VIP",
        Information: "Thông tin",
        UpBranch: "Tuyến trên",
        NoVipAuthorization: "Không có quyền thành viên VIP",
        TradeProfitDetail: "Chi tiết lợi nhuận Giao dịch",
        ThisMonthReceived: "Nhận được tháng này",
        TradingCommissionsChart: 'Biểu đồ giao dịch hoa hồng',
        InputTransferAmount: 'Hãy nhập lượng cần chuyển',
        CreateBonaxAccount: 'Tạo tài khoản PUTEX',
        RequestNewEmail: "Yêu cầu một email mới",
        InputNickname: "Nhập biệt danh",
        NeedBonaxAccount: "Cần có tài khoản PUTEX",
        ForgetPassword: "Quên mật khẩu",
        HaveAnAccount: 'Có tài khoản PUTEX?',
        SearchBy: "Tìm kiếm bằng",
        LoginToYourAccount: 'Đăng nhập vào tài khoản của bạn',
        Trade: "Giao dịch",
        Help: "Trợ giúp",
        Shopping: "Mua sắm",
        Setting: "Thiết lập",
        Guide: 'Hướng Dẫn',
        HideSensitiveContent: 'Ẩn dữ liệu nhạy cảm',
        Add: "Thêm",
        Vip: "Thành viên Vip",
        Get: 'Lấy',
        Size: 'Kích thước',
        NewPassword: 'Mật khẩu mới (tối thiểu 6 ký tự)',
        LevelDiagram: 'Sơ đồ các cấp',
        CommissionStatistics: 'Thống kê hoa hồng',
        Wallet: "Ví",
        Exchange: "Đổi tiền",
        OwnerName: "Tên chủ tài khoản",
        TotalCommissions: 'Tổng hoa hồng',
        Sound: 'Âm thanh',
        UploadImgNote: 'Ảnh tải lên cần dưới 5MB*',
        Dashboard: "Bảng điều khiển",
        Logout: "Đăng xuất",
        OTPfromTele: 'Mã OTP từ ứng dụng Telegram',
        Login: 'Đăng nhập',
        MinValue: 'Số tiền tối thiểu',
        ChangeImage: 'Thay ảnh',
        Challenge: "Giải thưởng",
        Profile: "Hồ Sơ",
        NoConfirmationEmail: "Không nhận được email xác nhận?",
        Settings: "Cài đặt",
        WithdrawalBank: 'Ngân hàng rút về',
        AccountNumber: 'Số tài khoản',
        NoNewNotifications: 'Không có thông báo mới',
        Command: "Lệnh",
        Optional: 'Không bắt buộc',
        TotalRoundWin: 'Tổng vòng thắng',
        TotalRoundDraw: 'Tổng vòng hòa',
        TotalRoundLose: 'Tổng vòng thua',
        Request: 'Yêu cầu',
        ReceiveBank: 'Ngân hàng nhận',
        CurrentPassword: 'Mật khẩu hiện tại',
        TurnSettingOn: 'Bật cài đặt này để ẩn thông tin thống kê tài khoản của bạn',
        TransferValue: 'Số lượng chuyển',
        InputEmail: "Nhập email",
        ReceiveAdress: {
            "1": 'Nhập',
            "2": 'Địa chỉ nhận',
        },
        Receive: "Nhận",
        MainAccount: 'Tài khoản chính',
        MainWallet: 'Ví chính',
        TradeWallet: 'Ví giao dịch',
        WaitingForResult: 'Chờ kết quả',
        RequestSuccess: 'Gửi yêu cầu thành công',
        QuickRecharge: "Nạp nhanh",
        Support: "Trung tâm hỗ trợ",
        RealAccount: "Tài khoản thực",
        DemoAccount: "Tài khoản Demo",
        showBalance: "Hiện số dư",
        Profit: "Lợi nhuận",
        CommissionShare: 'Nhận phần hồng tương ứng',
        CommissionEasy: 'Nhận hoa hồng dễ dàng',
        Sentiment: "Chỉ báo tâm lý",
        MakeMoney: "Kiếm tiền",
        Buy: "Mua",
        AmountOfMoneyLeft: 'Số tiền còn lại',
        Sell: "Bán",
        Register: 'Đăng ký',
        Bet: "Tiền cược",
        WithdrawValue: 'Số tiền rút',
        Recharge: "Nạp tiền",
        Withdraw: "Rút tiền",
        BuyCrypto: "Mua Crypto",
        Money: "Tiền",
        Network: "Mạng Lưới",
        TransferNote: "Bạn chỉ có thể giao dịch khi tài sản được chuyển đến tài khoản tương ứng. Chuyển tài sản không tốn phí.",
        MemberVip:
            "Bạn cần trở thành Thành viên VIP để nhận hoa hồng VIP và hoa hồng giao dịch",
        BuyNow: "Mua ngay",
        LinkRegister: "Link Đăng ký",
        Copy: "Sao chép",
        ReferralCode: "Mã giới thiệu",
        TradeId: "Mã giao dịch",
        InviteFriend: "Mời bạn",
        FriendAccepted: "Bạn của bạn đồng ý lời mời, hoàn tất đăng ký và giao dịch",
        FriendRegistered: "Bạn đăng ký",
        InviteFriendRegister: "Mời bạn bè đăng ký PUTEX qua liên kết",
        TotalAssets: "Tổng tài sản (USDT)",
        Reload: "Nạp lại",
        DepositComplaints: "Khiếu nại tiền gửi",
        Complain: "Khiếu nại",
        TransactionHistory: "Lịch sử giao dịch",
        BOData: "Số Liệu B.O",
        TotalRound: "Tổng vòng",
        WinRate: "Tỷ lệ thắng",
        TradeSumary: 'Tóm tắt giao dịch',
        TotalTransaction: "Tổng giao dịch",
        NetProfit: "Lợi nhuận ròng",
        TotalRevenue: "Tổng doanh thu",
        Search: "Tìm kiếm",
        Lang: "Ngôn ngữ",
        Currency: "Tiền tệ",
        ChangePassword: "Đổi mật khẩu",
        OldPassword: "Mật khẩu cũ",
        NewPassword: "Mật khẩu mới",
        EnterPassword: "Nhập lại mật khẩu mới",
        Enable2FA: "Bạn phải bật 2FA để điều chỉnh",
        Account: 'Tài khoản',
        NotOpen: "Bạn chưa có lệnh nào đang mở",
        Open: "MỞ",
        AccountName: 'Tên tài khoản',
        Close: "ĐÓNG",
        HideBalance: 'Ẩn số dư',
        UpLoadFromPc: 'Tải hình từ máy tính',
        ViewAll: 'Xem tất cả',
        InputPassword: "Nhập mật khẩu",
        Update: 'Cập nhật',
        Notification: 'Thông báo',
        DepositHistory: "Lịch Sử Nạp Tiền",
        WithdrawHistory: "Lịch Sử Rút tiền",
        ChangeAvatar: "Thay đổi ảnh đại diện",
        PersonalInformation: "Thông tin cá nhân",
        Verified: 'Đã xác minh',
        PendingVerify: 'Chờ xác minh',
        RejectedVerify: 'Từ chối xác minh',

        Nickname: "Biệt danh",
        VerifyIdentity: 'Xác minh danh tính:',
        PlaceOrder: 'Hãy đặt lệnh',
        VerifyAccount: "Xác minh tài khoản",
        EnsureTheSafety:
            "Để đảm bảo an toàn cho tài sản của bạn, chúng tôi cần xác minh danh tính. Hãy điền thông tin thật chính xác, khi đã hoàn tất xác minh danh tính thì thông tin sẽ không chỉnh sửa được nữa.",
        Confirm: "Xác nhận",
        AccountUnderReview: "Tài khoản đang được xem xét",
        AccountVerified: "Tài khoản đã được xác minh",
        Security: "Bảo mật",
        WantToChangePassword:
            "Bạn có muốn thay đổi mật khẩu không? Nhấp vào nút phía dưới để thay đổi.",
        RequiredToEnable2FA:
            "Bắt buộc bật 2FA để rút tiền hoặc cập nhật các bảo mật.",
        Open2FA: "Bật 2FA",
        Change: "Đổi",
        Surname: "Họ",
        Name: "Tên",
        CardPassport: "Số CMND / Hộ chiếu",
        Nation: "Quốc gia",
        Next: "Tiếp",
        Back: "Quay lại",
        Done: "Xong",
        WithdrawRequest: 'Yêu cầu rút tiền',
        AccountType: 'Loại tài khoản',
        IdentityAuthentication: "Xác thực danh tính",
        PleaseEnsureThePhoto1:
            "Hãy đảm bảo rằng ảnh chụp toàn vẹn và rõ ràng, có định dạng JPG, PNG, JPEG. ",
        PleaseEnsureThePhoto2:
            "Hãy chụp ảnh Chứng minh thư/Hộ chiếu của bạn. Ảnh cần sáng và rõ ràng, không bị mất góc.",
        FrontCard: "Mặt trước Chứng minh thư/Hộ chiếu",
        BackCard: "Mặt sau Chứng minh thư/Hộ chiếu",
        Consider: "Xem xét",
        ApplySuccess: 'Nộp đơn thành công',
        ClickDoneToComplete:
            "Chúng tôi sẽ xem xét thông tin của bạn và hoàn tất việc xác minh trong vòng 7 ngày làm việc!",
        YourAccountVerified: "Tài khoản của bạn đã được xác minh!",
        Asset: "Tài sản",
        StartTime: "Thời gian bắt đầu",
        Select: "Lựa chọn",
        Selected: "Đã chọn",
        OpenPrice: "Giá mở",
        ClosingPrice: "Giá đóng",
        Value: "Giá trị",
        Pay: "Thanh toán",
        Time: "Thời gian",
        Type: "Loại",
        PhoneNumber: "Số điện thoại",
        Description: "Txid/Mô tả",
        Cryptocurrency: "Tiền điện tử",
        Address: "Địa chỉ",
        Send: 'Gửi',
        GoogleAuthInput: "Nhập mã Google Authenticator",
        Warn2FA: 'Bắt buộc để rút tiền hoặc cập nhật các bảo mật',
        GoogleAuthentication: "Xác thực Google",
        GoogleAuthenticationIsEnabled:
            "Google Authenticator đã được bật. Để hủy kích hoạt, nhập mã Google Authenticator và nhấn Hủy kích hoạt.",
        OpenYourGoogleAuthentication:
            "Mở ứng dụng Google Authenticator của bạn và quét mã QR bên dưới hoặc nhập khóa vào ứng dụng. Khóa này dùng để khôi phục Xác thực Google của bạn khi bạn đổi hoặc mất điện thoại. Vui lòng sao lưu khóa này trước khi kích hoạt Xác thực Google.",
        BackupCode: "Mã sao lưu",
        Password: "Mật khẩu",
        Verification: "Mã xác thực",
        Code2FA: "Mã 2FA",
        SendCode: "Gửi mã",
        TurnOn: "Bật",
        Deactivate: "Hủy Kích Hoạt",
        AmountOfMoney: "Số tiền",
        DepositAddress: "Địa chỉ nạp tiền",
        Yours: "của bạn",
        SendOnly: "Chỉ gửi",
        From: 'Đến từ',
        ToThisAddress: "đến địa chỉ này",
        ConfirmationsNeeded: "confirmations cần thiết.",
        Max: "Tối đa",
        BalanceAmount: "Số tiền dư",
        VerifyNow: 'Xác nhận ngay',
        MinimumWithdrawAmount: "Số tiền rút tối thiểu là",
        TransactionProcessingFee: "Phí xử lý giao dịch",
        FromYourRemainingBalance: "sẽ được khấu trừ vào số dư còn lại của bạn.",
        DisclaimerTheParty:
            "Tuyên bố miễn trừ trách nhiệm: Các dịch vụ bên thứ ba ở trên có thể được sử dụng để mua tiền điện tử có thể được sử dụng để chơi trên Stake. Bằng cách đăng ký trên nền tảng của họ, bạn cũng chấp nhận các điều khoản dịch vụ của họ và sẽ được yêu cầu vượt qua quy trình KYC của họ, quy trình này chạy độc lập với quy trình của chúng tôi.",
        BecomeAVip: "Trở thành VIP",
        AcceptParticipation: "Chấp nhận tham gia",
        VipMemberCommissions: "Hoa hồng thành viên VIP",
        YouNeedToPay: {
            "1": 'Bạn cần thanh toán',
            "2": 'để trở thành Thành viên VIP. Bạn có muốn tiếp tục ?'
        },
        TotalCommissionTrades: "Tổng khối lượng giao dịch hoa hồng",
        AcknowledgeAndAgree: "Tôi xác nhận và đồng ý",
        TermsOfService: "Điều khoản về dịch vụ",
        YourBalanceIsInsufficient: "Số dư của bạn không đủ",
        LoadNow: "Nạp ngay",
        Overview: "Tổng Quan",
        Commission: "Hoa Hồng",
        SystemManagement: "Quản lý hệ thống",
        Rank: "Cấp bậc",
        Condition: "Điều kiện",
        TotalThisWeek: "tổng (Tuần này)",
        Agency: "Đại lý",
        Presenter: "Người giới thiệu",
        TotalOfVipMembers: "Tổng số thành viên VIP",
        TotalNumberOfTraders: "Tổng số nhà giao dịch",
        TotalNumberOfAgents: "Tổng số Đại lý",
        TradingCommissions: "Hoa hồng Giao dịch",
        VIPCommission: "Hoa hồng nâng VIP",
        ThisMonth: "Tháng này",
        LastMonth: "Tháng trước",
        RecentFigures: "Số liệu gần đây",
        TotalReceive: 'Tổng sẽ nhận',
        News: "Tin tức",
        TotalCommissions: "Tổng số hoa hồng",
        LowerLevelTradingVolume: "KLGD Cấp Dưới",
        TotalVolume: "Tổng khối lượng giao dịch của 7 tầng mỗi tháng.",
        Month: "Tháng",
        CommissionNote: "Mỗi ngày mới, bạn sẽ nhận hoa hồng giao dịch từ tuyến dưới của ngày hôm trước.",
        Total: "Tổng",
        Contact: "Liên hệ",
        EmailAddress: "Địa chỉ Email",
        Note: "Chú ý",
        SideNote: 'Ghi chú',
        YourRechargeAddress: {
            "1": "Địa chỉ nạp",
            "2": "của bạn"
        },
        TransferInfo: {
            "Warn": 'Vui lòng chuyển khoản đúng',
            "ToAccount": "vào tài khoản sau",
            "Content": 'Nội dung chuyển',
            "Warning1": "Chú ý: Vui lòng ghi đúng nội dung chuyển khoản bên trên để tránh phát sinh lỗi",
            "Warning2": "Vui lòng gọi hotline sau 10phút chuyển khoản nếu vẫn chưa lên điểm",
        },
        YouWillReceiveTradingCommissions:
            "Bạn sẽ nhận hoa hồng giao dịch từ tuyến dưới của ngay lập tức.",
        TradingProfitDetails: "Chi tiết Lợi nhuận Giao dịch",
        NumberOfTransactions: "Số lượng Giao dịch",
        TradingVolume: "Khối lượng Giao dịch",

        NoData: "Không có dữ liệu",
        Sales: "Doanh số",
        Date: "Ngày",
        ManagementAgent: "Quản lý đại lý",
        SeeWhoYouReferBy: "Xem Người bạn giới thiệu bằng",
        SearchResults: "Kết quả tìm kiếm",
        Period: "Khoảng thời gian",
        Yesterday: "Hôm qua",
        RecentDays: "ngày gần nhất",
        All: "Tất cả",
        Transfer: 'Chuyển tiền',
        TotalKLGD: "Tổng KLGD",
        HHAccepted: "HH Nhận",
        DepositOn: "Tiền nạp",
        ChooseWallet: 'Chọn ví',
        CommissionType: "Loại hoa hồng",
        TradeTurns: 'Lượt giao dịch',
        NetworkIsNoAvailable:
            "Mạng không sẵn sàng để chuyển tiền vui lòng chọn mạng khác hoặc loại tiền tệ khác.",
        OrderValue: 'Giá trị đặt',
        Internal: 'Nội bộ',
        Charge: 'Phí',
        Ensure: " Để đảm bảo an toàn cho tài sản của bạn, xin hãy xác nhận lần nữa blockchain bạn cần dùng là BSC",
        TradeType: 'Loại giao dịch',
        Sender_Receiver: 'Người gửi/nhận',
        Status: 'Trạng thái',
        FINISH: 'Thành công',
        NextStep: 'Bước tiếp theo',
        PENDING: 'Chờ xử lý',
        PROCESSING: 'Đang xử lý',
        CANCEL: 'Đã hủy',
        TransferSuccess: 'Chuyển tiền thành công',
        YouSuccecced: 'Bạn đã chuyển thành công',
        To: 'tới',
        InputRefererCode: "Nhập mã giới thiệu",
        YouChoose: 'Bạn chọn',
        InputName: 'Điền tên',
        InputName2: 'Điền họ và tên đệm',
        IdAndPassport: 'Số chứng minh thư/Hộ chiếu',
        ReceiverNickname: 'Biệt danh người nhận',
        DepositWithdraw: 'Giao dịch Nạp tiền Rút tiền sử dụng mạng lưới',

        ClickToPay: 'Nhấn vào đây để tiến hành thanh toán',
        MinValueWithdraw: 'Số tiền tối thiểu',
        NoteWithdraw: 'Nhập ghi chú của bạn',
        Require2FA: 'Bạn phải bật 2FA để yêu cầu rút tiền',
        ConfirmWithdraw: 'Xác nhận rút tiền',
        WithdrawAmount: 'Số lượng rút',
        WithdrawTime: 'Thời gian',
        WithdrawType: 'Loại rút',
        Input2FA: 'Nhập mã 2FA của bạn',

        TradingIndicatorsBenefit: "Các chỉ báo giao dịch giúp Khách hàng kiếm được nhiều tiền hơn",
        PUTEXAdvancedIndicators: "PUTEX phát triển các chỉ báo cực kỳ tiên tiến và dễ sử dụng để giúp các nhà giao dịch đưa ra quyết định tốt hơn trong giao dịch",
        SmartTraining: "Huấn luyện thông minh",
        EffectiveMoneyMaking: "Khám phá những cách hiệu quả nhất để kiếm tiền",
        NewEarningOpportunities: "Khám phá nhiều cơ hội kiếm tiền mới, từ việc giao dịch hàng ngày đến nhận thu nhập thụ động từ hoa hồng giao dịch hoặc hoa hồng VIP",
        OurPlatform: "Nền tảng của chúng tôi",
        InnovativePlatform: "Nền tảng xây dựng dựa sự đổi mới",
        LatestTradingInnovations: "Chúng tôi luôn cập nhật những cải tiến mới nhất trong lĩnh vực giao dịch để giúp ai cũng có thể kiếm được lợi nhuận từ giao dịch trên PUTEX",
        StableSecure: "Ổn định và bảo mật",
        ReferAndEarn: "Giới thiệu và kiếm tiền",
        FastFree: "Nhanh & Miễn phí",
        CustomerFeedback: "Trải nghiệm và đánh giá của khách hàng",
        UserFriendlyPlatform: "Nền tảng giao dịch thân thiện với người dùng",
        StreamlinedFeatures: "Các tính năng được sắp xếp hợp lý, dễ dàng tìm kiếm và giao dịch. Biểu đồ trực quan với các chỉ báo đầy đủ giúp tôi nhanh chóng nắm bắt xu hướng. Một lựa chọn tuyệt vời cho cả người mới Disclosures và nhà đầu tư chuyên nghiệp.",
        HighSecurityTrading: "Độ bảo mật cao, yên tâm giao dịch",
        SecureCryptoTrading: "Tôi luôn lo lắng về bảo mật khi giao dịch tiền điện tử, nhưng nền tảng này khiến tôi hoàn toàn yên tâm. Mọi giao dịch được thực hiện rõ ràng. Tôi chưa từng gặp phải bất kỳ vấn đề bảo mật nào. Đây là điểm cộng lớn mà ít nền tảng khác đạt được",
        DedicatedSupport: "Hỗ trợ khách hàng tận tình",
        ResponsiveSupportTeam: "Một trong những điều làm tôi ấn tượng là đội ngũ hỗ trợ luôn phản hồi rất nhanh chóng. Mọi thắc mắc của tôi đều được giải đáp trong vòng vài phút. Dù là về nạp rút tiền hay tính năng giao dịch, họ đều xử lý rất chuyên nghiệp",
        QuickStartJourney: "Bắt đầu hành trình của bạn sau vài phút",
        MultipleIncomeStreams: "Tạo nhiều nguồn thu nhập ngay hôm nay!",
        FAQ: "Câu hỏi thường gặp",
        VIPMemberObligations: "Nghĩa vụ của thành viên VIP",
        PrivacyPolicy: "Chính sách bảo mật",
        TermsConditions: "Điều khoản và Điều kiện",
        RiskWarning: "Cảnh báo Rủi ro",
        Disclaimer: "Tuyên bố từ chối trách nhiệm",
        UpdateNotifications: "Nhận thông báo cập nhật",
        SubscribeUpdates: "Đăng ký để nhận thông tin cập nhật và thông báo về trao đổi và sản phẩm của chúng tôi",
        Submit: "Gửi",
        EnterEmailAddress: "Nhập địa chỉ email của bạn",
    },
    en: {
        NạptiềnTRANSFER: 'Transfer',
        PROCESSING: 'Processing',
        Tout: "Transfer out",
        Tin: "Transfer in",
        ToBuy: "to buy VIP Member Rights. Do you want to continue?",
        VipDuty: "VIP Member Duty",
        Rule: "Users can only trade UP or DOWN in one session and must trade in consecutive sessions. Each trade in a session must be at least $10. The winning streak or losing streak must consist of 9 times. In the event that multiple users win the Jackpot in the same session, the prize will be evenly split among all winning users at that time. Users must complete identity verification (KYC) on our system to qualify for this challenge. Additionally, there will be a daily Mega prize worth 5x randomly selected from users who win the Jackpot on the current day. If no user wins the Jackpot on the current day, there will be no Mega prize. Please note that rewards will be credited to the account wallet within approximately 48 hours.We reserve the right to change/amend any information in the Terms and Conditions or any policy/guideline on our platform, at any time and at our sole discretion. Any changes/amendments will take effect immediately after the revised information is posted on our platform or you are notified of such changes/amendments via email.The Continuous Challenge program and its benefits are provided at our sole discretion. We reserve the right to modify or cancel the Jackpot prize and how we assess and reward your eligible transactions.We reserve the right to revoke or terminate your eligibility for the Jackpot prize if any fraudulent or dishonest behavior is detected, aimed at gaining extra rewards through the program. You will be disqualified from participating in the Continuous Challenge program or permanently banned from using our services without prior notice in such cases. Our decision will be final, and we will not engage in any disputes regarding this matter.",
        TradeandMakeProfit: "Trade and Make Profit",
        Prize: "Prize",
        YourHistory: "Your History",
        PrizeReceiveHistory: "Prize Receive History",
        PrizeWinnerList: "Prize Winner List",
        TradeandWin: "Trade and Win",
        ViewMoreInfo: "View more info",
        ShowBollinger: "Show Bollinger band",
        OpenOrder: "Open Order",
        CloseOrder: "Close Order",
        Up: "Up",
        Down: "Down",
        NạptiềnBANK: "Deposit money (USDT)",
        NạptiềnUSDT: "Deposit money (USDT)",
        Chuyểntiềntừvígiaodịchsangvíchính: "Transfer money from trading wallet to main wallet",
        Chuyểntiềntừvíchínhsangvígiaodịch: "Transfer money from main wallet to trading wallet",
        Last30days: "Last 30 days",
        Last7days: "Last 7 days",
        EnterUserName: "Enter username",
        TotalNewCommissions: "Total New Commissions",
        New: "new",
        Week: "Week",
        RejectedVerify: 'Rejected Verify',
        DevelopeSkill: "Developing skills",
        StartFree: "Start Free",
        Saying: "PUTEX is the world's leading trading platform, combining the latest innovations with advanced technology to provide traders with the best trading experience",
        IdealPlatform: "Ideal platform to make money",
        VipNotice: "Your default VIP level after becoming a VIP member is Level 1. To upgrade VIP level, you must pay the upgrade fee and have enough F1 bought VIP member. At 00:00:00 (UTC) every Sunday, the VIP level you have upgraded will expire, your new level will be updated based on the weekly trading volume of F1 and F1 bought VIP member in the past 7 days.",
        YouHaveReachMaxLevel: "Congratulations! You have reached the maximum level.",
        AmountF1BuyVip: "Amount of F1 bought VIP member",
        UpgradeCharge: "Upgrade Charge",
        Upgrade: "Upgrade",
        ShowReferersByName: "Show Referers By Name",
        ShowReferers: "Show Referers By Level",
        SearchBy: "Search by",
        VipMemberManagement: "VIP Member Management",
        TotalCommissionTrades: "Total commission trading volume",
        PhoneNumber: "Phone number",
        Information: "Information",
        UpBranch: "Up Branch",
        TotalOfVipMembers: "Total VIP members",
        NoVipAuthorization: "No VIP member authorization",
        TradeProfitDetail: "Trade Profit Detail",
        ThisMonthReceived: "Received this month",
        Receive: "Receive",
        TradingCommissionsChart: 'Trading Commissions Chart',
        CommissionNote: "Each new day, you will receive trading commissions from the downline of the previous day.",
        VipMemberCommissions: "VIP member commissions",
        Date: "Date",
        InputTransferAmount: 'Please enter the amount to transfer',
        CreateBonaxAccount: 'Create a PUTEX account',
        RequestNewEmail: "Request a new email",
        NoConfirmationEmail: "Did not receive confirmation email?",
        InputRefererCode: "Input referer code",
        InputNickname: "Input nickname",
        HaveAnAccount: 'Have a PUTEX account?',
        NeedBonaxAccount: "Need a PUTEX account",
        ForgetPassword: "Forget password",
        GoogleAuthInput: "Enter Google Authenticator code",
        InputPassword: "Input password",
        InputEmail: "Input email",
        LoginToYourAccount: 'Login to your account',
        Send: 'Send',
        ApplySuccess: 'Nộp đơn thành công',
        NextStep: 'Next step',
        IdAndPassport: 'Id/Passport number',
        InputName: 'Input name',
        InputName2: 'Input family and middle name',
        TurnSettingOn: 'Turn this setting on to hide your account\'s statistics',
        Warn2FA: 'Compulsory for withdraw and update securities',
        CurrentPassword: 'Current password',
        Account: 'Account',
        Verified: 'Verified',
        ChangeImage: 'Change image',
        Update: 'Update',
        UploadImgNote: 'Uploaded photo needs to be under 5MB*',
        UpLoadFromPc: 'Upload from Pc',
        TradeSumary: 'Trade sumary',
        TradeTurns: 'Trade turns',
        OTPfromTele: 'OTP code from Telegram application',
        AccountName: 'Account Name',
        AmountOfMoneyLeft: 'Amount of money left',
        WithdrawValue: 'Withdraw value',
        WithdrawRequest: 'Withdraw request',
        HideSensitiveContent: 'Hide sensitive data',
        TransferNote: "You can only trade once the assets are transferred to the corresponding account. Transferring assets is free of charge.",
        Transfer: 'Transfer',
        CANCEL: 'CANCEL',
        Status: 'Status',
        VerifyNow: 'Verify now',
        NewPassword: 'New password (at least 6 characters)',
        ReceiveBank: 'Receive bank',
        WithdrawalBank: 'Withdrawal bank',
        Sender_Receiver: 'Sender/Receiver',
        Size: 'Size',
        VerifyIdentity: 'Verify identity:',
        YouChoose: 'You choose',
        OwnerName: 'Owner\'s name',
        TotalRoundWin: 'Total rounds win',
        TotalRoundDraw: 'Total rounds draw',
        TotalRoundLose: 'Total rounds lose',
        Get: 'Get',
        Ensure: "To ensure the safety of your assets, please confirm again that the blockchain you need to use is BSC",
        NetworkIsNoAvailable:
            "Network is not available for money transfer please choose another network or another currency.",
        HHAccepted: "HH accepted",
        TotalKLGD: "Total KLGD",
        All: "All",
        CommissionType: "Commission Type",
        RecentDays: "recent days",
        Yesterday: "Yesterday",
        From: 'From',
        AccountNumber: 'Account number',
        ReceiveAdress: {
            "1": 'Input',
            "2": 'Receive address',
        },
        AccountType: 'Account type',
        Request: 'Request',
        SideNote: 'Note',
        Optional: 'Optional',
        Period: "Period",
        ChooseWallet: 'Choose Wallet',
        SearchResults: "Search Results",
        SeeWhoYouReferBy: "See Who You Refer By",
        ManagementAgent: "Management agent",
        MainWallet: 'Main Wallet',
        TradeWallet: 'Trade Wallet',
        MainAccount: 'Main Account',
        Sales: "Sales",
        HideBalance: 'Hide balance',
        ReceiverNickname: 'Receiver Nickname',
        FriendAccepted: 'Your friend has accepted your invitation, complete registration and transaction',
        NoData: "No data",
        Register: 'Register',
        TradeId: "Trade Id",
        ViewAll: 'View All',
        TradeType: 'Trade Type',
        MinValue: 'Minimum value',
        TransferSuccess: 'Transfer Success',
        ReceiverNickname: 'Receiver Nickname',
        YourRechargeAddress: {
            "1": "Your",
            "2": "recharge address",
        },
        Login: 'Login',
        Charge: 'Charge',
        RequestSuccess: 'Request Success',
        PlaceOrder: 'Place Order',
        TotalReceive: 'Total Receive',
        WaitingForResult: "Waiting for result",
        TransferInfo: {
            "Warn": 'Please transfer exactly',
            "ToAccount": "To the following account",
            "Content": 'Content',
            "Warning1": "Note: Please enter the correct transfer content above to avoid errors",
            "Warning2": "Please contact us through hotline 10 minutes after transfer if your account hasn't update points",
        },
        DepositOn: "Recharge amount",
        NoNewNotifications: "No new notifications",
        TradingVolume: "Trading Volume",
        NumberOfTransactions: "Number of Transactions",
        TradingProfitDetails: "Trading Profit Details",
        LevelDiagram: "Levels Diagram",
        YouWillReceiveTradingCommissions:
            "You will receive trading commissions from your downline immediately.",
        Note: "Note",
        Notification: 'Notification',
        EmailAddress: "Email address",
        showBalance: "Show Balance",
        Contact: "Contact",
        Total: "Total",
        Month: "Month",
        CommissionStatistics: 'Commission Statistics',
        CommissionShare: 'Receive the corresponding commission',
        CommissionEasy: 'Receive commission easily',
        TotalVolume: "Total trading volume of 7 floors per month.",
        LowerLevelTradingVolume: "Lower Level Trading Volume",
        TotalCommissions: "Total commission",
        News: "New",
        Guide: 'Guide',
        Sound: 'Sound',
        RecentFigures: "Recent figures",
        LastMonth: "Last month",
        ThisMonth: "This month",
        VIPCommission: "VIP Commission",
        TotalCommissions: 'Total Commissions',
        TradingCommissions: "Trading Commissions",
        TotalNumberOfAgents: "Total Number of Agents",
        TotalNumberOfTraders: "Total number of traders",
        Presenter: "Presenter",
        FriendRegistered: 'Friend registered',
        Agency: "Agency",
        TotalThisWeek: "total (This week)",
        Rank: "Rank",
        Condition: "Condition",
        YouSuccecced: 'You have successfully transferred',
        To: 'to',
        SystemManagement: "System management",
        Commission: "Commission",
        MakeMoney: "Make Money",
        Overview: "Overview",
        LoadNow: "Load now",
        YourBalanceIsInsufficient: "Your balance is insufficient",
        TermsOfService: "Terms of service",
        AcknowledgeAndAgree: "I acknowledge and agree",
        YouNeedToPay: {
            "1": 'You need to pay',
            "2": 'to become a VIP member. Would you like to continue ?'
        },
        AcceptParticipation: "Accept participation",
        BecomeAVip: "Become a VIP",
        DisclaimerTheParty:
            "Disclaimer: The above third party services may be used to purchase cryptocurrencies that may be used to play on Stake. By registering on their platform, you also accept their terms of service and will be required to pass their KYC process, which runs independently of ours.",
        Trade: "Trade",
        Help: "Help",
        Shopping: "Shopping",
        Setting: "Setting",
        Add: "Add",
        Vip: "Vip Member",
        Wallet: "Wallet",
        Exchange: "Exchange",
        Dashboard: "Dashboard",
        TransferValue: 'Transfer Value',
        Logout: "Logout",
        Challenge: "Challenge",
        Profile: "Profile",
        Settings: "Settings",
        Command: "Command",
        PENDING: 'Pending',
        FINISH: 'Succeed ',
        QuickRecharge: "Quick recharge",
        Support: "Support",
        RealAccount: "Real Account",
        DemoAccount: "Demo Account",
        Profit: "Profit",
        OrderValue: 'Order Value',
        Sentiment: "Sentiment indicator",
        Buy: "Buy",
        Sell: "Sell",
        Bet: "Bet",
        Internal: 'Internal',
        Recharge: "Recharge",
        Withdraw: "Withdraw",
        BuyCrypto: "Buy Crypto",
        Money: "Money",
        Network: "Network",
        MemberVip:
            "You need to become a VIP Member to receive VIP commissions and trading commissions",
        BuyNow: "Buy Now",
        LinkRegister: "Register Link",
        Copy: "Copy",
        ReferralCode: "Referral code",
        InviteFriend: "Invite friend",
        InviteFriendRegister: "Invite friend via PUTEX registration link",
        TotalAssets: "Total assets (USD)",
        Reload: "Reload",
        DepositComplaints: "Deposit complaints",
        Complain: "Complain",
        TransactionHistory: "Transaction history",
        BOData: "B.O. Data",
        TotalRound: "Total round",
        WinRate: "Win rate",
        TotalTransaction: "Total transaction",
        NetProfit: "Net profit",
        TotalRevenue: "Total revenue",
        Search: "Search",
        Lang: "Language",
        Currency: "Currency",
        ChangePassword: "Change password",
        OldPassword: "Old password",
        NewPassword: "New password",
        EnterPassword: "Enter the password",
        Enable2FA: "You must enable 2FA to adjust",
        NotOpen: "You don't have any open orders yet",
        Open: "OPEN",
        Close: "CLOSE",
        DepositHistory: "Deposit History",
        WithdrawHistory: "Withdraw History",
        ChangeAvatar: "Change Avatar",
        PersonalInformation: "Personal Information",
        Nickname: "Nickname",
        VerifyAccount: "Verify account",
        EnsureTheSafety:
            "To ensure the safety of your assets, we need to verify your identity. Please fill in the information accurately, once identity verification has been completed, the information will no longer be editable.",
        Confirm: "Confirm",
        AccountUnderReview: "Account under review",
        AccountVerified: "Account has been verified",
        Security: "Security",
        WantToChangePassword:
            "Do you want to change your password? Click the button below to change.",
        RequiredToEnable2FA:
            "Required to enable 2FA to withdraw funds or update security.",
        Open2FA: "Open 2FA",
        Change: "Change",
        Surname: "Surname",
        Name: "Name",
        CardPassport: "ID card / Passport number",
        Nation: "Nation",
        Next: "Next",
        Back: "Back",
        Done: "Done",
        IdentityAuthentication: "Identity authentication",
        PleaseEnsureThePhoto1:
            "Please ensure that the photo is complete and clear, in JPG, PNG, JPEG format.",
        PleaseEnsureThePhoto2:
            " Take a photo of your ID/Passport. The photo needs to be bright and clear, without lost angles.",
        FrontCard: "Front of ID card/Passport",
        BackCard: "Back of ID card/Passport",
        Consider: "Consider",
        ApplySuccess: 'Apply Success',
        ClickDoneToComplete:
            "We will review your information and complete verification within 7 business days!",
        YourAccountVerified: "Your account has been verified!",
        Asset: "Asset",
        StartTime: "Start time",
        Select: "Select",
        Selected: "Selected",
        OpenPrice: "Open price",
        ClosingPrice: "Closing price",
        Value: "Value",
        Pay: "Pay",
        Time: "Time",
        Type: "Type",
        Description: "Txid/Description",
        Cryptocurrency: "Cryptocurrency",
        Address: "Address",
        GoogleAuthentication: "Google Authentication",
        GoogleAuthenticationIsEnabled:
            "Google Authenticator is enabled. To deactivate, enter the Google Authenticator code and tap Deactivate.",
        OpenYourGoogleAuthentication:
            "Open your Google Authenticator app and scan the QR code below or enter the key into the app. This key is used to restore your Google Authentication when you change or lose your phone. Please back up this key before activating Google Authentication.",
        BackupCode: "Backup code",
        Password: "Password",
        Verification: "Verification",
        Code2FA: "2FA code",
        SendCode: "Send code",
        TurnOn: "Turn on",
        Deactivate: "Deactivate",
        AmountOfMoney: "Amount of money",
        DepositAddress: "Deposit address",
        Yours: "yours",
        SendOnly: "Send only",
        ToThisAddress: "to this address",
        ConfirmationsNeeded: "confirmations needed.",
        Max: "Max",
        BalanceAmount: "Balance amount",
        MinimumWithdrawAmount: "Minimum withdrawal amount is",
        TransactionProcessingFee: "Transaction processing fee",
        FromYourRemainingBalance: "will be deducted from your remaining balance.",
        DepositWithdraw: 'Deposit Withdrawal transaction using network',
        ClickToPay: "Click here to proceed with payment",
        MinValueWithdraw: "Minimum amount",
        NoteWithdraw: "Enter your note",
        Require2FA: "You must enable 2FA to request a withdrawal",
        ConfirmWithdraw: "Confirm withdrawal",
        WithdrawAmount: "Withdrawal amount",
        WithdrawTime: "Time",
        WithdrawType: "Withdrawal type",
        Input2FA: "Enter your 2FA code",

        TradingIndicatorsBenefit: "Trading indicators help clients earn more money",
        PUTEXAdvancedIndicators: "PUTEX develops highly advanced and user-friendly indicators to help traders make better trading decisions",
        SmartTraining: "Smart training",
        EffectiveMoneyMaking: "Discover the most effective ways to earn money",
        NewEarningOpportunities: "Explore new money-making opportunities, from daily trading to earning passive income from trading commissions or VIP commissions",
        OurPlatform: "Our platform",
        InnovativePlatform: "A platform built on innovation",
        LatestTradingInnovations: "We always update the latest innovations in trading to help everyone profit from trading on PUTEX",
        StableSecure: "Stable and secure",
        ReferAndEarn: "Refer and earn money",
        FastFree: "Fast & Free",
        CustomerFeedback: "Customer experience and feedback",
        UserFriendlyPlatform: "User-friendly trading platform",
        StreamlinedFeatures: "Streamlined features, easy to search and trade. Intuitive charts with comprehensive indicators help me quickly grasp trends. A great choice for both beginners and professional investors.",
        HighSecurityTrading: "High security, confident trading",
        SecureCryptoTrading: "I was always worried about security when trading crypto, but this platform puts me completely at ease. Every transaction is transparent. I’ve never encountered any security issues. This is a big plus that few other platforms achieve.",
        DedicatedSupport: "Dedicated customer support",
        ResponsiveSupportTeam: "One of the things that impressed me is the support team’s quick response. All my questions are answered within minutes. Whether it’s about deposits, withdrawals, or trading features, they handle it very professionally.",
        QuickStartJourney: "Start your journey in minutes",
        MultipleIncomeStreams: "Create multiple income streams today!",
        FAQ: "Frequently Asked Questions",
        VIPMemberObligations: "VIP member obligations",
        PrivacyPolicy: "Privacy Policy",
        TermsConditions: "Terms and Conditions",
        RiskWarning: "Risk Warning",
        Disclaimer: "Disclaimer",
        UpdateNotifications: "Receive update notifications",
        SubscribeUpdates: "Sign up to receive updates and notifications about our exchange and products",
        Submit: "Submit",
        EnterEmailAddress: "Enter your email address"
    },
    ja: {
        NạptiềnTRANSFER: '転送',
        PROCESSING: '処理中',
        Tout: "出金",
        Tin: "入金",
        ToBuy: "VIPメンバー権利を購入するには",
        VipDuty: "VIPメンバーの義務",
        Rule: "「ユーザーは1つのセッション内でUPまたはDOWNの取引のみを行うことができ、連続したセッションで取引を行う必要があります。1回のセッション内の各取引は最低$10でなければなりません。勝ち続ける回数または負け続ける回数は9回である必要があります。同じセッション内で複数のユーザーがジャックポットを獲得した場合、賞金はその時点でのすべての勝者に均等に分配されます。このチャレンジに参加するには、システム上で本人確認（KYC）を完了する必要があります。さらに、現在の日にジャックポットを獲得したユーザーの中からランダムに選ばれた1人に、日替わりでMega賞（賞金の5倍）が与えられます。その日にジャックポットの勝者がいない場合、Mega賞もありません。賞金は約48時間以内にアカウントのウォレットに振り込まれますのでご注意ください。私たちは、プラットフォームの利用規約またはポリシー/ガイドラインの情報を、独自の裁量でいつでも変更/修正する権利を有します。変更/修正された情報は、プラットフォーム上で公開された後またはメールで通知された時点で即時に有効となります。連続チャレンジプログラムとその特典は、当社の独自の裁量によって提供されます。当社は、ジャックポット賞の内容や、適格な取引を評価・報酬する方法を変更または取り消す権利を有します。プログラムを悪用し不正行為を行った場合、ジャックポット賞の権利が無効になるか、永久にサービス利用が禁止される可能性があります。このような場合において、通知なしで連続チャレンジプログラムへの参加資格を剥奪する権利を有します。当社の判断は最終的なものであり、これに関する議論には応じません。」",
        TradeandMakeProfit: "取引して利益を上げる",
        Prize: "賞品",
        YourHistory: "あなたの履歴",
        PrizeReceiveHistory: "賞品受賞履歴",
        PrizeWinnerList: "賞品受賞者リスト",
        ViewMoreInfo: "詳細を表示",
        TradeandWin: "トレードして勝つ",
        ShowBollinger: "ボリンジャーバンドを表示",
        OpenOrder: "オープンオーダー",
        CloseOrder: "クローズオーダー",
        Up: "上げる",
        Down: "下げる",
        NạptiềnBANK: "銀行に入金する",
        NạptiềnUSDT: "USDTに入金する",
        Chuyểntiềntừvígiaodịchsangvíchính: "取引ウォレットからメインウォレットに送金する",
        Chuyểntiềntừvíchínhsangvígiaodịch: "メインウォレットから取引ウォレットに送金する",
        Last30days: "過去30日間",
        Last7days: "過去7日間",
        EnterUserName: "ユーザー名を入力してください",
        TotalNewCommissions: "新しい手数料の合計",
        New: "新しい",
        Week: "週",
        RejectedVerify: '拒否された検証',
        DevelopeSkill: "スキルを開発する",
        StartFree: "無料で開始",
        Saying: "PUTEXは、最新の革新と先進技術を組み合わせて、トレーダーに最高の取引体験を提供するための世界をリードする取引プラットフォームです。",
        IdealPlatform: "お金を稼ぐための理想的なプラットフォーム",
        VipNotice: "VIPメンバーになった後のデフォルトのVIPレベルはレベル1です。VIPレベルをアップグレードするには、アップグレード料金を支払い、VIPメンバーを購入したF1の数が必要です。毎週日曜日の00:00:00（UTC）に、アップグレードしたVIPレベルが期限切れになり、新しいレベルは過去7日間のF1の週間取引量とVIPメンバーを購入したF1に基づいて更新されます。",
        YouHaveReachMaxLevel: "おめでとうございます！最大レベルに達しました。",
        AmountF1BuyVip: "F1がVIPメンバーを購入した金額",
        UpgradeCharge: "アップグレードチャージ",
        Upgrade: "アップグレード",
        ShowReferersByName: "名前別紹介者を表示",
        ShowReferers: "レベル別紹介者を表示",
        SearchBy: "検索",
        VipMemberManagement: "VIPメンバー管理",
        TotalCommissionTrades: "取引手数料の合計",
        PhoneNumber: "電話番号",
        Information: "情報",
        UpBranch: "上位ブランチ",
        TotalOfVipMembers: "VIPメンバーの合計",
        NoVipAuthorization: "VIPメンバーの権限がありません",
        TradeProfitDetail: "取引利益詳細",
        ThisMonthReceived: "今月受け取る",
        Receive: "受け取る",
        TradingCommissionsChart: '取引手数料チャート',
        CommissionNote: "新しい日ごとに、前日のダウンラインから取引手数料を受け取ります。",
        VipMemberCommissions: "VIPメンバーの手数料",
        Date: "日付",
        InputTransferAmount: '転送する金額を入力してください',
        CreateBonaxAccount: 'PUTEXアカウントを作成する',
        RequestNewEmail: "新しいメールをリクエストする",
        NoConfirmationEmail: "確認メールが届きませんでした ?",
        InputRefererCode: "紹介コードを入力してください",
        InputNickname: "ニックネームを入力してください",
        HaveAnAccount: 'PUTEXアカウントをお持ちですか ?',
        NeedBonaxAccount: "PUTEXアカウントが必要ですか",
        ForgetPassword: "パスワードを忘れた",
        GoogleAuthInput: "Google認証コードを入力してください",
        InputPassword: "パスワードを入力してください",
        InputEmail: "メールアドレスを入力してください",
        LoginToYourAccount: 'アカウントにログイン',
        Send: '送信',
        ApplySuccess: '申請成功',
        NextStep: '次のステップ',
        IdAndPassport: 'ID/パスポート番号',
        InputName: '名前を入力してください',
        InputName2: '姓とミドルネームを入力してください',
        TurnSettingOn: 'この設定をオンにして、アカウントの統計情報を非表示にします',
        Warn2FA: '出金と証券の更新には必須です',
        CurrentPassword: '現在のパスワード',
        Account: 'アカウント',
        Verified: '確認済み',
        ChangeImage: '画像を変更',
        Update: '更新',
        UploadImgNote: 'アップロードした写真は5MB以内である必要があります*',
        UpLoadFromPc: 'PCからアップロード',
        TradeSumary: '取引サマリー',
        TradeTurns: '取引ターン',
        OTPfromTele: 'TelegramアプリからのOTPコード',
        AccountName: 'アカウント名',
        AmountOfMoneyLeft: '残高',
        WithdrawValue: '出金額',
        WithdrawRequest: '出金リクエスト',
        HideSensitiveContent: 'センシティブな情報を非表示にする',
        TransferNote: '資産を対応するアカウントに転送した後、取引できます。資産の転送は無料です。',
        Transfer: '転送',
        CANCEL: 'キャンセル',
        Status: 'ステータス',
        VerifyNow: '今すぐ確認',
        NewPassword: '新しいパスワード（最低6文字）',
        ReceiveBank: '受取銀行',
        WithdrawalBank: '出金銀行',
        Sender_Receiver: '送信者/受信者',
        Size: 'サイズ',
        VerifyIdentity: '本人確認:',
        YouChoose: 'あなたが選んだ',
        OwnerName: '所有者名',
        TotalRoundWin: '総勝利ラウンド数',
        TotalRoundDraw: '総引き分けラウンド数',
        TotalRoundLose: '総敗北ラウンド数',
        Get: '取得',
        Ensure: '資産の安全を確保するために、使用する必要があるブロックチェーンがBSCであることを再確認してください。',
        NetworkIsNoAvailable: 'ネットワークが利用できません。別のネットワークまたは通貨を選択してください。',
        HHAccepted: 'HH承認済み',
        TotalKLGD: '総KLGD',
        All: 'すべて',
        CommissionType: '手数料タイプ',
        RecentDays: '最近の日',
        Yesterday: '昨日',
        From: 'から',
        AccountNumber: 'アカウント番号',
        ReceiveAdress: {
            "1": '入力',
            "2": '受取アドレス',
        },
        AccountType: 'アカウントタイプ',
        Request: 'リクエスト',
        SideNote: 'メモ',
        Optional: 'オプション',
        Period: '期間',
        ChooseWallet: 'ウォレットを選択',
        SearchResults: '検索結果',
        SeeWhoYouReferBy: 'あなたが紹介した人を確認',
        ManagementAgent: '管理代理人',
        MainWallet: 'メインウォレット',
        TradeWallet: '取引ウォレット',
        MainAccount: 'メインアカウント',
        Sales: '販売',
        HideBalance: '残高を非表示にする',
        ReceiverNickname: '受信者のニックネーム',
        FriendAccepted: 'あなたの友達は招待を受け入れました、登録と取引を完了してください',
        NoData: 'データがありません',
        Register: '登録',
        TradeId: '取引ID',
        ViewAll: 'すべて表示',
        TradeType: '取引タイプ',
        MinValue: '最小額',
        TransferSuccess: '転送成功',
        ReceiverNickname: '受信者のニックネーム',
        YourRechargeAddress: {
            "1": 'あなたの',
            "2": '入金アドレス',
        },
        Login: 'ログイン',
        Charge: 'チャージ',
        RequestSuccess: 'リクエスト成功',
        PlaceOrder: '注文する',
        TotalReceive: '総受取',
        WaitingForResult: '結果を待っています',
        TransferInfo: {
            "Warn": '正確に転送してください',
            "ToAccount": '以下のアカウントに',
            "Content": '内容',
            "Warning1": '注意: 上記の正しい転送内容を入力してください。間違えた場合はエラーが発生します',
            "Warning2": '転送後10分以内にアカウントのポイントが更新されていない場合は、ホットラインでご連絡ください。',
        },
        DepositOn: '入金額',
        NoNewNotifications: '新しい通知はありません',
        TradingVolume: '取引量',
        NumberOfTransactions: '取引数',
        TradingProfitDetails: '取引利益詳細',
        LevelDiagram: 'レベル図',
        YouWillReceiveTradingCommissions: 'あなたはダウンラインからの取引手数料をすぐに受け取ります。',
        Note: 'メモ',
        Notification: '通知',
        EmailAddress: 'メールアドレス',
        showBalance: '残高を表示',
        Contact: '連絡先',
        Total: '合計',
        Month: '月',
        CommissionStatistics: '手数料統計',
        CommissionShare: '対応する手数料を受け取る',
        CommissionEasy: '簡単に手数料を受け取る',
        TotalVolume: '7階層の総取引量（月ごと）',
        LowerLevelTradingVolume: '下位層取引量',
        TotalCommissions: '総手数料',
        New: '新しい',
        Guide: 'ガイド',
        Sound: '音',
        RecentFigures: '最近の数字',
        LastMonth: '先月',
        ThisMonth: '今月',
        VIPCommission: 'VIP手数料',
        TotalCommissions: '総手数料',
        TradingCommissions: '取引手数料',
        TotalNumberOfAgents: '総代理人数',
        TotalNumberOfTraders: '総トレーダー数',
        Presenter: 'プレゼンター',
        FriendRegistered: '友達が登録しました',
        Agency: '代理店',
        TotalThisWeek: '総計（今週）',
        Rank: 'ランク',
        Condition: '条件',
        YouSuccecced: '転送に成功しました',
        To: 'へ',
        SystemManagement: 'システム管理',
        Commission: 'コミッション',
        MakeMoney: 'お金を稼ぐ',
        Overview: '概要',
        LoadNow: '今すぐロード',
        YourBalanceIsInsufficient: '残高が不足しています',
        TermsOfService: '利用規約',
        AcknowledgeAndAgree: '同意します',
        YouNeedToPay: {
            "1": 'VIPメンバーになるには',
            "2": '支払う必要があります。続行しますか？'
        },
        AcceptParticipation: '参加を受け入れる',
        BecomeAVip: 'VIPになる',
        DisclaimerTheParty: '免責事項: 上記のサードパーティサービスは、Stakeでプレイするために使用する可能性のある暗号通貨を購入するために使用できます。彼らのプラットフォームに登録することで、彼らの利用規約を受け入れ、KYCプロセスを通過する必要があります。',
        Trade: '取引',
        Help: 'ヘルプ',
        Shopping: 'ショッピング',
        Setting: '設定',
        Add: '追加',
        Vip: 'VIPメンバー',
        Wallet: 'ウォレット',
        Exchange: '交換',
        Dashboard: 'ダッシュボード',
        TransferValue: '転送額',
        Logout: 'ログアウト',
        Challenge: 'チャレンジ',
        Profile: 'プロフィール',
        Settings: '設定',
        Command: 'コマンド',
        PENDING: '保留中',
        FINISH: '完了',
        QuickRecharge: 'クイックチャージ',
        Support: 'サポート',
        RealAccount: '実際のアカウント',
        DemoAccount: 'デモアカウント',
        Profit: '利益',
        OrderValue: '注文額',
        Sentiment: 'センチメント指標',
        Buy: '購入',
        Sell: '販売',
        Bet: 'ベット',
        Internal: '内部',
        Recharge: '再充電',
        Withdraw: '出金',
        BuyCrypto: '暗号通貨を購入',
        Money: 'お金',
        Network: 'ネットワーク',
        MemberVip: 'VIPメンバーになることで、VIPコミッションと取引コミッションを受け取ることができます',
        BuyNow: '今すぐ購入',
        LinkRegister: '登録リンク',
        Copy: 'コピー',
        ReferralCode: '紹介コード',
        InviteFriend: '友達を招待',
        InviteFriendRegister: 'PUTEX登録リンクを通じて友達を招待',
        TotalAssets: '総資産（USD）',
        Reload: 'リロード',
        DepositComplaints: '入金クレーム',
        Complain: 'クレーム',
        TransactionHistory: '取引履歴',
        BOData: 'B.O.データ',
        TotalRound: '総ラウンド',
        WinRate: '勝率',
        TotalTransaction: '総取引数',
        NetProfit: '純利益',
        TotalRevenue: '総収益',
        Search: '検索',
        Lang: '言語',
        Currency: '通貨',
        ChangePassword: 'パスワード変更',
        OldPassword: '古いパスワード',
        NewPassword: '新しいパスワード',
        EnterPassword: 'パスワードを入力',
        Enable2FA: '2FAを有効にして調整する必要があります',
        NotOpen: 'まだ注文は開いていません',
        Open: '開く',
        Close: '閉じる',
        DepositHistory: '入金履歴',
        WithdrawHistory: '出金履歴',
        ChangeAvatar: 'アバターを変更',
        PersonalInformation: '個人情報',
        Nickname: 'ニックネーム',
        VerifyAccount: 'アカウント確認',
        EnsureTheSafety: '資産の安全を確保するために、本人確認を行う必要があります。正確に情報を記入してください。本人確認が完了すると、情報の変更はできなくなります。',
        Confirm: '確認',
        AccountUnderReview: 'アカウントは審査中です',
        AccountVerified: 'アカウントは確認済みです',
        Security: 'セキュリティ',
        WantToChangePassword: 'パスワードを変更しますか？下のボタンをクリックして変更できます。',
        RequiredToEnable2FA: '出金またはセキュリティの更新には2FAの有効化が必要です。',
        Open2FA: '2FAを開く',
        Change: '変更',
        Surname: '姓',
        Name: '名前',
        CardPassport: 'IDカード / パスポート番号',
        Nation: '国',
        Next: '次',
        Back: '戻る',
        Done: '完了',
        IdentityAuthentication: '本人確認',
        PleaseEnsureThePhoto1: '写真が完全で明確であり、JPG、PNG、JPEG形式であることを確認してください。',
        PleaseEnsureThePhoto2: 'IDカード/パスポートの写真を撮影してください。写真は明るく、角度が欠けないようにしてください。',
        FrontCard: 'IDカード/パスポートの表面',
        BackCard: 'IDカード/パスポートの裏面',
        Consider: '考慮',
        ApplySuccess: '申請成功',
        ClickDoneToComplete: '情報を確認し、7営業日以内に確認を完了します。',
        YourAccountVerified: 'あなたのアカウントは確認されました！',
        Asset: '資産',
        StartTime: '開始時間',
        Select: '選択',
        Selected: '選択済み',
        OpenPrice: '開始価格',
        ClosingPrice: '終了価格',
        Value: '価値',
        Pay: '支払う',
        Time: '時間',
        Type: 'タイプ',
        Description: 'Txid/説明',
        Cryptocurrency: '暗号通貨',
        Address: 'アドレス',
        GoogleAuthentication: 'Google認証',
        GoogleAuthenticationIsEnabled: 'Google認証が有効です。無効にするには、Google認証コードを入力し、無効化をタップしてください。',
        OpenYourGoogleAuthentication: 'Google認証アプリを開き、以下のQRコードをスキャンするか、アプリにキーを入力してください。このキーは、電話を変更または紛失した場合にGoogle認証を復元するために使用します。Google認証を有効にする前にこのキーをバックアップしてください。',
        BackupCode: 'バックアップコード',
        Password: 'パスワード',
        Verification: '認証',
        Code2FA: '2FAコード',
        SendCode: 'コードを送信',
        TurnOn: 'オンにする',
        Deactivate: '無効化',
        AmountOfMoney: '金額',
        DepositAddress: '入金アドレス',
        Yours: 'あなたの',
        SendOnly: 'のみ送信',
        ToThisAddress: 'このアドレスに送信',
        ConfirmationsNeeded: '確認が必要です。',
        Max: '最大',
        BalanceAmount: '残高',
        MinimumWithdrawAmount: '最小出金額は',
        TransactionProcessingFee: '取引処理手数料',
        FromYourRemainingBalance: '残高から差し引かれます。',
        DepositWithdraw: 'ネットワークを使用した入金出金取引',
        ClickToPay: "ここをクリックして支払いを進める",
        MinValueWithdraw: "最低金額",
        NoteWithdraw: "メモを入力",
        Require2FA: "出金リクエストには2FAを有効にする必要があります",
        ConfirmWithdraw: "出金を確認",
        WithdrawAmount: "出金額",
        WithdrawTime: "時間",
        WithdrawType: "出金の種類",
        Input2FA: "2FAコードを入力してください",

        TradingIndicatorsBenefit: "取引インジケーターは顧客がより多くのお金を稼ぐのを助けます",
        PUTEXAdvancedIndicators: "PUTEXは非常に高度で使いやすいインジケーターを開発し、トレーダーがより良い取引決定を行うのを支援します",
        SmartTraining: "スマートトレーニング",
        EffectiveMoneyMaking: "最も効果的なお金の稼ぎ方を見つけましょう",
        NewEarningOpportunities: "デイリートレーディングから取引手数料やVIP手数料による受動的収入まで、新しいお金の稼ぎ方の機会を探求しましょう",
        OurPlatform: "私たちのプラットフォーム",
        InnovativePlatform: "革新に基づいて構築されたプラットフォーム",
        LatestTradingInnovations: "私たちは常に取引分野の最新の革新を更新し、PUTEXでの取引から誰もが利益を得られるようにします",
        StableSecure: "安定かつ安全",
        ReferAndEarn: "紹介してお金を稼ぐ",
        FastFree: "迅速かつ無料",
        CustomerFeedback: "顧客の体験とフィードバック",
        UserFriendlyPlatform: "使いやすい取引プラットフォーム",
        StreamlinedFeatures: "合理化された機能、検索や取引が簡単。直感的なチャートと包括的なインジケーターでトレンドを素早く把握できます。初心者からプロの投資家まで素晴らしい選択肢です。",
        HighSecurityTrading: "高い安全性、安心の取引",
        SecureCryptoTrading: "暗号通貨の取引での安全性が常に心配でしたが、このプラットフォームは完全に安心させてくれます。すべての取引が透明です。セキュリティの問題に一度も遭遇していません。他のプラットフォームではなかなか達成できない大きな利点です。",
        DedicatedSupport: "献身的なカスタマーサポート",
        ResponsiveSupportTeam: "印象的だったのは、サポートチームの迅速な対応です。すべての質問が数分以内に回答されます。入出金や取引機能に関する質問でも、非常にプロフェッショナルに対応してくれます。",
        QuickStartJourney: "数分であなたの旅を始めましょう",
        MultipleIncomeStreams: "今日から複数の収入源を作りましょう！",
        FAQ: "よくある質問",
        VIPMemberObligations: "VIP会員の義務",
        PrivacyPolicy: "プライバシーポリシー",
        TermsConditions: "利用規約",
        RiskWarning: "リスク警告",
        Disclaimer: "免責事項",
        UpdateNotifications: "更新通知を受け取る",
        SubscribeUpdates: "私たちの取引所や製品に関する更新や通知を受け取るために登録してください",
        Submit: "送信",
        EnterEmailAddress: "メールアドレスを入力してください"
    },
    zh: {
        NạptiềnTRANSFER: '转账',
        PROCESSING: '处理中',
        Tout: "转出",
        Tin: "转入",
        ToBuy: "购买VIP会员权益",
        VipDuty: "VIP会员的职责",
        Rule: "用户只能在一个会话中进行涨或跌的交易，并且必须连续交易。每次交易的最低金额为$10。连胜或连败次数必须为9次。如果在同一个会话中有多个用户同时赢得大奖，奖金将平均分配给所有获奖用户。用户必须完成系统上的身份验证（KYC），才有资格参加此挑战。此外，每天将从当天赢得大奖的用户中随机选择一名，获得Mega奖（5倍奖金）。如果当天没有用户赢得大奖，则没有Mega奖。请注意，奖励将在约48小时内转入账户钱包。我们保留随时更改或修改平台上的条款和条件或任何政策/指南的权利，且无需另行通知。任何更改/修改将在更新信息发布后立即生效，或者通过电子邮件通知您。连续挑战计划及其福利完全由我们决定提供。我们保留修改或取消大奖以及如何评估和奖励合格交易的权利。如果发现任何用户通过欺诈或不诚实行为来获取额外奖励，我们有权撤销或终止其大奖资格。在此情况下，我们保留取消用户参与连续挑战计划或永久禁止其使用服务的权利，且不提前通知。我们的决定为最终决定，且不会就此问题进行任何争议",
        TradeandMakeProfit: "交易赚取",
        Prize: "奖品",
        YourHistory: "您的历史",
        PrizeReceiveHistory: "奖品领取历史",
        PrizeWinnerList: "奖品获奖者名单",
        ViewMoreInfo: "查看更多信息",
        TradeandWin: "交易赢取",
        ShowBollinger: "显示布林带",
        OpenOrder: "开放订单",
        CloseOrder: "关闭订单",
        Up: "上涨",
        Down: "下跌",
        NạptiềnBANK: "银行充值",
        NạptiềnUSDT: "USDT充值",
        Chuyểntiềntừvígiaodịchsangvíchính: "从交易钱包转到主钱包",
        Chuyểntiềntừvíchínhsangvígiaodịch: "从主钱包转到交易钱包",
        Last30days: "过去30天",
        Last7days: "过去7天",
        EnterUserName: "请输入用户名",
        TotalNewCommissions: "新佣金总额",
        New: "新",
        Week: "周",
        RejectedVerify: '拒绝验证',
        DevelopeSkill: "开发技能",
        StartFree: "免费开始",
        Saying: "PUTEX是一个领先的交易平台，结合了最新的创新和先进技术，为交易者提供最佳的交易体验。",
        IdealPlatform: "赚钱的理想平台",
        VipNotice: "成为VIP会员后的默认VIP等级是等级1。要升级VIP等级，您必须支付升级费用并拥有足够的F1购买VIP会员。每周日00:00:00（UTC），您升级的VIP等级将过期，您的新等级将根据过去7天内F1的每周交易量和F1购买的VIP会员数量更新。",
        YouHaveReachMaxLevel: "您已达到最大等级",
        AmountF1BuyVip: "F1购买VIP会员的金额",
        UpgradeCharge: "升级费用",
        Upgrade: "升级",
        ShowReferersByName: "按名称显示推荐人",
        ShowReferers: "按级别显示推荐人",
        SearchBy: "搜索",
        VipMemberManagement: "VIP会员管理",
        TotalCommissionTrades: "总佣金交易",
        PhoneNumber: "电话号码",
        Information: "信息",
        UpBranch: "上位分支",
        TotalOfVipMembers: "VIP会员总数",
        NoVipAuthorization: "没有VIP授权",
        TradeProfitDetail: "交易利润明细",
        ThisMonthReceived: "本月收到",
        Receive: "接收",
        TradingCommissionsChart: '交易佣金图表',
        CommissionNote: "每个新的一天，您将收到前一天下线的交易佣金。",
        VipMemberCommissions: "VIP会员佣金",
        Date: "日期",
        InputTransferAmount: '请输入转账金额',
        CreateBonaxAccount: '创建PUTEX账户',
        RequestNewEmail: "请求新邮件",
        NoConfirmationEmail: "未收到确认邮件?",
        InputRefererCode: "输入推荐码",
        InputNickname: "输入昵称",
        HaveAnAccount: '已有PUTEX账户？',
        NeedBonaxAccount: "需要PUTEX账户吗",
        ForgetPassword: "忘记密码",
        GoogleAuthInput: "输入Google身份验证代码",
        InputPassword: "输入密码",
        InputEmail: "输入电子邮件",
        LoginToYourAccount: '登录您的账户',
        Send: '发送',
        ApplySuccess: '申请成功',
        NextStep: '下一步',
        IdAndPassport: 'ID/护照号',
        InputName: '请输入姓名',
        InputName2: '请输入姓和中间名',
        TurnSettingOn: '打开此设置以隐藏您的帐户统计信息',
        Warn2FA: '提款和证券更新必需',
        CurrentPassword: '当前密码',
        Account: '帐户',
        Verified: '已验证',
        ChangeImage: '更改图片',
        Update: '更新',
        UploadImgNote: '上传的照片应不超过5MB*',
        UpLoadFromPc: '从PC上传',
        TradeSumary: '交易总结',
        TradeTurns: '交易回合',
        OTPfromTele: '来自Telegram应用的OTP代码',
        AccountName: '帐户名称',
        AmountOfMoneyLeft: '余额',
        WithdrawValue: '提款金额',
        WithdrawRequest: '提款请求',
        HideSensitiveContent: '隐藏敏感信息',
        TransferNote: '转账后，您可以进行交易。资产转移是免费的。',
        Transfer: '转账',
        CANCEL: '已取消',
        Status: '状态',
        VerifyNow: '立即验证',
        NewPassword: '新密码（至少6个字符）',
        ReceiveBank: '接收银行',
        WithdrawalBank: '提款银行',
        Sender_Receiver: '发件人/接收人',
        Size: '大小',
        VerifyIdentity: '身份验证:',
        YouChoose: '您选择',
        OwnerName: '所有者名称',
        TotalRoundWin: '总胜利回合数',
        TotalRoundDraw: '总平局回合数',
        TotalRoundLose: '总失败回合数',
        Get: '获得',
        Ensure: '为确保资产安全，请确保使用的区块链是BSC。',
        NetworkIsNoAvailable: '网络不可用，请选择另一个网络或货币。',
        HHAccepted: 'HH已接受',
        TotalKLGD: '总KLGD',
        All: '全部',
        CommissionType: '佣金类型',
        RecentDays: '最近几天',
        Yesterday: '昨天',
        From: '从',
        AccountNumber: '账户号码',
        ReceiveAdress: {
            "1": '输入',
            "2": '接收地址',
        },
        AccountType: '账户类型',
        Request: '请求',
        SideNote: '备注',
        Optional: '可选',
        Period: '期限',
        ChooseWallet: '选择钱包',
        SearchResults: '搜索结果',
        SeeWhoYouReferBy: '查看您推荐的人',
        ManagementAgent: '管理代理',
        MainWallet: '主钱包',
        TradeWallet: '交易钱包',
        MainAccount: '主账户',
        Sales: '销售',
        HideBalance: '隐藏余额',
        ReceiverNickname: '接收者昵称',
        FriendAccepted: '您的朋友已接受邀请，请完成注册和交易',
        NoData: '没有数据',
        Register: '注册',
        TradeId: '交易ID',
        ViewAll: '查看全部',
        TradeType: '交易类型',
        MinValue: '最小值',
        TransferSuccess: '转账成功',
        ReceiverNickname: '接收者昵称',
        YourRechargeAddress: {
            "1": '您的',
            "2": '充值地址',
        },
        Login: '登录',
        Charge: '充值',
        RequestSuccess: '请求成功',
        PlaceOrder: '下单',
        TotalReceive: '总接收',
        WaitingForResult: '等待结果',
        TransferInfo: {
            "Warn": '请准确转账',
            "ToAccount": '到账户',
            "Content": '内容',
            "Warning1": '注意：请输入正确的转账内容。错误将导致失败',
            "Warning2": '如果在转账10分钟内账户没有更新积分，请通过热线联系我们。',
        },
        DepositOn: '充值金额',
        NoNewNotifications: '没有新通知',
        TradingVolume: '交易量',
        NumberOfTransactions: '交易数量',
        TradingProfitDetails: '交易利润详情',
        LevelDiagram: '级别图',
        YouWillReceiveTradingCommissions: '您将立即收到来自下线的交易佣金。',
        Note: '备注',
        Notification: '通知',
        EmailAddress: '电子邮件地址',
        showBalance: '显示余额',
        Contact: '联系方式',
        Total: '总计',
        Month: '月',
        CommissionStatistics: '佣金统计',
        CommissionShare: '收到相应的佣金',
        CommissionEasy: '轻松收到佣金',
        TotalVolume: '7层的总交易量（按月）',
        LowerLevelTradingVolume: '下层交易量',
        TotalCommissions: '总佣金',
        New: '新的',
        Guide: '指南',
        Sound: '声音',
        RecentFigures: '最近的数字',
        LastMonth: '上个月',
        ThisMonth: '本月',
        VIPCommission: 'VIP佣金',
        TotalCommissions: '总佣金',
        TradingCommissions: '交易佣金',
        TotalNumberOfAgents: '总代理人数',
        TotalNumberOfTraders: '总交易员人数',
        Presenter: '呈现者',
        FriendRegistered: '朋友已注册',
        Agency: '代理',
        TotalThisWeek: '本周总计',
        Rank: '排名',
        Condition: '条件',
        YouSuccecced: '转账成功',
        To: '到',
        SystemManagement: '系统管理',
        Commission: '佣金',
        MakeMoney: '赚钱',
        Overview: '概述',
        LoadNow: '立即加载',
        YourBalanceIsInsufficient: '余额不足',
        TermsOfService: '服务条款',
        AcknowledgeAndAgree: '我同意并接受',
        YouNeedToPay: {
            "1": '要成为VIP会员，',
            "2": '您需要支付。是否继续？'
        },
        AcceptParticipation: '接受参与',
        BecomeAVip: '成为VIP',
        DisclaimerTheParty: '免责声明：上述第三方服务可用于购买可能用于Stake游戏的加密货币。通过注册他们的平台，您同意他们的条款，并且需要通过KYC过程。',
        Trade: '交易',
        Help: '帮助',
        Shopping: '购物',
        Setting: '设置',
        Add: '添加',
        Vip: 'VIP会员',
        Wallet: '钱包',
        Exchange: '兑换',
        Dashboard: '仪表板',
        TransferValue: '转账金额',
        Logout: '登出',
        Challenge: '挑战',
        Profile: '个人资料',
        Settings: '设置',
        Command: '命令',
        PENDING: '待处理',
        FINISH: '完成',
        QuickRecharge: '快速充值',
        Support: '支持',
        RealAccount: '真实账户',
        DemoAccount: '演示账户',
        Profit: '利润',
        OrderValue: '订单金额',
        Sentiment: '情绪指标',
        Buy: '购买',
        Sell: '出售',
        Bet: '投注',
        Internal: '内部',
        Recharge: '充值',
        Withdraw: '提款',
        BuyCrypto: '购买加密货币',
        Money: '钱',
        Network: '网络',
        MemberVip: '成为VIP会员，您可以获得VIP佣金和交易佣金',
        BuyNow: '立即购买',
        LinkRegister: '注册链接',
        Copy: '复制',
        ReferralCode: '推荐码',
        InviteFriend: '邀请朋友',
        InviteFriendRegister: '通过PUTEX注册链接邀请朋友',
        TotalAssets: '总资产（USD）',
        Reload: '重新加载',
        DepositComplaints: '充值投诉',
        Complain: '投诉',
        TransactionHistory: '交易历史',
        BOData: 'B.O.数据',
        TotalRound: '总回合数',
        WinRate: '胜率',
        TotalTransaction: '总交易数',
        NetProfit: '净利润',
        TotalRevenue: '总收入',
        Search: '搜索',
        Lang: '语言',
        Currency: '货币',
        ChangePassword: '更改密码',
        OldPassword: '旧密码',
        NewPassword: '新密码',
        EnterPassword: '输入密码',
        Enable2FA: '必须启用2FA以进行调整',
        NotOpen: '订单尚未开启',
        Open: '开启',
        Close: '关闭',
        DepositHistory: '充值历史',
        WithdrawHistory: '提款历史',
        ChangeAvatar: '更改头像',
        PersonalInformation: '个人信息',
        Nickname: '昵称',
        VerifyAccount: '验证账户',
        EnsureTheSafety: '为了确保资产安全，您需要进行身份验证，请准确填写信息。完成身份验证后，无法更改信息。',
        Confirm: '确认',
        AccountUnderReview: '账户正在审核中',
        AccountVerified: '账户已验证',
        Security: '安全',
        WantToChangePassword: '要更改密码吗？点击下方按钮更改。',
        RequiredToEnable2FA: '提款或更新安全性需要启用2FA。',
        Open2FA: '开启2FA',
        Change: '更改',
        Surname: '姓',
        Name: '名字',
        CardPassport: 'ID卡 / 护照号码',
        Nation: '国家',
        Next: '下一步',
        Back: '返回',
        Done: '完成',
        IdentityAuthentication: '身份验证',
        PleaseEnsureThePhoto1: '确保照片清晰完整，格式为JPG、PNG或JPEG。',
        PleaseEnsureThePhoto2: '请拍摄ID卡/护照的照片。照片应明亮且角度不缺。',
        FrontCard: 'ID卡/护照正面',
        BackCard: 'ID卡/护照背面',
        Consider: '考虑',
        ApplySuccess: '申请成功',
        ClickDoneToComplete: '请确认信息，7个工作日内完成审核。',
        YourAccountVerified: '您的账户已验证！',
        Asset: '资产',
        StartTime: '开始时间',
        Select: '选择',
        Selected: '已选择',
        OpenPrice: '开盘价',
        ClosingPrice: '收盘价',
        Value: '价值',
        Pay: '支付',
        Time: '时间',
        Type: '类型',
        Description: 'Txid/说明',
        Cryptocurrency: '加密货币',
        Address: '地址',
        GoogleAuthentication: 'Google认证',
        GoogleAuthenticationIsEnabled: 'Google认证已启用。要禁用，请输入Google认证代码并点击禁用。',
        OpenYourGoogleAuthentication: '打开Google认证应用，扫描下面的二维码或输入应用中的密钥。此密钥用于恢复Google认证，请在启用Google认证前备份此密钥。',
        BackupCode: '备份代码',
        Password: '密码',
        Verification: '验证',
        Code2FA: '2FA代码',
        SendCode: '发送代码',
        TurnOn: '开启',
        Deactivate: '禁用',
        AmountOfMoney: '金额',
        DepositAddress: '充值地址',
        Yours: '您的',
        SendOnly: '仅发送',
        ToThisAddress: '发送到此地址',
        ConfirmationsNeeded: '需要确认。',
        Max: '最大',
        BalanceAmount: '余额',
        MinimumWithdrawAmount: '最低提款金额为',
        TransactionProcessingFee: '交易处理费用',
        FromYourRemainingBalance: '将从您的余额中扣除。',
        DepositWithdraw: '使用网络进行存款提款交易',
        ClickToPay: "点击此处进行支付",
        MinValueWithdraw: "最低金额",
        NoteWithdraw: "输入您的备注",
        Require2FA: "您必须启用双重认证才能请求提现",
        ConfirmWithdraw: "确认提现",
        WithdrawAmount: "提现金额",
        WithdrawTime: "时间",
        WithdrawType: "提现类型",
        Input2FA: "输入您的双重认证代码",

        TradingIndicatorsBenefit: "交易指标帮助客户赚更多钱",
        PUTEXAdvancedIndicators: "PUTEX开发了高度先进且易于使用的指标，帮助交易者做出更好的交易决策",
        SmartTraining: "智能培训",
        EffectiveMoneyMaking: "发现最有效的赚钱方式",
        NewEarningOpportunities: "探索新的赚钱机会，从每日交易到通过交易佣金或VIP佣金获得被动收入",
        OurPlatform: "我们的平台",
        InnovativePlatform: "基于创新构建的平台",
        LatestTradingInnovations: "我们始终更新交易领域的最新创新，帮助每个人从PUTEX的交易中获利",
        StableSecure: "稳定且安全",
        ReferAndEarn: "推荐并赚钱",
        FastFree: "快速且免费",
        CustomerFeedback: "客户体验和反馈",
        UserFriendlyPlatform: "用户友好的交易平台",
        StreamlinedFeatures: "简化的功能，易于搜索和交易。直观的图表和全面的指标帮助我快速掌握趋势。对初学者和专业投资者来说都是一个绝佳选择。",
        HighSecurityTrading: "高安全性，放心交易",
        SecureCryptoTrading: "我一直担心加密货币交易的安全性，但这个平台让我完全放心。每笔交易都透明。我从未遇到任何安全问题。这是其他平台很少能达到的一大优势。",
        DedicatedSupport: "贴心的客户支持",
        ResponsiveSupportTeam: "让我印象深刻的是支持团队的快速响应。我的所有问题都在几分钟内得到解答。无论是关于存取款还是交易功能，他们都处理得非常专业。",
        QuickStartJourney: "几分钟内开始您的旅程",
        MultipleIncomeStreams: "今天就创建多个收入来源！",
        FAQ: "常见问题",
        VIPMemberObligations: "VIP会员义务",
        PrivacyPolicy: "隐私政策",
        TermsConditions: "条款和条件",
        RiskWarning: "风险警告",
        Disclaimer: "免责声明",
        UpdateNotifications: "接收更新通知",
        SubscribeUpdates: "注册以接收有关我们交易所和产品的更新和通知",
        Submit: "提交",
        EnterEmailAddress: "输入您的电子邮件地址"
    },
    ko: {
        NạptiềnTRANSFER: '전송',
        PROCESSING: '처리 중',
        Tout: "출금",
        Tin: "입금",
        ToBuy: "VIP 멤버십 구매",
        VipDuty: "VIP 멤버의 의무",
        Rule: "사용자는 하나의 세션에서 상승 또는 하락 거래만 할 수 있으며 연속적인 세션에서 거래를 해야 합니다. 세션당 최소 거래 금액은 $10이어야 합니다. 연승 또는 연패는 9회 연속이어야 합니다. 동일한 세션에서 여러 사용자가 잭팟에 당첨된 경우, 상금은 해당 시간의 모든 당첨자들에게 균등하게 나뉩니다. 이 도전에 참여하려면 시스템에서 신원 확인(KYC)을 완료해야 합니다. 또한, 매일 당일 잭팟에 당첨된 사용자 중 무작위로 선택된 사용자에게 5배 상금을 지급하는 메가 상이 수여됩니다. 당일 잭팟에 당첨된 사용자가 없으면 메가 상도 없습니다. 보상은 약 48시간 이내에 계정 지갑으로 지급됩니다.저희는 언제든지 플랫폼의 약관 또는 정책/지침의 정보를 변경/수정할 권리를 보유합니다. 변경/수정된 정보는 플랫폼에 게시된 즉시 또는 이메일로 알림을 받은 시점부터 즉시 효력을 발휘합니다.연속 도전 프로그램 및 그 혜택은 당사의 단독 재량에 따라 제공됩니다. 당사는 잭팟 상과 적격 거래를 평가하고 보상하는 방법을 수정하거나 취소할 권리를 보유합니다.프로그램을 통해 추가 보상을 받기 위해 부정 또는 비정직한 행위가 발견될 경우, 잭팟 상의 자격이 취소되거나 서비스 영구 이용이 금지될 수 있습니다. 이 경우, 사전 통보 없이 연속 도전 프로그램 참여 자격을 박탈할 권리를 보유합니다. 당사의 결정은 최종적이며, 이 문제와 관련하여 논쟁에 참여하지 않을 것입니다.",
        TradeandMakeProfit: "거래하여 수익",
        Prize: "상품",
        YourHistory: "귀하의 역사",
        PrizeReceiveHistory: "상품 수령 내역",
        PrizeWinnerList: "상품 수상자 목록",
        ViewMoreInfo: "자세한 정보보기",
        TradeandWin: "거래하여 승리하십시오",
        ShowBollinger: "볼린저 밴드 표시",
        OpenOrder: "주문 열기",
        CloseOrder: "주문 닫기",
        Up: "상승",
        Down: "하락",
        NạptiềnBANK: "은행 입금",
        NạptiềnUSDT: "USDT 입금",
        Chuyểntiềntừvígiaodịchsangvíchính: "거래 지갑에서 메인 지갑으로 송금",
        Chuyểntiềntừvíchínhsangvígiaodịch: "메인 지갑에서 거래 지갑으로 송금",
        Last30days: "지난 30일",
        Last7days: "지난 7일",
        EnterUserName: "사용자 이름 입력",
        TotalNewCommissions: "신규 수수료 총액",
        New: "새로운",
        Week: "주",
        RejectedVerify: '검증 거부',
        DevelopeSkill: "기술 개발",
        StartFree: "무료로 시작",
        Saying: "PUTEX는 최신 혁신과 선진 기술을 결합하여 트레이더에게 최상의 거래 경험을 제공하는 선도적인 거래 플랫폼입니다.",
        IdealPlatform: "이상적인 수익 플랫폼",
        VipNotice: "VIP 회원이 된 후 기본 VIP 레벨은 레벨 1입니다. VIP 레벨을 업그레이드하려면 업그레이드 비용을 지불하고 VIP 회원을 구매한 F1의 수가 필요합니다. 매주 일요일 00:00:00 (UTC)에 업그레이드된 VIP 레벨이 만료되며, 새로운 레벨은 지난 7일 동안의 F1의 주간 거래량과 VIP 회원을 구매한 F1에 따라 업데이트됩니다.",
        YouHaveReachMaxLevel: "최대 레벨에",
        AmountF1BuyVip: "F1 VIP 멤버쉽 구매 금액",
        UpgradeCharge: "업그레이드",
        Upgrade: "업그레이드",
        ShowReferersByName: "이름별 추천인 표시",
        ShowReferers: "레벨별 추천인 표시",
        SearchBy: "검색",
        VipMemberManagement: "VIP 회원 관리",
        TotalCommissionTrades: "총 수수료 거래",
        PhoneNumber: '전화 번호',
        Information: "정보",
        UpBranch: "상위 브랜치",
        TotalOfVipMembers: "VIP 회원 총 수",
        NoVipAuthorization: "VIP 권한 없음",
        TradeProfitDetail: "거래 수익 세부 정보",
        ThisMonthReceived: "이번 달 받기",
        Receive: "받다",
        TradingCommissionsChart: '거래 수수료 차트',
        CommissionNote: "매일 새로운 날마다 전날의 다운라인에서 거래 수수료를 받게 됩니다.",
        VipMemberCommissions: "VIP 회원 수수료",
        Date: "날짜",
        InputTransferAmount: '이체 금액 입력',
        CreateBonaxAccount: 'PUTEX 계정 만들기',
        RequestNewEmail: "새 이메일 요청",
        NoConfirmationEmail: "확인 이메일을 받지 못했습니다?",
        InputRefererCode: "추천 코드 입력",
        InputNickname: "닉네임 입력",
        HaveAnAccount: '이미 PUTEX 계정이 있습니까?',
        NeedBonaxAccount: "PUTEX 계정이 필요하십니까",
        ForgetPassword: "비밀번호를 잊으셨나요",
        GoogleAuthInput: "Google 인증 코드 입력",
        InputPassword: "비밀번호 입력",
        InputEmail: "이메일 입력",
        LoginToYourAccount: '귀하의 계정에 로그인하세요',
        Send: '보내다',
        ApplySuccess: '신청 성공',
        NextStep: '다음 단계',
        IdAndPassport: 'ID/여권 번호',
        InputName: '이름 입력',
        InputName2: '성 및 중간 이름 입력',
        TurnSettingOn: '계정 통계 숨기기를 위해 이 설정을 켭니다.',
        Warn2FA: '출금 및 증권 업데이트에 필수',
        CurrentPassword: '현재 비밀번호',
        Account: '계정',
        Verified: '인증됨',
        ChangeImage: '이미지 변경',
        Update: '업데이트',
        UploadImgNote: '업로드한 사진은 5MB 이하여야 합니다.',
        UpLoadFromPc: 'PC에서 업로드',
        TradeSumary: '거래 요약',
        TradeTurns: '거래 회전',
        OTPfromTele: '텔레그램 애플리케이션의 OTP 코드',
        AccountName: '계정 이름',
        AmountOfMoneyLeft: '남은 금액',
        WithdrawValue: '출금 금액',
        WithdrawRequest: '출금 요청',
        HideSensitiveContent: '민감한 데이터 숨기기',
        TransferNote: '자산이 해당 계정으로 전송되면 거래를 시작할 수 있습니다. 자산 전송은 무료입니다.',
        Transfer: '전송',
        CANCEL: '취소됨',
        Status: '상태',
        VerifyNow: '지금 인증하기',
        NewPassword: '새 비밀번호 (최소 6자)',
        ReceiveBank: '수취 은행',
        WithdrawalBank: '출금 은행',
        Sender_Receiver: '보낸 사람/받는 사람',
        Size: '크기',
        VerifyIdentity: '신원 인증:',
        YouChoose: '당신이 선택한',
        OwnerName: '소유자 이름',
        TotalRoundWin: '총 승리 라운드',
        TotalRoundDraw: '총 무승부 라운드',
        TotalRoundLose: '총 패배 라운드',
        Get: '받다',
        Ensure: "자산의 안전을 보장하기 위해 사용하려는 블록체인이 BSC인지 다시 확인하십시오.",
        NetworkIsNoAvailable: "네트워크가 이용할 수 없습니다. 다른 네트워크나 다른 통화를 선택하십시오.",
        HHAccepted: "HH 수락됨",
        TotalKLGD: "총 KLGD",
        All: "전체",
        CommissionType: "커미션 유형",
        RecentDays: "최근 일자",
        Yesterday: "어제",
        From: '보낸 사람',
        AccountNumber: '계좌 번호',
        ReceiveAdress: {
            "1": '입력',
            "2": '수신 주소',
        },
        AccountType: '계정 유형',
        Request: '요청',
        SideNote: '참고',
        Optional: '선택 사항',
        Period: "기간",
        ChooseWallet: '지갑 선택',
        SearchResults: "검색 결과",
        SeeWhoYouReferBy: "누가 당신을 추천했는지 보기",
        ManagementAgent: "관리 에이전트",
        MainWallet: '주 지갑',
        TradeWallet: '거래 지갑',
        MainAccount: '주 계좌',
        Sales: "판매",
        HideBalance: '잔액 숨기기',
        ReceiverNickname: '받는 사람 닉네임',
        FriendAccepted: '친구가 초대를 수락했습니다. 등록 및 거래를 완료하십시오.',
        NoData: "데이터 없음",
        Register: '등록',
        TradeId: "거래 ID",
        ViewAll: '모두 보기',
        TradeType: '거래 유형',
        MinValue: '최소 금액',
        TransferSuccess: '전송 성공',
        ReceiverNickname: '받는 사람 별명',
        YourRechargeAddress: {
            "1": "귀하의",
            "2": "충전 주소",
        },
        Login: '로그인',
        Charge: '충전',
        RequestSuccess: '요청 성공',
        PlaceOrder: '주문하기',
        TotalReceive: '총 수신',
        WaitingForResult: "결과를 기다리는 중",
        TransferInfo: {
            "Warn": '정확히 전송해 주세요',
            "ToAccount": "다음 계좌로 전송",
            "Content": '내용',
            "Warning1": "주의: 전송 내용을 정확히 입력하여 오류를 방지하십시오.",
            "Warning2": "전송 후 10분 이내에 포인트가 업데이트되지 않으면 핫라인을 통해 문의하십시오.",
        },
        DepositOn: "충전 금액",
        NoNewNotifications: "새로운 알림이 없습니다",
        TradingVolume: "거래량",
        NumberOfTransactions: "거래 건수",
        TradingProfitDetails: "거래 수익 상세",
        LevelDiagram: "레벨 다이어그램",
        YouWillReceiveTradingCommissions: "당신은 즉시 다운라인으로부터 거래 수수료를 받게 됩니다.",
        Note: "참고",
        Notification: '알림',
        EmailAddress: "이메일 주소",
        showBalance: "잔액 표시",
        Contact: "연락처",
        Total: "총",
        Month: "월",
        CommissionStatistics: '수수료 통계',
        CommissionShare: '상응하는 수수료 받기',
        CommissionEasy: '간편한 수수료 받기',
        TotalVolume: "7층 전체 거래량 (매월)",
        LowerLevelTradingVolume: "하위 레벨 거래량",
        TotalCommissions: "총 수수료",
        New: "새로",
        Guide: '가이드',
        Sound: '소리',
        RecentFigures: "최근 수치",
        LastMonth: "지난 달",
        ThisMonth: "이번 달",
        VIPCommission: "VIP 수수료",
        TotalCommissions: '총 수수료',
        TradingCommissions: "거래 수수료",
        TotalNumberOfAgents: "전체 에이전트 수",
        TotalNumberOfTraders: "전체 거래자 수",
        Presenter: "발표자",
        FriendRegistered: '친구가 등록되었습니다.',
        Agency: "대리점",
        TotalThisWeek: "총 (이번 주)",
        Rank: "순위",
        Condition: "조건",
        YouSuccecced: '성공적으로 전송했습니다.',
        To: '에',
        SystemManagement: "시스템 관리",
        Commission: "수수료",
        MakeMoney: "돈 벌기",
        Overview: "개요",
        LoadNow: "지금 로드",
        YourBalanceIsInsufficient: "잔액이 부족합니다.",
        TermsOfService: "서비스 약관",
        AcknowledgeAndAgree: "나는 동의합니다.",
        YouNeedToPay: {
            "1": 'VIP 회원이 되려면',
            "2": '지불해야 합니다. 계속하시겠습니까?'
        },
        AcceptParticipation: "참여 수락",
        BecomeAVip: "VIP 회원이 되기",
        DisclaimerTheParty: "면책 조항: 위의 제3자 서비스는 Stake에서 사용할 수 있는 암호화폐를 구매하는 데 사용될 수 있습니다. 해당 플랫폼에 등록하면 그들의 서비스 약관을 수락하며, 독립적인 KYC 절차를 통과해야 합니다.",
        Trade: "거래",
        Help: "도움말",
        Shopping: "쇼핑",
        Setting: "설정",
        Add: "추가",
        Vip: "VIP 회원",
        Wallet: "지갑",
        Exchange: "교환",
        Dashboard: "대시보드",
        TransferValue: '전송 금액',
        Logout: "로그아웃",
        Challenge: "도전",
        Profile: "프로필",
        Settings: "설정",
        Command: "명령",
        PENDING: '대기 중',
        FINISH: '완료',
        QuickRecharge: "빠른 충전",
        Support: "지원",
        RealAccount: "실제 계좌",
        DemoAccount: "데모 계좌",
        Profit: "수익",
        OrderValue: '주문 금액',
        Sentiment: "감정 지표",
        Buy: "구매",
        Sell: "판매",
        Bet: "배팅",
        Internal: '내부',
        Recharge: "충전",
        Withdraw: "출금",
        BuyCrypto: "암호화폐 구매",
        Money: "돈",
        Network: "네트워크",
        MemberVip: "VIP 회원이 되어야 VIP 수수료와 거래 수수료를 받습니다.",
        BuyNow: "지금 구매",
        LinkRegister: "등록 링크",
        Copy: "복사",
        ReferralCode: "추천 코드",
        InviteFriend: "친구 초대",
        InviteFriendRegister: "PUTEX 등록 링크를 통해 친구 초대",
        TotalAssets: "총 자산 (USD)",
        Reload: "새로 고침",
        DepositComplaints: "입금 불만",
        Complain: "불만",
        TransactionHistory: "거래 내역",
        BOData: "B.O. 데이터",
        TotalRound: "총 라운드",
        WinRate: "승률",
        TotalTransaction: "총 거래",
        NetProfit: "순수익",
        TotalRevenue: "총 수익",
        Search: "검색",
        Lang: "언어",
        Currency: "통화",
        ChangePassword: "비밀번호 변경",
        OldPassword: "현재 비밀번호",
        NewPassword: "새 비밀번호",
        EnterPassword: "비밀번호 입력",
        Enable2FA: "2FA를 활성화해야 조정할 수 있습니다.",
        NotOpen: "아직 열린 주문이 없습니다.",
        Open: "열기",
        Close: "닫기",
        DepositHistory: "입금 내역",
        WithdrawHistory: "출금 내역",
        ChangeAvatar: "아바타 변경",
        PersonalInformation: "개인 정보",
        Nickname: "닉네임",
        VerifyAccount: "계정 인증",
        EnsureTheSafety: "자산의 안전을 보장하기 위해 신원을 인증해야 합니다. 정보를 정확하게 입력해 주세요. 인증 후에는 정보가 수정되지 않습니다.",
        Confirm: "확인",
        AccountUnderReview: "계정 검토 중",
        AccountVerified: "계정 인증 완료",
        Security: "보안",
        WantToChangePassword: "비밀번호를 변경하시겠습니까? 아래 버튼을 클릭해 변경하십시오.",
        RequiredToEnable2FA: "출금이나 보안 업데이트를 위해 2FA를 활성화해야 합니다.",
        Open2FA: "2FA 활성화",
        Change: "변경",
        Surname: "성",
        Name: "이름",
        CardPassport: "ID 카드/여권 번호",
        Nation: "국가",
        Next: "다음",
        Back: "뒤로",
        Done: "완료",
        IdentityAuthentication: "신원 인증",
        PleaseEnsureThePhoto1: "사진이 완전하고 명확하며 JPG, PNG, JPEG 형식인지 확인하십시오.",
        PleaseEnsureThePhoto2: "ID/여권 사진을 찍어주세요. 사진은 밝고 명확해야 하며 각도가 잘못되지 않아야 합니다.",
        FrontCard: "ID 카드/여권 앞면",
        BackCard: "ID 카드/여권 뒷면",
        Consider: "고려",
        ApplySuccess: '신청 성공',
        ClickDoneToComplete: "우리는 귀하의 정보를 검토하고 7 영업일 이내에 인증을 완료할 것입니다!",
        YourAccountVerified: "귀하의 계정이 인증되었습니다!",
        Asset: "자산",
        StartTime: "시작 시간",
        Select: "선택",
        Selected: "선택됨",
        OpenPrice: "시가",
        ClosingPrice: "종가",
        Value: "값",
        Pay: "결제",
        Time: "시간",
        Type: "유형",
        Description: "Txid/설명",
        Cryptocurrency: "암호화폐",
        Address: "주소",
        GoogleAuthentication: "구글 인증",
        GoogleAuthenticationIsEnabled: "구글 인증이 활성화되었습니다. 비활성화하려면 구글 인증 코드를 입력하고 비활성화 버튼을 클릭하십시오.",
        OpenYourGoogleAuthentication: "구글 인증 앱을 열고 아래의 QR 코드를 스캔하거나 앱에 키를 입력하십시오. 이 키는 전화기를 변경하거나 잃어버렸을 때 구글 인증을 복원하는 데 사용됩니다. 구글 인증을 활성화하기 전에 이 키를 백업하십시오.",
        BackupCode: "백업 코드",
        Password: "비밀번호",
        Verification: "인증",
        Code2FA: "2FA 코드",
        SendCode: "코드 보내기",
        TurnOn: "켜기",
        Deactivate: "비활성화",
        AmountOfMoney: "금액",
        DepositAddress: "입금 주소",
        Yours: "귀하의",
        SendOnly: "보내기만",
        ToThisAddress: "이 주소로",
        ConfirmationsNeeded: "필요한 확인",
        Max: "최대",
        BalanceAmount: "잔액",
        MinimumWithdrawAmount: "최소 출금 금액은",
        TransactionProcessingFee: "거래 처리 수수료",
        FromYourRemainingBalance: "잔여 잔액에서 차감됩니다.",
        DepositWithdraw: '네트워크를 이용한 입금 출금 거래',
        ClickToPay: "여기를 클릭하여 결제를 진행하세요",
        MinValueWithdraw: "최소 금액",
        NoteWithdraw: "메모를 입력하세요",
        Require2FA: "출금 요청을 위해 2FA를 활성화해야 합니다",
        ConfirmWithdraw: "출금 확인",
        WithdrawAmount: "출금 금액",
        WithdrawTime: "시간",
        WithdrawType: "출금 유형",
        Input2FA: "2FA 코드를 입력하세요",

        TradingIndicatorsBenefit: "거래 지표는 고객이 더 많은 돈을 벌도록 돕습니다",
        PUTEXAdvancedIndicators: "PUTEX는 매우 진보되고 사용하기 쉬운 지표를 개발하여 거래자들이 더 나은 거래 결정을 내릴 수 있도록 돕습니다",
        SmartTraining: "스마트 트레이닝",
        EffectiveMoneyMaking: "가장 효과적인 돈 버는 방법을 찾아보세요",
        NewEarningOpportunities: "일일 거래부터 거래 수수료나 VIP 수수료로 얻는 수동적 수익까지, 새로운 돈 버는 기회를 탐색하세요",
        OurPlatform: "우리의 플랫폼",
        InnovativePlatform: "혁신을 기반으로 구축된 플랫폼",
        LatestTradingInnovations: "우리는 항상 거래 분야의 최신 혁신을 업데이트하여 모두가 PUTEX에서 거래로 수익을 얻을 수 있도록 돕습니다",
        StableSecure: "안정적이고 안전함",
        ReferAndEarn: "추천하고 돈을 벌어",
        FastFree: "빠르고 무료",
        CustomerFeedback: "고객 경험과 피드백",
        UserFriendlyPlatform: "사용자 친화적인 거래 플랫폼",
        StreamlinedFeatures: "간소화된 기능, 검색과 거래가 쉬움. 직관적인 차트와 포괄적인 지표로 트렌드를 빠르게 파악할 수 있습니다. 초보자와 전문 투자자 모두에게 훌륭한 선택입니다.",
        HighSecurityTrading: "높은 보안, 안심 거래",
        SecureCryptoTrading: "암호화폐 거래의 보안이 항상 걱정이었지만, 이 플랫폼은 저를 완전히 안심시켰습니다. 모든 거래가 투명합니다. 보안 문제를 한 번도 겪지 않았습니다. 다른 플랫폼이 달성하기 어려운 큰 장점입니다.",
        DedicatedSupport: "헌신적인 고객 지원",
        ResponsiveSupportTeam: "가장 인상 깊었던 점은 지원 팀의 빠른 응답입니다. 모든 질문이 몇 분 안에 답변됩니다. 입출금이나 거래 기능에 대한 질문이든, 매우 전문적으로 처리합니다.",
        QuickStartJourney: "몇 분 안에 여정을 시작하세요",
        MultipleIncomeStreams: "오늘부터 여러 수입원을 만드세요!",
        FAQ: "자주 묻는 질문",
        VIPMemberObligations: "VIP 회원 의무",
        PrivacyPolicy: "개인정보 보호정책",
        TermsConditions: "이용약관",
        RiskWarning: "위험 경고",
        Disclaimer: "면책 조항",
        UpdateNotifications: "업데이트 알림 수신",
        SubscribeUpdates: "우리 거래소 및 제품에 대한 업데이트와 알림을 받기 위해 가입하세요",
        Submit: "제출",
        EnterEmailAddress: "이메일 주소를 입력하세요"
    },
    th: {
        NạptiềnTRANSFER: 'โอน',
        PROCESSING: 'กำลังประมวลผล',
        Tout: "โอนออก",
        Tin: "โอนเข้า",
        ToBuy: "ซื้อสมาชิก VIP",
        VipDuty: "หน้าที่ของสมาชิก VIP",
        Rule: "ผู้ใช้สามารถทำการซื้อขายในลักษณะเพิ่มขึ้นหรือลดลงได้เพียงครั้งเดียวในหนึ่งเซสชัน และต้องทำการซื้อขายในเซสชันที่ต่อเนื่องกัน การซื้อขายแต่ละครั้งในเซสชันต้องมีมูลค่าขั้นต่ำ $10 และต้องมีการชนะติดต่อกันหรือแพ้ติดต่อกัน 9 ครั้ง ในกรณีที่มีผู้ใช้หลายคนชนะรางวัลแจ็คพอตในเซสชันเดียวกัน รางวัลจะถูกแบ่งเท่าๆ กันให้กับผู้ชนะทั้งหมดในช่วงเวลาดังกล่าว ผู้ใช้ต้องทำการยืนยันตัวตน (KYC) ผ่านระบบของเราเพื่อให้มีสิทธิ์เข้าร่วมกิจกรรมนี้ นอกจากนี้ ทุกวันจะมีรางวัล Mega ที่มีมูลค่า 5 เท่าของรางวัล ซึ่งจะสุ่มเลือกจากผู้ใช้ที่ชนะรางวัลแจ็คพอตในวันนั้น หากไม่มีผู้ใช้ชนะรางวัลแจ็คพอตในวันนั้น ก็จะไม่มีรางวัล Mega โปรดทราบว่ารางวัลจะถูกโอนเข้ากระเป๋าเงินในบัญชีของคุณภายในเวลาประมาณ 48 ชั่วโมงเราขอสงวนสิทธิ์ในการเปลี่ยนแปลง/แก้ไขข้อมูลในข้อกำหนดและเงื่อนไข หรือนโยบาย/แนวทางต่างๆ ของแพลตฟอร์มได้ทุกเมื่อ ตามดุลยพินิจของเรา การเปลี่ยนแปลง/แก้ไขใดๆ จะมีผลทันทีหลังจากข้อมูลใหม่ถูกเผยแพร่บนแพลตฟอร์ม หรือคุณได้รับการแจ้งเตือนผ่านทางอีเมลโปรแกรม Continuous Challenge และสิทธิประโยชน์ต่างๆ เป็นไปตามดุลยพินิจของเราแต่เพียงผู้เดียว เราขอสงวนสิทธิ์ในการแก้ไขหรือลบล้างรางวัลแจ็คพอต รวมถึงวิธีที่เราใช้ในการประเมินและมอบรางวัลสำหรับการซื้อขายที่มีคุณสมบัติครบถ้วนหากตรวจพบว่ามีการกระทำที่เป็นการฉ้อโกงหรือไม่ซื่อสัตย์ใดๆ เพื่อให้ได้รางวัลเพิ่มเติม เรามีสิทธิ์ยกเลิกสิทธิ์รับรางวัลแจ็คพอตของคุณ คุณจะถูกตัดสิทธิ์จากการเข้าร่วมโปรแกรม Continuous Challenge หรือต้องถูกแบนจากการใช้บริการของเราอย่างถาวรโดยไม่ต้องแจ้งล่วงหน้า การตัดสินใจของเราถือเป็นที่สิ้นสุด และเราจะไม่ร่วมอภิปรายเกี่ยวกับกรณีนี้",
        TradeandMakeProfit: "ซื้อขายและทำกำไร",
        Prize: "รางวัล",
        YourHistory: "ประวัติของคุณ",
        PrizeReceiveHistory: "ประวัติการรับรางวัล",
        PrizeWinnerList: "รายชื่อผู้โชคดี",
        ViewMoreInfo: "ดูข้อมูลเพิ่มเติม",
        TradeandWin: "ซื้อขายและชนะ",
        ShowBollinger: "แสดงแถบบอลลิงเจอร์",
        OpenOrder: "เปิดคำสั่ง",
        CloseOrder: "ปิดคำสั่ง",
        Up: "ขึ้น",
        Down: "ลง",
        NạptiềnBANK: "ฝากเงินผ่านธนาคาร",
        NạptiềnUSDT: "ฝากเงินผ่าน USDT",
        Chuyểntiềntừvígiaodịchsangvíchính: "โอนเงินจากกระเป๋าการซื้อขายไปยังกระเป๋าหลัก",
        Chuyểntiềntừvíchínhsangvígiaodịch: "โอนเงินจากกระเป๋าหลักไปยังกระเป๋าการซื้อขาย",
        Last30days: "30 วันที่ผ่านมา",
        Last7days: "7 วันที่ผ่านมา",
        EnterUserName: "ป้อนชื่อผู้ใช้",
        TotalNewCommissions: "คอมมิชชันใหม่ทั้งหมด",
        New: "ใหม่",
        Week: "สัปดาห์",
        RejectedVerify: 'การตรวจสอบถูกปฏิเสธ',
        DevelopeSkill: "พัฒนาทักษะ",
        StartFree: "เริ่มฟรี",
        Saying: "PUTEX เป็นแพลตฟอร์มการซื้อขายที่นำนวัตกรรมล่าสุดและเทคโนโลยีขั้นสูงมารวมกันเพื่อมอบประสบการณ์การซื้อขายที่ดีที่สุดให้กับผู้ค้า",
        IdealPlatform: "แพลตฟอร์มที่เหมาะสมในการสร้างรายได้",
        VipNotice: "ระดับ VIP เริ่มต้นของคุณหลังจากเป็นสมาชิก VIP คือระดับ 1 ในการอัปเกรดระดับ VIP คุณต้องจ่ายค่าธรรมเนียมการอัปเกรดและมีจำนวน F1 ที่ซื้อสมาชิก VIP เพียงพอ ทุกวันอาทิตย์เวลา 00:00:00 (UTC) ระดับ VIP ที่คุณอัปเกรดจะหมดอายุ ระดับใหม่ของคุณจะได้รับการอัปเดตตามปริมาณการซื้อขายรายสัปดาห์ของ F1 และจำนวนสมาชิก VIP ที่ซื้อโดย F1 ในช่วง 7 วันที่ผ่านมา",
        YouHaveReachMaxLevel: "คุณได้ระดับสูงสุดแล้ว",
        AmountF1BuyVip: "จำนวนเงินที่ใช้ในการซื้อสมาชิก VIP F1",
        UpgradeCharge: "อัพเกรด",
        Upgrade: "อัพเกรด",
        ShowReferersByName: "แสดงผู้แนะนำตามชื่อ",
        ShowReferers: "แสดงผู้แนะนำตามระดับ",
        SearchBy: "ค้นหาโดย",
        VipMemberManagement: "การจัดการสมาชิก VIP",
        TotalCommissionTrades: "รวมค่าคอมมิชชั่นการซื้อขาย",
        PhoneNumber: 'หมายเลขโทรศัพท์',
        Information: "ข้อมูล",
        UpBranch: "สาขาบน",
        TotalOfVipMembers: "จำนวนสมาชิก VIP ทั้งหมด",
        NoVipAuthorization: "ไม่มีสิทธิ์สมาชิก VIP",
        TradeProfitDetail: "รายละเอียดกำไรการซื้อขาย",
        ThisMonthReceived: "รับเดือนนี้",
        Receive: "รับ",
        TradingCommissionsChart: 'แผนภูมิค่าคอมมิชชั่นการซื้อขาย',
        CommissionNote: "ทุกวันใหม่ คุณจะได้รับค่าคอมมิชชั่นการซื้อขายจากสายงานของวันก่อนหน้า",
        VipMemberCommissions: "คอมมิชชันสมาชิก VIP",
        Date: "วันที่",
        InputTransferAmount: 'ป้อนจำนวนเงินที่โอน',
        CreateBonaxAccount: 'สร้างบัญชี PUTEX',
        RequestNewEmail: "ขออีเมลใหม่",
        NoConfirmationEmail: "ไม่ได้รับอีเมลยืนยัน?",
        InputRefererCode: "ป้อนรหัสผู้แนะนำ",
        InputNickname: "ป้อนชื่อเล่น",
        HaveAnAccount: 'มีบัญชี PUTEX อยู่แล้วหรือไม่?',
        NeedBonaxAccount: "ต้องมีบัญชี PUTEX",
        ForgetPassword: "ลืมรหัสผ่าน",
        GoogleAuthInput: "ป้อนรหัส Google Authenticator",
        InputPassword: "ป้อนรหัสผ่าน",
        InputEmail: "ป้อนอีเมล",
        LoginToYourAccount: 'เข้าสู่ระบบบัญชีของคุณ',
        Send: 'ส่ง',
        ApplySuccess: 'สมัครสำเร็จ',
        NextStep: 'ขั้นตอนถัดไป',
        IdAndPassport: 'หมายเลขบัตรประชาชน/หนังสือเดินทาง',
        InputName: 'กรอกชื่อ',
        InputName2: 'กรอกนามสกุลและชื่อกลาง',
        TurnSettingOn: 'เปิดการตั้งค่าซ่อนสถิติตัวเลือกบัญชี',
        Warn2FA: 'จำเป็นสำหรับการถอนและการอัพเดตความปลอดภัย',
        CurrentPassword: 'รหัสผ่านปัจจุบัน',
        Account: 'บัญชี',
        Verified: 'ได้รับการยืนยัน',
        ChangeImage: 'เปลี่ยนรูปภาพ',
        Update: 'อัพเดต',
        UploadImgNote: 'ไฟล์ที่อัพโหลดต้องมีขนาดไม่เกิน 5MB',
        UpLoadFromPc: 'อัพโหลดจากคอมพิวเตอร์',
        TradeSumary: 'สรุปการซื้อขาย',
        TradeTurns: 'จำนวนการหมุน',
        OTPfromTele: 'รหัส OTP จากแอปพลิเคชัน Telegram',
        AccountName: 'ชื่อบัญชี',
        AmountOfMoneyLeft: 'ยอดเงินคงเหลือ',
        WithdrawValue: 'จำนวนเงินที่ถอน',
        WithdrawRequest: 'คำขอถอนเงิน',
        HideSensitiveContent: 'ซ่อนข้อมูลที่ละเอียดอ่อน',
        TransferNote: 'เมื่อโอนสินทรัพย์ไปยังบัญชีนี้ คุณสามารถเริ่มต้นการซื้อขายได้ การโอนสินทรัพย์ฟรี',
        Transfer: 'โอน',
        CANCEL: 'ยกเลิก',
        Status: 'สถานะ',
        VerifyNow: 'ยืนยันตอนนี้',
        NewPassword: 'รหัสผ่านใหม่ (อย่างน้อย 6 ตัวอักษร)',
        ReceiveBank: 'ธนาคารที่รับเงิน',
        WithdrawalBank: 'ธนาคารถอนเงิน',
        Sender_Receiver: 'ผู้ส่ง/ผู้รับ',
        Size: 'ขนาด',
        VerifyIdentity: 'การยืนยันตัวตน:',
        YouChoose: 'ตัวเลือกของคุณ',
        OwnerName: 'ชื่อเจ้าของ',
        TotalRoundWin: 'จำนวนรอบที่ชนะทั้งหมด',
        TotalRoundDraw: 'จำนวนรอบที่เสมอทั้งหมด',
        TotalRoundLose: 'จำนวนรอบที่แพ้ทั้งหมด',
        Get: 'รับ',
        Ensure: "โปรดตรวจสอบให้แน่ใจว่าเครือข่ายที่คุณเลือกคือ BSC ก่อนที่จะใช้ในการโอนสินทรัพย์เพื่อความปลอดภัย",
        NetworkIsNoAvailable: "เครือข่ายไม่สามารถใช้งานได้ กรุณาเลือกเครือข่ายหรือสกุลเงินอื่น",
        HHAccepted: "HH ได้รับการยอมรับ",
        TotalKLGD: "จำนวน KLGD รวม",
        All: "ทั้งหมด",
        CommissionType: "ประเภทค่าคอมมิชชั่น",
        RecentDays: "ในช่วงหลายวันมานี้",
        Yesterday: "เมื่อวาน",
        From: 'จาก',
        AccountNumber: 'หมายเลขบัญชี',
        ReceiveAdress: {
            "1": 'กรอก',
            "2": 'ที่อยู่สำหรับรับ',
        },
        AccountType: 'ประเภทบัญชี',
        Request: 'คำขอ',
        SideNote: 'หมายเหตุ',
        Optional: 'ตัวเลือก',
        Period: "ระยะเวลา",
        ChooseWallet: 'เลือกกระเป๋าสตางค์',
        SearchResults: "ผลการค้นหา",
        SeeWhoYouReferBy: "ดูว่าใครแนะนำคุณ",
        ManagementAgent: "ตัวแทนการจัดการ",
        MainWallet: 'กระเป๋าหลัก',
        TradeWallet: 'กระเป๋าแลกเปลี่ยน',
        MainAccount: 'บัญชีหลัก',
        Sales: "การขาย",
        HideBalance: 'ซ่อนยอดเงิน',
        ReceiverNickname: 'ชื่อเล่นผู้รับ',
        FriendAccepted: 'เพื่อนของคุณยอมรับการเชิญ กรุณาลงทะเบียนและทำการซื้อขายให้เสร็จสมบูรณ์',
        NoData: "ไม่มีข้อมูล",
        Register: 'ลงทะเบียน',
        TradeId: "หมายเลขการซื้อขาย",
        ViewAll: 'ดูทั้งหมด',
        TradeType: 'ประเภทการซื้อขาย',
        MinValue: 'มูลค่าต่ำสุด',
        TransferSuccess: 'โอนสำเร็จ',
        ReceiverNickname: 'ชื่อเล่นผู้รับ',
        YourRechargeAddress: {
            "1": "ที่อยู่",
            "2": "สำหรับการเติมเงินของคุณ",
        },
        Login: 'เข้าสู่ระบบ',
        Charge: 'เติมเงิน',
        RequestSuccess: 'คำขอสำเร็จ',
        PlaceOrder: 'สั่งซื้อ',
        TotalReceive: 'รวมที่ได้รับ',
        WaitingForResult: "รอผลลัพธ์",
        TransferInfo: {
            "Warn": 'กรุณาโอนให้ถูกต้อง',
            "ToAccount": "โอนให้กับบัญชีนี้",
            "Content": 'รายละเอียด',
            "Warning1": "คำเตือน: กรุณากรอกรายละเอียดการโอนอย่างถูกต้องเพื่อหลีกเลี่ยงความผิดพลาด",
            "Warning2": "หากยอดเงินไม่ได้อัปเดตภายใน 10 นาทีหลังจากการโอน กรุณาติดต่อฝ่ายสนับสนุน",
        },
        DepositOn: "จำนวนเงินที่ฝาก",
        NoNewNotifications: "ไม่มีการแจ้งเตือนใหม่",
        TradingVolume: "ปริมาณการซื้อขาย",
        NumberOfTransactions: "จำนวนธุรกรรม",
        TradingProfitDetails: "รายละเอียดกำไรการซื้อขาย",
        LevelDiagram: "แผนภูมิระดับ",
        YouWillReceiveTradingCommissions: "คุณจะได้รับค่าคอมมิชชั่นจากการซื้อขายจากสมาชิกในสายงานของคุณทันที",
        Note: "หมายเหตุ",
        Notification: 'การแจ้งเตือน',
        EmailAddress: "ที่อยู่อีเมล",
        showBalance: "แสดงยอดเงิน",
        Contact: "ติดต่อ",
        Total: "ทั้งหมด",
        Month: "เดือน",
        CommissionStatistics: 'สถิติค่าคอมมิชชั่น',
        CommissionShare: 'รับค่าคอมมิชชั่นตามที่เหมาะสม',
        CommissionEasy: 'รับค่าคอมมิชชั่นง่ายๆ',
        TotalVolume: "ปริมาณการซื้อขายทั้งหมด (รายเดือน)",
        LowerLevelTradingVolume: "ปริมาณการซื้อขายในระดับต่ำกว่า",
        TotalCommissions: "ค่าคอมมิชชั่นรวม",
        New: "ใหม่",
        Guide: 'คู่มือ',
        Sound: 'เสียง',
        RecentFigures: "ตัวเลขล่าสุด",
        LastMonth: "เดือนที่แล้ว",
        ThisMonth: "เดือนนี้",
        VIPCommission: "ค่าคอมมิชชั่น VIP",
        TotalCommissions: 'ค่าคอมมิชชั่นทั้งหมด',
        TradingCommissions: "ค่าคอมมิชชั่นการซื้อขาย",
        TotalNumberOfAgents: "จำนวนตัวแทนทั้งหมด",
        TotalNumberOfTraders: "จำนวนเทรดเดอร์ทั้งหมด",
        Presenter: "ผู้เสนอ",
        FriendRegistered: 'เพื่อนลงทะเบียนแล้ว',
        Agency: "ตัวแทน",
        TotalThisWeek: "ทั้งหมด (สัปดาห์นี้)",
        Rank: "อันดับ",
        Condition: "เงื่อนไข",
        YouSuccecced: 'โอนสำเร็จ',
        To: 'ไปที่',
        SystemManagement: "การจัดการระบบ",
        Commission: "ค่าคอมมิชชั่น",
        MakeMoney: "ทำเงิน",
        Overview: "ภาพรวม",
        LoadNow: "โหลดเดี๋ยวนี้",
        YourBalanceIsInsufficient: "ยอดเงินของคุณไม่เพียงพอ",
        TermsOfService: "ข้อกำหนดการให้บริการ",
        AcknowledgeAndAgree: "ฉันยอมรับและเห็นด้วย",
        YouNeedToPay: {
            "1": 'เพื่อเป็นสมาชิก VIP',
            "2": 'คุณต้องชำระเงินต่อไปนี้, คุณต้องการดำเนินการต่อหรือไม่?'
        },
        AcceptParticipation: "ยอมรับการเข้าร่วม",
        BecomeAVip: "กลายเป็นสมาชิก VIP",
        DisclaimerTheParty: "ข้อจำกัดความรับผิด: บริการจากบุคคลที่สามดังกล่าวสามารถใช้ในการซื้อสกุลเงินดิจิตอลที่สามารถใช้ใน Stake ได้ เมื่อคุณลงทะเบียนในแพลตฟอร์มนี้ คุณยอมรับข้อกำหนดการให้บริการของพวกเขา และต้องผ่านกระบวนการ KYC แยกต่างหาก",
        Trade: "การซื้อขาย",
        Help: "ความช่วยเหลือ",
        Shopping: "ช้อปปิ้ง",
        Setting: "การตั้งค่า",
        Add: "เพิ่ม",
        Vip: "สมาชิก VIP",
        Wallet: "กระเป๋าสตางค์",
        Exchange: "แลกเปลี่ยน",
        Dashboard: "แดชบอร์ด",
        TransferValue: 'มูลค่าการโอน',
        Logout: "ออกจากระบบ",
        Challenge: "ความท้าทาย",
        Profile: "โปรไฟล์",
        Settings: "การตั้งค่า",
        Command: "คำสั่ง",
        PENDING: 'รอดำเนินการ',
        FINISH: 'เสร็จสิ้น',
        QuickRecharge: "เติมเงินด่วน",
        Support: "การสนับสนุน",
        RealAccount: "บัญชีจริง",
        DemoAccount: "บัญชีทดลอง",
        Profit: "กำไร",
        OrderValue: 'มูลค่าคำสั่งซื้อ',
        Sentiment: "ดัชนีอารมณ์",
        Buy: "ซื้อ",
        Sell: "ขาย",
        Bet: "เดิมพัน",
        Internal: 'ภายใน',
        Recharge: "เติมเงิน",
        Withdraw: "ถอนเงิน",
        BuyCrypto: "ซื้อคริปโต",
        Money: "เงิน",
        Network: "เครือข่าย",
        MemberVip: "คุณต้องเป็นสมาชิก VIP เพื่อรับค่าคอมมิชชั่น VIP และค่าคอมมิชชั่นการซื้อขาย",
        BuyNow: "ซื้อเดี๋ยวนี้",
        LinkRegister: "ลิงค์การลงทะเบียน",
        Copy: "คัดลอก",
        ReferralCode: "รหัสแนะนำ",
        InviteFriend: "เชิญเพื่อน",
        InviteFriendRegister: "เชิญเพื่อนผ่านลิงค์การลงทะเบียน PUTEX",
        TotalAssets: "มูลค่าสินทรัพย์รวม (USD)",
        Reload: "โหลดใหม่",
        DepositComplaints: "ข้อร้องเรียนการฝากเงิน",
        Complain: "ร้องเรียน",
        TransactionHistory: "ประวัติการทำธุรกรรม",
        BOData: "ข้อมูล B.O.",
        TotalRound: "จำนวนรอบทั้งหมด",
        WinRate: "อัตราการชนะ",
        TotalTransaction: "จำนวนธุรกรรมทั้งหมด",
        NetProfit: "กำไรสุทธิ",
        TotalRevenue: "รายได้รวม",
        Search: "ค้นหา",
        Lang: "ภาษา",
        Currency: "สกุลเงิน",
        ChangePassword: "เปลี่ยนรหัสผ่าน",
        OldPassword: "รหัสผ่านเดิม",
        NewPassword: "รหัสผ่านใหม่",
        EnterPassword: "กรอกรหัสผ่าน",
        Enable2FA: "คุณต้องเปิด 2FA เพื่อปรับการตั้งค่า",
        NotOpen: "คุณยังไม่มีคำสั่งซื้อที่เปิดอยู่",
        Open: "เปิด",
        Close: "ปิด",
        DepositHistory: "ประวัติการฝากเงิน",
        WithdrawHistory: "ประวัติการถอนเงิน",
        ChangeAvatar: "เปลี่ยนภาพโปรไฟล์",
        PersonalInformation: "ข้อมูลส่วนตัว",
        Nickname: "ชื่อเล่น",
        VerifyAccount: "ยืนยันบัญชี",
        EnsureTheSafety: "เพื่อความปลอดภัยของสินทรัพย์ของคุณ โปรดยืนยันตัวตนของคุณให้ครบถ้วน ข้อมูลที่กรอกจะไม่สามารถแก้ไขได้หลังจากผ่านการตรวจสอบแล้ว",
        Confirm: "ยืนยัน",
        AccountUnderReview: "บัญชีอยู่ระหว่างการตรวจสอบ",
        AccountVerified: "บัญชีได้รับการยืนยัน",
        Security: "ความปลอดภัย",
        WantToChangePassword: "คุณต้องการเปลี่ยนรหัสผ่านไหม? คลิกที่ปุ่มด้านล่างเพื่อเปลี่ยน",
        RequiredToEnable2FA: "ต้องเปิด 2FA เพื่อถอนเงินหรืออัปเดตความปลอดภัย",
        Open2FA: "เปิด 2FA",
        Change: "เปลี่ยน",
        Surname: "นามสกุล",
        Name: "ชื่อ",
        CardPassport: "หมายเลขบัตรประชาชน/หนังสือเดินทาง",
        Nation: "ประเทศ",
        Next: "ถัดไป",
        Back: "ย้อนกลับ",
        Done: "เสร็จสิ้น",
        IdentityAuthentication: "การตรวจสอบตัวตน",
        PleaseEnsureThePhoto1: "โปรดตรวจสอบให้แน่ใจว่าภาพที่ถ่ายชัดเจนและสมบูรณ์ในรูปแบบ JPG, PNG, JPEG",
        PleaseEnsureThePhoto2: "ถ่ายภาพบัตรประชาชนหรือหนังสือเดินทางของคุณ ภาพต้องมีความสว่างและชัดเจน ไม่มีมุมหายไป",
        FrontCard: "ด้านหน้า ID/หนังสือเดินทาง",
        BackCard: "ด้านหลัง ID/หนังสือเดินทาง",
        Consider: "พิจารณา",
        ApplySuccess: 'สมัครสำเร็จ',
        ClickDoneToComplete: "เราจะตรวจสอบข้อมูลของคุณและดำเนินการยืนยันภายใน 7 วันทำการ!",
        YourAccountVerified: "บัญชีของคุณได้รับการยืนยันแล้ว!",
        Asset: "สินทรัพย์",
        StartTime: "เวลาเริ่มต้น",
        Select: "เลือก",
        Selected: "เลือกแล้ว",
        OpenPrice: "ราคาเปิด",
        ClosingPrice: "ราคาปิด",
        Value: "มูลค่า",
        Pay: "ชำระ",
        Time: "เวลา",
        Type: "ประเภท",
        Description: "รายละเอียด Txid",
        Cryptocurrency: "สกุลเงินดิจิทัล",
        Address: "ที่อยู่",
        GoogleAuthentication: "การยืนยันตัวตน Google",
        GoogleAuthenticationIsEnabled: "Google Authenticator เปิดใช้งานแล้ว หากต้องการปิดใช้งาน ให้กรอกรหัสจาก Google Authenticator และคลิกที่ปิดการใช้งาน",
        OpenYourGoogleAuthentication: "เปิดแอป Google Authenticator ของคุณ และสแกน QR code ด้านล่าง หรือใส่รหัสเข้าแอป กรุณาสำรองรหัสนี้ก่อนเปิดใช้งาน Google Authenticator",
        BackupCode: "รหัสสำรอง",
        Password: "รหัสผ่าน",
        Verification: "การตรวจสอบ",
        Code2FA: "รหัส 2FA",
        SendCode: "ส่งรหัส",
        TurnOn: "เปิดใช้งาน",
        Deactivate: "ปิดการใช้งาน",
        AmountOfMoney: "จำนวนเงิน",
        DepositAddress: "ที่อยู่สำหรับฝาก",
        Yours: "ของคุณ",
        SendOnly: "ส่งเท่านั้น",
        ToThisAddress: "ไปยังที่อยู่นี้",
        ConfirmationsNeeded: "จำนวนการยืนยันที่ต้องการ",
        Max: "สูงสุด",
        BalanceAmount: "ยอดคงเหลือ",
        MinimumWithdrawAmount: "จำนวนการถอนขั้นต่ำคือ",
        TransactionProcessingFee: "ค่าธรรมเนียมการประมวลผลธุรกรรม",
        FromYourRemainingBalance: "จะหักจากยอดเงินคงเหลือของคุณ",
        DepositWithdraw: 'ธุรกรรมฝากถอนโดยใช้เครือข่าย',
        ClickToPay: "คลิกที่นี่เพื่อดำเนินการชำระเงิน",
        MinValueWithdraw: "จำนวนขั้นต่ำ",
        NoteWithdraw: "ป้อนบันทึกของคุณ",
        Require2FA: "คุณต้องเปิดใช้งาน 2FA เพื่อขอถอนเงิน",
        ConfirmWithdraw: "ยืนยันการถอนเงิน",
        WithdrawAmount: "จำนวนเงินที่ถอน",
        WithdrawTime: "เวลา",
        WithdrawType: "ประเภทการถอน",
        Input2FA: "ป้อนรหัส 2FA ของคุณ",
        TradingIndicatorsBenefit: "ตัวบ่งชี้การซื้อขายช่วยให้ลูกค้าสร้างรายได้มากขึ้น",
        PUTEXAdvancedIndicators: "PUTEX พัฒนาตัวบ่งชี้ที่ล้ำสมัยและใช้งานง่ายเพื่อช่วยให้เทรดเดอร์ตัดสินใจซื้อขายได้ดีขึ้น",
        SmartTraining: "การฝึกอบรมอัจฉริยะ",
        EffectiveMoneyMaking: "ค้นพบวิธีที่มีประสิทธิภาพที่สุดในการสร้างรายได้",
        NewEarningOpportunities: "สำรวจโอกาสสร้างรายได้ใหม่ ๆ ตั้งแต่การซื้อขายรายวันไปจนถึงการรับรายได้แบบพาสซีฟจากค่าคอมมิชชันการซื้อขายหรือค่าคอมมิชชัน VIP",
        OurPlatform: "แพลตฟอร์มของเรา",
        InnovativePlatform: "แพลตฟอร์มที่สร้างขึ้นจากนวัตกรรม",
        LatestTradingInnovations: "เราอัปเดตนวัตกรรมล่าสุดในวงการซื้อขายอยู่เสมอเพื่อช่วยให้ทุกคนสามารถทำกำไรจากการซื้อขายบน PUTEX",
        StableSecure: "มั่นคงและปลอดภัย",
        ReferAndEarn: "แนะนำและสร้างรายได้",
        FastFree: "รวดเร็วและฟรี",
        CustomerFeedback: "ประสบการณ์และความคิดเห็นของลูกค้า",
        UserFriendlyPlatform: "แพลตฟอร์มการซื้อขายที่เป็นมิตรกับผู้ใช้",
        StreamlinedFeatures: "ฟีเจอร์ที่ได้รับการปรับปรุงให้ใช้งานง่าย ค้นหาและซื้อขายได้สะดวก กราฟที่เข้าใจง่ายพร้อมตัวบ่งชี้ครบถ้วนช่วยให้ฉันจับเทรนด์ได้อย่างรวดเร็ว เป็นตัวเลือกที่ยอดเยี่ยมสำหรับทั้งมือใหม่และนักลงทุนมืออาชีพ",
        HighSecurityTrading: "ความปลอดภัยสูง มั่นใจในการซื้อขาย",
        SecureCryptoTrading: "ฉันกังวลเรื่องความปลอดภัยในการซื้อขายคริปโตมาโดยตลอด แต่แพลตฟอร์มนี้ทำให้ฉันวางใจได้อย่างสมบูรณ์ ทุกการซื้อขายโปร่งใส ฉันไม่เคยเจอปัญหาด้านความปลอดภัยเลย นี่คือข้อดีใหญ่ที่แพลตฟอร์มอื่นทำได้ยาก",
        DedicatedSupport: "การสนับสนุนลูกค้าด้วยความใส่ใจ",
        ResponsiveSupportTeam: "สิ่งที่ทำให้ฉันประทับใจคือทีมสนับสนุนที่ตอบกลับอย่างรวดเร็ว คำถามทุกข้อของฉันได้รับคำตอบภายในไม่กี่นาที ไม่ว่าจะเป็นเรื่องการฝากถอนหรือฟีเจอร์การซื้อขาย พวกเขาจัดการอย่างมืออาชีพ",
        QuickStartJourney: "เริ่มต้นการเดินทางของคุณในไม่กี่นาที",
        MultipleIncomeStreams: "สร้างแหล่งรายได้หลายทางได้ตั้งแต่วันนี้!",
        FAQ: "คำถามที่พบบ่อย",
        VIPMemberObligations: "ภาระผูกพันของสมาชิก VIP",
        PrivacyPolicy: "นโยบายความเป็นส่วนตัว",
        TermsConditions: "ข้อกำหนดและเงื่อนไข",
        RiskWarning: "คำเตือนความเสี่ยง",
        Disclaimer: "ข้อจำกัดความรับผิดชอบ",
        UpdateNotifications: "รับการแจ้งเตือนการอัปเดต",
        SubscribeUpdates: "สมัครเพื่อรับการอัปเดตและการแจ้งเตือนเกี่ยวกับการแลกเปลี่ยนและผลิตภัณฑ์ของเรา",
        Submit: "ส่ง",
        EnterEmailAddress: "ป้อนที่อยู่อีเมลของคุณ"
    },
    km: {
        PROCESSING: 'កំពុងដំណើរការ',
        NạptiềnTRANSFER: 'ការផ្ទេរប្រើប្រាស់',
        Tout: "ផ្ទេរចេញ",
        Tin: "ផ្ទេរចូល",
        ToBuy: "ទិញ VIP",
        VipDuty: "តើអ្នកចង់ជ្រើសរើសជាសមាជិក VIP ឬទេ?",
        Rule: "អ្នកប្រើប្រាស់អាចធ្វើការជួញដូរបង្កើនឬបន្ថយបានក្នុងសម័យប្រើប្រាស់តែមួយ និងត្រូវធ្វើការជួញដូរបន្តជាបន្តបន្ទាប់។ ការជួញដូរក្នុងសម័យប្រើប្រាស់ត្រូវមានតម្លៃអប្បបរមា $10 និងស៊ួចយោគឺជាបន្តបន្តគឺ 9 ដង។ នៅក្នុងករណីដែលមានអ្នកប្រើប្រាស់ជាច្រើនឈ្នះរង្វាន់ Jackpot ក្នុងសម័យប្រើប្រាស់តែមួយនោះ រង្វាន់នឹងត្រូវចែកស្មើគ្នាទៅកាន់អ្នកឈ្នះទាំងអស់។ អ្នកប្រើប្រាស់ត្រូវបញ្ចប់ការបញ្ជាក់អត្តសញ្ញាណ (KYC) នៅលើប្រព័ន្ធរបស់យើង ដើម្បីមានលក្ខណៈសម្បត្តិចូលរួមការប្រកួតនេះ។ លើសពីនេះ ការប្រកួតមួយៗមានរង្វាន់ Mega 5 ដង ដែលនឹងត្រូវជ្រើសរើសដោយចៃដន្យចេញពីអ្នកប្រើប្រាស់ដែលឈ្នះរង្វាន់ Jackpot ក្នុងថ្ងៃបច្ចុប្បន្ន។ ប្រសិនបើគ្មានអ្នកឈ្នះរង្វាន់ Jackpot ក្នុងថ្ងៃបច្ចុប្បន្ន នោះរង្វាន់ Mega នឹងមិនមានឡើយ។ សូមបញ្ជាក់ថា រង្វាន់នឹងត្រូវចេញទៅកាន់កាបូបស្ពាយរបស់គណនីរបស់អ្នកក្នុងរយៈពេលប្រមាណ 48 ម៉ោង។យើងសម្រេចប្តូរឬកែសម្រួលព័ត៌មានណាមួយក្នុងលក្ខខណ្ឌនិងលក្ខខណ្ឌ ឬគោលនយោបាយណាមួយបានតាមតែការសម្រេចចិត្តរបស់យើង។ ការផ្លាស់ប្តូរឬកែសម្រួលនឹងមានប្រសិទ្ធភាពភ្លាមៗបន្ទាប់ពីបានប្រកាសលើវេទិការបស់យើង ឬអ្នកបានទទួលការជូនដំណឹងតាមអ៊ីមែល។កម្មវិធី Continuous Challenge និងអត្ថប្រយោជន៍ដែលផ្ដល់ដោយយើងត្រូវបានបកស្រាយតាមការសម្រេចចិត្តរបស់យើង។ យើងមានសិទ្ធិកែប្រែឬលុបចោលរង្វាន់ Jackpot ដោយស្ថិតលើការវាយតម្លៃលើការជួញដូររបស់អ្នក។ក្នុងករណីដែលមានការបង្កើតល្បែងដែលមានភាពអនីតិជន ឬអសុចរិតសំរាប់ទទួលសិទ្ធិលើការប្រកួត នោះអ្នកនឹងត្រូវដកសិទ្ធិឬកាត់ចេញពីកម្មវិធីនេះដោយគ្មានការជូនដំណឹងមុន។ ការសម្រេចចិត្តរបស់យើងគឺជាការសម្រេចចុងក្រោយ ហើយយើងនឹងមិនចូលរួមជជែកនូវបញ្ហានេះឡើយ។",
        TradeandMakeProfit: "ជួញដូរ និង រកប្រាក់",
        Prize: "រង្វាន់",
        YourHistory: "ប្រវត្តិរត់របស់អ្នក",
        PrizeReceiveHistory: "ប្រវត្តិរត់ប្រាក់ជារង្វាន់",
        PrizeWinnerList: "បញ្ជីអ្នកឈ្មោះជាអ្នកជំនួញ",
        ViewMoreInfo: "មើលព័ត៌មានបន្ថែម",
        TradeandWin: "ជួញដូរ និង ឈ្មោះ",
        ShowBollinger: "បង្ហាញ Bollinger",
        OpenOrder: "ការបញ្ជាទិញដែលមិនបានបើក",
        ClosedOrder: "ការបញ្ជាទិញដែលបានបើក",
        Up: "ឡើង",
        Down: "ចុះ",
        NạptiềnBANK: "ផ្ទេរប្រាក់ (USDT)",
        NạptiềnUSDT: "ផ្ទេរប្រាក់ (USDT)",
        Chuyểntiềntừvígiaodịchsangvíchính: "ផ្ទេរប្រាក់ពីកាបូបជួញដូរទៅកាបូបចម្បង",
        Chuyểntiềntừvíchínhsangvígiaodịch: "ផ្ទេរប្រាក់ពីកាបូបចម្បងទៅកាបូបជួញដូរ",
        Last30days: "ខែនេះ",
        Last7days: "ថ្ងៃនេះ",
        EnterUserName: "បញ្ចូលឈ្មោះអ្នកប្រើ",
        TotalNewCommissions: "កម្រិតកម្រិតថ្មី",
        New: "ថ្មី",
        Week: "សប្តាហ៍",
        RejectedVerify: "ការបញ្ជាក់ត្រូវបានបដិសេធ",
        DevelopeSkill: "អភិវឌ្ឍបង្កើតជំនាញ",
        StartFree: "ចាប់ផ្តើមដោយឥតគិតថ្លៃ",
        Saying: "PUTEX គឺជាវេទិកាជួញដូរឈានមុខគេនៅលើពិភពលោក ដែលរួមបញ្ចូលនូវការច្នៃប្រឌិតថ្មីៗជាមួយនឹងបច្ចេកវិទ្យាទំនើប ដើម្បីផ្តល់នូវបទពិសោធន៍ជួញដូរល្អបំផុតសម្រាប់អ្នកជួញដូរ",
        IdealPlatform: "ប្រព័ន្ធដ៏ល្អបំផុតសម្រាប់ការជួញដូរ",
        VipNotice: "កម្រិត VIP លំនាំដើមរបស់អ្នកបន្ទាប់ពីក្លាយជាសមាជិក VIP គឺកម្រិត 1។ ដើម្បីអាចធ្វើឱ្យប្រសើរកម្រិត VIP អ្នកត្រូវបង់ថ្លៃធ្វើឱ្យប្រសើរនិងមានចំនួន F1 គ្រប់គ្រាន់ដែលបានទិញសមាជិក VIP នៅម៉ោង 00:00:00 (UTC) ថ្ងៃអាទិត្យរៀងសប្តាហ៍ កម្រិត VIP ដែលអ្នកបានធ្វើឱ្យប្រសើរនឹងផុតកំណត់ កម្រិតថ្មីរបស់អ្នកនឹងត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយផ្អែកលើបរិមាណពាណិជ្ជកម្មប្រចាំសប្តាហ៍របស់ F1 និង F1 ដែលបានទិញចំនួនសមាជិក VIP ក្នុងរយៈពេល 7 ថ្ងៃកន្លងមក។",
        YouHaveReachMaxLevel: "អ្នកបានដាក់ស្នើកម្រិតអតិបរមាហើយ",
        AmountF1BuyVip: "ចំនួនទិញសមាជិក VIP",
        UpgradeCharge: "ធ្វើឱ្យប្រសើរ",
        Upgrade: "ធ្វើឱ្យប្រសើរ",
        ShowReferers: "បង្ហាញអ្នកណែនាំតាមកម្រិត",
        ShowReferersByName: "បង្ហាញអ្នកណែនាំតាមឈ្មោះ",
        SearchBy: "ស្វែងរកតាម",
        VipMemberManagement: "ការគ្រប់គ្រងសមាជិក VIP",
        TotalCommissionTrades: "ការជួញដូរកម្រៃសរុប",
        PhoneNumber: 'លេខទូរសព្ទ',
        Information: "ព័ត៌មាន",
        UpBranch: "សាខាលើ",
        TotalOfVipMembers: "សមាជិក VIP សរុប",
        NoVipAuthorization: "គ្មានសិទ្ធិសមាជិក VIP",
        TradeProfitDetail: "ព័ត៌មានលម្អិតនៃការជួញដូរ",
        ThisMonthReceived: "ទទួលខែនេះ",
        Receive: "ទទួល",
        TradingCommissionChart: "គំនូសតាងកម្រៃជួញដូរ",
        CommissionNote: "រាល់ថ្ងៃថ្មី អ្នកនឹងទទួលបានកម្រៃជួញដូរពីសមាជិកក្នុងប្រព័ន្ធរបស់អ្នកនៅថ្ងៃមុន។",
        VipMemberCommissions: "កម្រិតកម្មវិធីសម្រាប់សមាជិក VIP",
        Date: "កាលបរិច្ឆេទ",
        InputTransferAmount: 'បញ្ចូលចំនួនទិញដូរ',
        CreateBonaxAccount: 'បង្កើតគណនី PUTEX',
        RequestNewEmail: "ស្នើសុំអ៊ីមែលថ្មី",
        NoConfirmationEmail: "មិនបានទទួលអ៊ីមែលបញ្ជាក់?",
        InputRefererCode: "បញ្ចូលកូដអ្នកណែនាំ",
        InputNickname: "បញ្ចូលឈ្មោះលេង",
        HaveAnAccount: 'មានគណនី PUTEX រួចហើយឬទេ?',
        NeedBonaxAccount: "ត្រូវការគណនី PUTEX",
        ForgetPassword: "ភ្លេចពាក្យសម្ងាត់",
        GoogleAuthInput: "បញ្ចូលកូដ Google Authenticator",
        InputPassword: "បញ្ចូលពាក្យសម្ងាត់",
        InputEmail: "បញ្ចូលអ៊ីមែល",
        LoginToYourAccount: 'ចូលទៅគណនីរបស់អ្នក។',
        Send: 'ផ្ញើ',
        ApplySuccess: 'ការដាក់ពាក្យបានជោគជ័យ',
        NextStep: 'ជំហានបន្ទាប់',
        IdAndPassport: 'លេខអត្តសញ្ញាណប័ណ្ណ/ពន្ធបើកលិខិតធ្វើដំណើរ',
        InputName: 'បញ្ចូលឈ្មោះ',
        InputName2: 'បញ្ចូលឈ្មោះក្រុមហ៊ុន និងឈ្មោះមធ្យម',
        TurnSettingOn: 'បើកការកំណត់របស់ជម្រើសគណនីលាក់ស្ថិតិ',
        Warn2FA: 'ត្រូវការសម្រាប់ការដកប្រាក់ និងការអាប់ដេតសុវត្ថិភាព',
        CurrentPassword: 'ពាក្យសម្ងាត់បច្ចុប្បន្ន',
        Account: 'គណនី',
        Verified: 'បានផ្ទៀងផ្ទាត់',
        ChangeImage: 'ប្តូរូបភាព',
        Update: 'ធ្វើបច្ចុប្បន្នភាព',
        UploadImgNote: 'ឯកសារដែលផ្ទុកឡើងមិនគួរតែមានទំហំលើសពី 5MB',
        UpLoadFromPc: 'ផ្ទុកឡើងពីកុំព្យូទ័រ',
        TradeSumary: 'សង្ខេបការជួញដូរ',
        TradeTurns: 'ចំនួនការបង្វិល',
        OTPfromTele: 'កូដ OTP ពីកម្មវិធី Telegram',
        AccountName: 'ឈ្មោះគណនី',
        AmountOfMoneyLeft: 'ចំនួនប្រាក់សល់',
        WithdrawValue: 'ចំនួនប្រាក់ដែលដក',
        WithdrawRequest: 'សំណើដកប្រាក់',
        HideSensitiveContent: 'លាក់មាតិកាដែលមានការពិចារណា',
        TransferNote: 'ពេលដែលបញ្ជូនទ្រព្យសកម្មទៅកាន់គណនីនេះ អ្នកអាចចាប់ផ្តើមការជួញដូរ បាន ការបញ្ជូនទ្រព្យសកម្មគឺឥតគិតថ្លៃ',
        Transfer: 'បញ្ជូន',
        CANCEL: 'បានបោះបង់',
        Status: 'ស្ថានភាព',
        VerifyNow: 'ផ្ទៀងផ្ទាត់ឥឡូវនេះ',
        NewPassword: 'ពាក្យសម្ងាត់ថ្មី (យ៉ាងហោចណាស់ 6 តួអក្សរ)',
        ReceiveBank: 'ធនាគារដែលទទួលប្រាក់',
        WithdrawalBank: 'ធនាគារដែលដកប្រាក់',
        Sender_Receiver: 'អ្នកផ្ញើ/អ្នកទទួល',
        Size: 'ទំហំ',
        VerifyIdentity: 'ការផ្ទៀងផ្ទាត់អត្តសញ្ញាណ:',
        YouChoose: 'ជម្រើសរបស់អ្នក',
        OwnerName: 'ឈ្មោះម្ចាស់',
        TotalRoundWin: 'ចំនួនជួរ​ដែលឈ្នះសរុប',
        TotalRoundDraw: 'ចំនួនជួរ​ដែលត្រូវបានតែងតាម',
        TotalRoundLose: 'ចំនួនជួរ​ដែលបាត់បង់សរុប',
        Get: 'ទទួលបាន',
        Ensure: "សូមប្រាកដថាបណ្តាញដែលអ្នកជ្រើសគឺ BSC មុនពេលប្រើសម្រាប់ការបញ្ជូនទ្រព្យសកម្មដើម្បីសុវត្ថិភាព",
        NetworkIsNoAvailable: "បណ្តាញមិនអាចប្រើបាន សូមជ្រើសបណ្តាញឬប្រាក់សព្វផ្សេងទៀត",
        HHAccepted: "HH បានទទួលការយល់ព្រម",
        TotalKLGD: "ចំនួន KLGD សរុប",
        All: "ទាំងអស់",
        CommissionType: "ប្រភេទកម្រៃជម្រះ",
        RecentDays: "ក្នុងរយៈពេលចុងក្រោយ",
        Yesterday: "ម្សិលមិញ",
        From: 'ពី',
        AccountNumber: 'លេខគណនី',
        ReceiveAdress: {
            "1": 'បញ្ចូល',
            "2": 'អាសយដ្ឋានសម្រាប់ទទួល',
        },
        AccountType: 'ប្រភេទគណនី',
        Request: 'សំណើ',
        SideNote: 'កតិ្តសម្គាល់',
        Optional: 'ជម្រើស',
        Period: "រយៈពេល",
        ChooseWallet: 'ជ្រើសកាបូប',
        SearchResults: "លទ្ធផលស្វែងរក",
        SeeWhoYouReferBy: "មើលថាតើអ្នកណាបានយល់ព្រមចំពោះអ្នក",
        ManagementAgent: "ភ្នាក់ងារគ្រប់គ្រង",
        MainWallet: 'កាបូបចម្បង',
        TradeWallet: 'កាបូបជួញដូរ',
        MainAccount: 'គណនីចម្បង',
        Sales: "ការលក់",
        HideBalance: 'លាក់សមតុល្យ',
        ReceiverNickname: 'ឈ្មោះលេងអ្នកទទួល',
        FriendAccepted: 'មិត្តរបស់អ្នកបានទទួលការអញ្ជើញ សូមចុះបញ្ជី និងធ្វើការជួញដូរ',
        NoData: "គ្មានទិន្នន័យ",
        Register: 'ចុះបញ្ជី',
        TradeId: "លេខអត្តសញ្ញាណការជួញដូរ",
        ViewAll: 'មើលទាំងអស់',
        TradeType: 'ប្រភេទការជួញដូរ',
        MinValue: 'តម្លៃអប្បបរមា',
        TransferSuccess: 'ការបញ្ជូនបានជោគជ័យ',
        ReceiverNickname: 'ឈ្មោះលេងអ្នកទទួល',
        YourRechargeAddress: {
            "1": "អាសយដ្ឋាន",
            "2": "សម្រាប់ការបំពេញប្រាក់របស់អ្នក",
        },
        Login: 'ចូលទៅក្នុងគណនី',
        Charge: 'បញ្ចូលប្រាក់',
        RequestSuccess: 'សំណើបានជោគជ័យ',
        PlaceOrder: 'ដាក់ពាក្យបញ្ជា',
        TotalReceive: 'សរុបដែលទទួលបាន',
        WaitingForResult: "កំពុងរង់ចាំលទ្ធផល",
        TransferInfo: {
            "Warn": 'សូមបញ្ជូនឲ្យត្រឹមត្រូវ',
            "ToAccount": "បញ្ជូនទៅគណនីនេះ",
            "Content": 'អត្ថបទ',
            "Warning1": "ការព្រមាន: សូមបញ្ចូលព័ត៌មានលម្អិតការបញ្ជូនឲ្យត្រឹមត្រូវដើម្បីជៀសវាងកំហុស",
            "Warning2": "ប្រសិនបើยอดเงินមិនទាន់កើនឡើងក្នុងរយៈពេល 10 នាទីក្រោយការបញ្ជូន សូមទំនាក់ទំនងជាមួយក្រុមគាំទ្រ",
        },
        DepositOn: "จำนวนเงินที่ฝาก",
        NoNewNotifications: "គ្មានការជូនដំណឹងថ្មី",
        TradingVolume: "បរិមាណការជួញដូរ",
        NumberOfTransactions: "ចំនួនប្រតិបត្តិការ",
        TradingProfitDetails: "ព័ត៌មានលម្អិតអំពីប្រាក់កម្រៃជួញដូរ",
        LevelDiagram: "រៀបចំតាមកម្រិត",
        YouWillReceiveTradingCommissions: "អ្នកនឹងទទួលបានកម្រៃជួញដូរពីសមាជិកក្នុងប្រព័ន្ធរបស់អ្នក",
        Note: "កត់សម្គាល់",
        Notification: 'ការជូនដំណឹង',
        EmailAddress: "អាសយដ្ឋានអ៊ីមែល",
        showBalance: "បង្ហាញសមតុល្យ",
        Contact: "ទំនាក់ទំនង",
        Total: "សរុប",
        Month: "ខែ",
        CommissionStatistics: 'ស្ថិតិអំពីកម្រៃជម្រះ',
        CommissionShare: 'ទទួលកម្រៃការជួញដូរដោយសមរម្យ',
        CommissionEasy: 'ទទួលកម្រៃជួញដូរយ៉ាងងាយស្រួល',
        TotalVolume: "បរិមាណជួញដូរទាំងអស់",
        LowerLevelTradingVolume: "បរិមាណជួញដូរប្រចាំកម្រិតទាប",
        TotalCommissions: "សរុបកម្រៃ",
        New: "ថ្មី",
        Guide: 'คู่มือ',
        Sound: 'សំឡេង',
        RecentFigures: "លេខសំរាប់ពេលវេលាចុងក្រោយ",
        LastMonth: "ខែមុន",
        CommissionHistory: "ប្រវត្តិការកំណត់ទំនាក់ទំនង",
        CheckBalance: "ត្រួតពិនិត្យប balances",
        LastMonth: "ខែមុន",
        ThisMonth: "ខែនេះ",
        VIPCommission: "កម្រៃជម្រះ VIP",
        TotalCommissions: 'កម្រៃសរុប',
        TradingCommissions: "កម្រៃជួញដូរ",
        TotalNumberOfAgents: "ចំនួនភ្នាក់ងារសរុប",
        TotalNumberOfTraders: "ចំនួនអ្នកជួញដូរសរុប",
        Presenter: "អ្នកណែនាំ",
        FriendRegistered: 'មិត្តបានចុះបញ្ជី',
        Agency: "ភ្នាក់ងារ",
        TotalThisWeek: "សរុប (សប្តាហ៍នេះ)",
        Rank: "តម្លៃ",
        Condition: "លក្ខខណ្ឌ",
        YouSuccecced: 'អ្នកបានបញ្ជូនជោគជ័យ',
        To: 'ទៅកាន់',
        SystemManagement: "ការគ្រប់គ្រងប្រព័ន្ធ",
        Commission: "កម្រៃ",
        MakeMoney: "រកប្រាក់",
        Overview: "ទិដ្ឋភាពទូទៅ",
        LoadNow: "បញ្ចូលឥឡូវនេះ",
        YourBalanceIsInsufficient: "សមតុល្យរបស់អ្នកមិនគ្រប់គ្រាន់ទេ",
        TermsOfService: "លក្ខខណ្ឌសេវាកម្ម",
        AcknowledgeAndAgree: "ខ្ញុំយល់ព្រម និងទទួលយក",
        YouNeedToPay: {
            "1": 'អ្នកត្រូវបង់ប្រាក់',
            "2": 'ដើម្បីក្លាយជាសមាជិក VIP។ តើអ្នកចង់បន្តដែរឬទេ?',
        },
        AcceptParticipation: "ទទួលការចូលរួម",
        BecomeAVip: "ក្លាយជាសមាជិក VIP",
        DisclaimerTheParty: "ការបដិសេធ: សេវាកម្មភាគីទីបីខាងលើអាចត្រូវបានប្រើដើម្បីទិញគ្រប់គ្រងជួញដូរ។ ដោយការចុះបញ្ជីលើវេទិកាដែលពួកគេបានផ្ដល់ឲ្យអ្នកបានទទួលយល់ព្រមក្នុងលក្ខខណ្ឌសេវាកម្មរបស់ពួកគេ និងត្រូវបានតម្រូវឲ្យបញ្ជាក់សម្គាល់អត្តសញ្ញាណ",
        Trade: "ការជួញដូរ",
        Help: "ជំនួយ",
        Shopping: "ទិញទំនិញ",
        Setting: "ការកំណត់",
        Add: "បន្ថែម",
        Vip: "សមាជិក VIP",
        Wallet: "កាបូប",
        Exchange: "ការប្ដូរ",
        Dashboard: "ផ្ទាំងគ្រប់គ្រង",
        TransferValue: 'តម្លៃបញ្ជូន',
        Logout: "ចាកចេញ",
        Challenge: "ការប្រកួត",
        Profile: "ពត៌មានអ្នកប្រើ",
        Settings: "ការកំណត់",
        Command: "បញ្ជា",
        PENDING: 'រំពឹងទុក',
        FINISH: 'បញ្ចប់',
        QuickRecharge: "បញ្ចូលប្រាក់ប្រញាប់",
        Support: "គាំទ្រ",
        RealAccount: "គណនីពិត",
        DemoAccount: "គណនីសាកល្បង",
        Profit: "ប្រាក់ចំណេញ",
        OrderValue: 'តម្លៃពាក្យបញ្ជា',
        Sentiment: "ការបង្ហាញអារម្មណ៍",
        Buy: "ទិញ",
        Sell: "លក់",
        Bet: "ដាក់ប្រាក់",
        Internal: 'ខាងក្នុង',
        Recharge: "បញ្ចូលប្រាក់",
        Withdraw: "ដកប្រាក់",
        BuyCrypto: "ទិញករណីក្រមព្រះអាទិត្យ",
        Money: "ប្រាក់",
        Network: "បណ្តាញ",
        MemberVip: "អ្នកត្រូវតែជាសមាជិក VIP ដើម្បីទទួលបានកម្រៃជួញដូរ និងកម្រៃពាណិជ្ជកម្ម",
        BuyNow: "ទិញឥឡូវនេះ",
        LinkRegister: "តំណតំណរ ចុះបញ្ជី",
        Copy: "ចម្លង",
        ReferralCode: "កូដណែនាំ",
        InviteFriend: "អញ្ជើញមិត្ត",
        InviteFriendRegister: "អញ្ជើញមិត្តតាមតំណភ្ជាប់ចុះបញ្ជី PUTEX",
        TotalAssets: "ទ្រព្យសកម្មសរុប (USD)",
        Reload: "បញ្ចូលឡើងវិញ",
        DepositComplaints: "ការជំទាស់បញ្ចូលប្រាក់",
        Complain: "ការទន្ទឹង",
        TransactionHistory: "ប្រវត្តិប្រតិបត្តិការ",
        BOData: "ទិន្នន័យ BO",
        TotalRound: "ការប្រកួតសរុប",
        WinRate: "អត្រាជើងឈ្នះ",
        TotalTransaction: "ប្រតិបត្តិការសរុប",
        NetProfit: "ប្រាក់ចំណេញសុទ្ធ",
        TotalRevenue: "ប្រាក់ចំណូលសរុប",
        Search: "ស្វែងរក",
        Lang: "ភាសា",
        Currency: "រូបិយប័ណ្ណ",
        ChangePassword: "ប្តូរពាក្យសម្ងាត់",
        OldPassword: "ពាក្យសម្ងាត់ចាស់",
        NewPassword: "ពាក្យសម្ងាត់ថ្មី",
        EnterPassword: "បញ្ចូលពាក្យសម្ងាត់",
        Enable2FA: "ត្រូវបើក 2FA ដើម្បីកំណត់",
        NotOpen: "អ្នកមិនទាន់មានការបញ្ជូនបញ្ជីទេ",
        Open: "បើក",
        Close: "បិទ",
        DepositHistory: "ប្រវត្តិការបញ្ចូលប្រាក់",
        WithdrawHistory: "ប្រវត្តិការដកប្រាក់",
        ChangeAvatar: "ប្តូរូបភាពមុខ",
        PersonalInformation: "ព័ត៌មានផ្ទាល់ខ្លួន",
        Nickname: "ឈ្មោះលេង",
        VerifyAccount: "ផ្ទៀងផ្ទាត់គណនី",
        EnsureTheSafety: "ដើម្បីធានាសុវត្ថិភាពរបស់អ្នក។",
        Confirm: "បញ្ជាក់",
        AccountUnderReview: "គណនីកំពុងពិនិត្យ",
        AccountVerified: "គណនីបានផ្ទៀងផ្ទាត់",
        Security: "សុវត្ថិភាព",
        WantToChangePassword: "តើអ្នកចង់ប្ដូរពាក្យសម្ងាត់របស់អ្នកទេ?",
        RequiredToEnable2FA: "ត្រូវការបើក 2FA ដើម្បីដកប្រាក់ឬធ្វើការអាប់ដេតសុវត្ថិភាព។",
        Open2FA: "បើក 2FA",
        Change: "ប្តូរ",
        Surname: "ត្រកូល",
        Name: "ឈ្មោះ",
        CardPassport: "លេខអត្តសញ្ញាណប័ណ្ណ / លិខិតធ្វើដំណើរ",
        Nation: "ប្រទេស",
        Next: "បន្ទាប់",
        Back: "ត្រឡប់",
        Done: "បញ្ចប់",
        IdentityAuthentication: "ការផ្ទៀងផ្ទាត់អត្តសញ្ញាណ",
        PleaseEnsureThePhoto1: "សូមធានាថាបញ្ចូលរូបភាពជាមួយអត្ថបទ JPG, PNG, JPEG",
        PleaseEnsureThePhoto2: "យករូបភាពអត្តសញ្ញាណប័ណ្ណ/លិខិតធ្វើដំណើររបស់អ្នក។",
        FrontCard: "ផ្នែកមុខនៃកាតអត្តសញ្ញាណ/លិខិតធ្វើដំណើរ",
        BackCard: "ផ្នែកក្រោយនៃកាតអត្តសញ្ញាណ/លិខិតធ្វើដំណើរ",
        Consider: "ពិចារណា",
        ApplySuccess: 'ការដាក់ពាក្យបានជោគជ័យ',
        ClickDoneToComplete: "យើងនឹងពិនិត្យព័ត៌មានរបស់អ្នក ហើយបញ្ចប់ការផ្ទៀងផ្ទាត់ក្នុងរយៈពេល 7 ថ្ងៃធ្វើការ",
        YourAccountVerified: "គណនីរបស់អ្នកត្រូវបានផ្ទៀងផ្ទាត់ហើយ!",
        Asset: "ទ្រព្យសកម្ម",
        StartTime: "ម៉ោងចាប់ផ្តើម",
        Select: "ជ្រើស",
        Selected: "បានជ្រើស",
        OpenPrice: "តម្លៃបើក",
        ClosingPrice: "តម្លៃបិទ",
        Value: "តម្លៃ",
        Pay: "បង់",
        Time: "ម៉ោង",
        Type: "ប្រភេទ",
        Description: "Txid/ការពិពណ៌នា",
        Cryptocurrency: "កាក់ក្រដាសឌីជីថល",
        Address: "អាសយដ្ឋាន",
        GoogleAuthentication: "ការផ្ទៀងផ្ទាត់ Google",
        GoogleAuthenticationIsEnabled: "Google Authenticator ត្រូវបានបើក",
        OpenYourGoogleAuthentication: "បើកកម្មវិធី Google Authenticator របស់អ្នក",
        BackupCode: "កូដបម្រើ",
        Password: "ពាក្យសម្ងាត់",
        Verification: "ការផ្ទៀងផ្ទាត់",
        Code2FA: "កូដ 2FA",
        SendCode: "ផ្ញើកូដ",
        TurnOn: "បើក",
        Deactivate: "បិទ",
        AmountOfMoney: "ចំនួនប្រាក់",
        DepositAddress: "អាសយដ្ឋានបញ្ចូលប្រាក់",
        Yours: "របស់អ្នក",
        SendOnly: "ផ្ញើតែប៉ុណ្ណោះ",
        ToThisAddress: "ទៅកាន់អាសយដ្ឋាននេះ",
        ConfirmationsNeeded: "តម្រូវការបញ្ជាក់",
        Max: "អតិបរមា",
        BalanceAmount: "ចំនួនសមតុល្យ",
        MinimumWithdrawAmount: "ចំនួនដកប្រាក់អប្បបរមា",
        TransactionProcessingFee: "កម្រៃការប្រតិបត្តិការ",
        FromYourRemainingBalance: "នឹងត្រូវបានដកចេញពីសមតុល្យនៅសល់របស់អ្នក",
        DepositWithdraw: 'ប្រតិបត្តិការដកប្រាក់ដាក់ប្រាក់ដោយប្រើបណ្តាញ',
        ClickToPay: "ចុចទីនេះដើម្បីបន្តការទូទាត់",
        MinValueWithdraw: "ចំនួនទឹកប្រាក់អប្បបរមា",
        NoteWithdraw: "បញ្ចូលកំណត់សម្គាល់របស់អ្នក",
        Require2FA: "អ្នកត្រូវបើក 2FA ដើម្បីស្នើសុំការដកប្រាក់",
        ConfirmWithdraw: "បញ្ជាក់ការដកប្រាក់",
        WithdrawAmount: "ចំនួនទឹកប្រាក់ដក",
        WithdrawTime: "ពេលវេលា",
        WithdrawType: "ប្រភេទនៃការដក",
        Input2FA: "បញ្ចូលកូដ 2FA របស់អ្នក",

        TradingIndicatorsBenefit: "សូចនាករពាណិជ្ជកម្មជួយអតិថិជនរកប្រាក់បានច្រើនជាងមុន",
        PUTEXAdvancedIndicators: "PUTEX បង្កើតសូចនាករដែលទំនើបខ្លាំង និងងាយស្រួលប្រើ ដើម្បីជួយអ្នកជួញដូរធ្វើការសម្រេចចិត្តកាន់តែប្រសើរក្នុងការជួញដូរ",
        SmartTraining: "ការបណ្តុះបណ្តាលឆ្លាតវៃ",
        EffectiveMoneyMaking: "ស្វែងរកវិធីដែលមានប្រសិទ្ធភាពបំផុតដើម្បីរកប្រាក់",
        NewEarningOpportunities: "ស្វែងរកឱកាសរកប្រាក់ថ្មីៗ ចាប់ពីការជួញដូរប្រចាំថ្ងៃ រហូតដល់ការទទួលប្រាក់ចំណូលអកម្មពីកម្រៃជួញដូរ ឬកម្រៃ VIP",
        OurPlatform: "វេទិការបស់យើង",
        InnovativePlatform: "វេទិកាដែលបង្កើតឡើងដោយនវានុវត្តន៍",
        LatestTradingInnovations: "យើងតែងតែធ្វើបច្ចុប្បន្នភាពនវានុវត្តន៍ចុងក្រោយបំផុតក្នុងវិស័យជួញដូរ ដើម្បីជួយឱ្យមនុស្សគ្រប់គ្នាអាចរកប្រាក់ចំណេញពីការជួញដូរនៅលើ PUTEX",
        StableSecure: "ស្ថិរភាព និងសុវត្ថិភាព",
        ReferAndEarn: "ណែនាំ និងរកប្រាក់",
        FastFree: "រហ័ស និងឥតគិតថ្លៃ",
        CustomerFeedback: "បទពិសោធន៍ និងមតិរបស់អតិថិជន",
        UserFriendlyPlatform: "វេទិកាជួញដូរដែលងាយស្រួលប្រើ",
        StreamlinedFeatures: "លក្ខណៈពិសេសដែលត្រូវបានរៀបចំឱ្យសាមញ្ញ ងាយស្រួលស្វែងរក និងជួញដូរ។ តារាងវិចារណ៍ជាមួយសូចនាករពេញលេញជួយខ្ញុំចាប់យកនិន្នាការបានរហ័ស។ ជម្រើសដ៏ល្អសម្រាប់ទាំងអ្នកថ្មី និងវិនិយោគិនអាជីព។",
        HighSecurityTrading: "សុវត្ថិភាពខ្ពស់ ជឿជាក់លើការជួញដូរ",
        SecureCryptoTrading: "ខ្ញុំតែងតែបារម្ភអំពីសុវត្ថិភាពនៅពេលជួញដូរគ្រីបតូ ប៉ុន្តែវេទិកានេះធ្វើឱ្យខ្ញុំមានភាពជឿជាក់ទាំងស្រុង។ រាល់ប្រតិបត្តិការគឺច្បាស់លាស់។ ខ្ញុំមិនដែលជួបបញ្ហាសុវត្ថិភាពណាមួយឡើយ។ នេះជាចំណុចខ្លាំងដែលវេទិកាផ្សេងទៀតកម្រសម្រេចបាន។",
        DedicatedSupport: "ការគាំទ្រអតិថិជនដោយយកចិត្តទុកដាក់",
        ResponsiveSupportTeam: "រឿងមួយដែលធ្វើឱ្យខ្ញុំចាប់អារម្មណ៍គឺក្រុមគាំទ្រដែលឆ្លើយតបយ៉ាងរហ័ស។ រាល់សំណួររបស់ខ្ញ۔ុំត្រូវបានដោះស្រាយក្នុងរយៈពេលប៉ុន្មាននាទី។ មិនថាជាបញ្ហាដាក់ប្រាក់ ដកប្រាក់ ឬលក្ខណៈពិសេសជួញដូរទេ ពួកគេគ្រប់គ្រងយ៉ាងជំនាញ។",
        QuickStartJourney: "ចាប់ផ្តើមដំណើររបស់អ្នកក្នុងរយៈពេលប៉ុន្មាននាទី",
        MultipleIncomeStreams: "បង្កើតប្រភពចំណូលច្រើននៅថ្ងៃនេះ!",
        FAQ: "សំណួរដែលសួរញឹកញាប់",
        VIPMemberObligations: "កាតព្វកិច្ចសមាជិក VIP",
        PrivacyPolicy: "គោលការណ៍ឯកជនភាព",
        TermsConditions: "លក្ខខណ្ឌនិងលក្ខន្តិកៈ",
        RiskWarning: "ការព្រមានអំពីហានិភ័យ",
        Disclaimer: "ការបដិសេធទំនួលខុសត្រូវ",
        UpdateNotifications: "ទទួលការជូនដំណឹងអំពីការធ្វើបច្ចុប្បន្នភាព",
        SubscribeUpdates: "ចុះឈ្មោះដើម្បីទទួលព័ត៌មានធ្វើបច្ចុប្បន្នភាព និងការជូនដំណឹងអំពីការផ្លាស់ប្តូរ និងផលិតផលរបស់យើង",
        Submit: "ដាក់ស្នើ",
        EnterEmailAddress: "បញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់អ្នក"
    },
    id: {
        PROCESSING: 'Sedang diproses',
        NạptiềnTRANSFER: 'Deposit uang',
        Tout: "Transfer keluar",
        Tin: "Transfer masuk",
        ToBuy: "Beli VIP",
        VipDuty: "Tugas VIP",
        Rule: "Pengguna hanya dapat melakukan perdagangan Naik atau Turun dalam satu sesi dan harus melakukan perdagangan di sesi berturut-turut. Setiap perdagangan dalam satu sesi harus minimal $10. Rangkaian kemenangan atau kekalahan harus terdiri dari 9 kali berturut-turut. Jika ada beberapa pengguna memenangkan Jackpot di sesi yang sama, hadiah akan dibagi rata di antara semua pengguna pemenang pada waktu tersebut. Pengguna harus menyelesaikan verifikasi identitas (KYC) di sistem kami agar memenuhi syarat untuk tantangan ini. Selain itu, setiap hari akan ada hadiah Mega senilai 5x yang dipilih secara acak dari pengguna yang memenangkan Jackpot pada hari tersebut. Jika tidak ada pengguna yang memenangkan Jackpot pada hari tersebut, maka tidak ada hadiah Mega. Harap diperhatikan bahwa hadiah akan dikreditkan ke dompet akun dalam waktu sekitar 48 jam.Kami berhak untuk mengubah/mengubah informasi apa pun dalam Syarat dan Ketentuan atau kebijakan/panduan platform kami, kapan saja dan atas kebijakan kami sendiri. Perubahan/pengubahan akan berlaku segera setelah informasi revisi dipublikasikan di platform kami atau Anda diberitahukan melalui email.Program Tantangan Berkelanjutan dan manfaatnya disediakan atas kebijakan kami sendiri. Kami berhak untuk memodifikasi atau membatalkan hadiah Jackpot serta cara kami menilai dan memberikan penghargaan untuk transaksi yang memenuhi syarat.Kami berhak untuk mencabut atau mengakhiri kelayakan Anda untuk hadiah Jackpot jika ditemukan tindakan penipuan atau tidak jujur untuk mendapatkan hadiah tambahan melalui program ini. Anda akan didiskualifikasi dari Tantangan Berkelanjutan atau dilarang secara permanen menggunakan layanan kami tanpa pemberitahuan sebelumnya dalam kasus seperti itu. Keputusan kami adalah final dan kami tidak akan terlibat dalam perselisihan apa pun terkait masalah ini.",
        TradeandMakeProfit: "Trading dan Profit",
        Prize: "Hadiah",
        YourHistory: "Riwayat Anda",
        PrizeReceiveHistory: "Riwayat Receive History",
        PrizeWinnerList: "Daftar Pemenang Hadiah",
        ViewMoreInfo: "Lihat info lebih lanjut",
        TradeandWin: "Perdagangan dan Menang",
        ShowBollingerBands: "Tampilkan Bollinger Bands",
        OpenOrder: "Pesanan Terbuka",
        CloseOrder: "Pesanan Ditutup",
        Up: "Naik",
        Down: "Turun",
        NạptiềnBANK: "Deposit uang (USDT)",
        NạptiềnUSDT: "Deposit uang (USDT)",
        Chuyểntiềntừvígiaodịchsangvíchính: "Transfer uang dari dompet perdagangan ke dompet utama",
        Chuyểntiềntừvíchínhsangvígiaodịch: "Transfer uang dari dompet utama ke dompet perdagangan",
        Last30days: "30 hari terakhir",
        Last7days: "7 hari terakhir",
        EnterUserName: "Masukkan nama pengguna",
        New: "Baru",
        TotalNewCommissions: "Total Komisi Baru",
        Week: "Minggu",
        RejectedVerify: 'Verifikasi ditolak',
        DevelopeSkill: "Kembangkan",
        StartFree: "Mulai gratis",
        Saying: "PUTEX adalah platform perdagangan terkemuka di dunia, menggabungkan inovasi terbaru dengan teknologi canggih untuk memberikan pengalaman perdagangan terbaik bagi para pedagang",
        IdealPlatform: "Platform ideal untuk menghasilkan uang",
        VipNotice: "Tingkat VIP default Anda setelah menjadi anggota VIP adalah Level 1. Untuk meningkatkan tingkat VIP, Anda harus membayar biaya upgrade dan memiliki cukup F1 yang membeli anggota VIP. Pada pukul 00:00:00 (UTC) setiap hari Minggu, tingkat VIP yang Anda tingkatkan akan kedaluwarsa, tingkat baru Anda akan diperbarui berdasarkan volume perdagangan mingguan F1 dan jumlah anggota VIP yang dibeli oleh F1 dalam 7 hari terakhir.",
        YouHaveReachMaxLevel: "Anda telah mencapai level maksimum",
        AmountF1BuyVip: "Jumlah yang dibutuhkan untuk mem",
        UpgradeCharge: "Biaya Upgrade",
        UpgradeCharge: "Upgrade",
        Upgrade: "Tingkatkan",
        ShowReferersByName: "Tampilkan Referensi Berdasarkan Nama",
        ShowReferers: "Tampilkan Referensi Berdasarkan Level",
        SearchBy: "Cari berdasarkan",
        VipMemberManagement: "Manajemen Anggota VIP",
        TotalCommissionTrades: "Total Komisi Perdagangan",
        PhoneNumber: "Nomor Telepon",
        Information: "Informasi",
        UpBranch: "Cabang Atas",
        TotalOfVipMembers: "Total anggota VIP",
        NoVipAuthorization: "Tidak ada otorisasi anggota VIP",
        TradeProfitDetail: "Detail Keuntungan Perdagangan",
        ThisMonthReceived: "Diterima bulan ini",
        Receive: "Terima",
        TradingCommissionChart: "Grafik Komisi Perdagangan",
        CommissionNote: "Setiap hari baru, Anda akan menerima komisi perdagangan dari downline hari sebelumnya.",
        VipMemberCommissions: "Komisi Anggota VIP",
        Date: "Tanggal",
        InputTransferAmount: 'Masukkan jumlah yang akan ditransfer',
        CreateBonaxAccount: 'Buat Akun PUTEX',
        RequestNewEmail: "Minta email baru",
        NoConfirmationEmail: "Tidak menerima email konfirmasi?",
        InputRefererCode: "Masukkan kode referensi",
        InputNickname: "Masukkan nama panggilan",
        HaveAnAccount: 'Sudah memiliki akun?',
        NeedBonaxAccount: "Perlu akun PUTEX",
        ForgetPassword: "Lupa kata sandi",
        GoogleAuthInput: "Masukkan kode Google Authenticator",
        InputPassword: "Masukkan kata sandi",
        InputEmail: "Masukkan email",
        LoginToYourAccount: 'Masuk ke akun Anda',
        ApplySuccess: 'Pengajuan Berhasil',
        NextStep: 'Langkah Selanjutnya',
        IdAndPassport: 'Nomor ID/Paspor',
        InputName: 'Masukkan Nama',
        InputName2: 'Masukkan Nama Keluarga dan Nama Tengah',
        TurnSettingOn: 'Aktifkan pengaturan ini untuk menyembunyikan statistik akun Anda',
        Warn2FA: 'Wajib untuk penarikan dan pembaruan keamanan',
        CurrentPassword: 'Kata Sandi Saat Ini',
        Account: 'Akun',
        Verified: 'Terverifikasi',
        ChangeImage: 'Ubah Gambar',
        Update: 'Perbarui',
        UploadImgNote: 'Foto yang diunggah harus kurang dari 5MB*',
        UpLoadFromPc: 'Unggah dari PC',
        TradeSumary: 'Ringkasan Perdagangan',
        TradeTurns: 'Putaran Perdagangan',
        OTPfromTele: 'Kode OTP dari aplikasi Telegram',
        AccountName: 'Nama Akun',
        AmountOfMoneyLeft: 'Jumlah Uang yang Tersisa',
        WithdrawValue: 'Nilai Penarikan',
        WithdrawRequest: 'Permintaan Penarikan',
        HideSensitiveContent: 'Sembunyikan data sensitif',
        TransferNote: "Anda hanya dapat melakukan perdagangan setelah aset ditransfer ke akun yang sesuai. Transfer aset bebas biaya.",
        Transfer: 'Transfer',
        CANCEL: 'Dibatalkan',
        Status: 'Status',
        VerifyNow: 'Verifikasi Sekarang',
        NewPassword: 'Kata Sandi Baru (minimal 6 karakter)',
        ReceiveBank: 'Bank Penerima',
        WithdrawalBank: 'Bank Penarikan',
        Sender_Receiver: 'Pengirim/Penerima',
        Size: 'Ukuran',
        VerifyIdentity: 'Verifikasi Identitas:',
        YouChoose: 'Anda memilih',
        OwnerName: 'Nama Pemilik',
        TotalRoundWin: 'Total Putaran Menang',
        TotalRoundDraw: 'Total Putaran Seri',
        TotalRoundLose: 'Total Putaran Kalah',
        Get: 'Dapatkan',
        Ensure: "Untuk memastikan keamanan aset Anda, harap konfirmasi lagi bahwa blockchain yang Anda pilih adalah BSC",
        NetworkIsNoAvailable: "Jaringan tidak tersedia untuk transfer uang, harap pilih jaringan atau mata uang lain.",
        HHAccepted: "HH diterima",
        TotalKLGD: "Total KLGD",
        All: "Semua",
        CommissionType: "Jenis Komisi",
        RecentDays: "Beberapa Hari Terakhir",
        Yesterday: "Kemarin",
        From: 'Dari',
        AccountNumber: 'Nomor Akun',
        ReceiveAdress: {
            "1": 'Masukkan',
            "2": 'Alamat Penerimaan',
        },
        AccountType: 'Jenis Akun',
        Request: 'Permintaan',
        SideNote: 'Catatan',
        Optional: 'Opsional',
        Period: "Periode",
        ChooseWallet: 'Pilih Dompet',
        SearchResults: "Hasil Pencarian",
        SeeWhoYouReferBy: "Lihat siapa yang Anda referensikan",
        ManagementAgent: "Agen Manajemen",
        MainWallet: 'Dompet Utama',
        TradeWallet: 'Dompet Perdagangan',
        MainAccount: 'Akun Utama',
        Sales: "Penjualan",
        HideBalance: 'Sembunyikan Saldo',
        ReceiverNickname: 'Nama Panggilan Penerima',
        FriendAccepted: 'Teman Anda telah menerima undangan Anda, selesaikan registrasi dan transaksi',
        NoData: "Tidak ada data",
        Register: 'Daftar',
        TradeId: "ID Perdagangan",
        ViewAll: 'Lihat Semua',
        TradeType: 'Jenis Perdagangan',
        MinValue: 'Nilai Minimum',
        TransferSuccess: 'Transfer Berhasil',
        ReceiverNickname: 'Nama Panggilan Penerima',
        YourRechargeAddress: {
            "1": "Alamat",
            "2": "Pengisian Ulang Anda",
        },
        Login: 'Masuk',
        Charge: 'Isi Ulang',
        RequestSuccess: 'Permintaan Berhasil',
        PlaceOrder: 'Tempatkan Pesanan',
        TotalReceive: 'Total Penerimaan',
        WaitingForResult: "Menunggu Hasil",
        TransferInfo: {
            "Warn": 'Harap transfer jumlah yang tepat',
            "ToAccount": "Ke akun berikut",
            "Content": 'Konten',
            "Warning1": "Catatan: Harap masukkan konten transfer yang benar di atas untuk menghindari kesalahan",
            "Warning2": "Harap hubungi kami melalui hotline 10 menit setelah transfer jika akun Anda belum terupdate.",
        },
        DepositOn: "Jumlah Pengisian Ulang",
        NoNewNotifications: "Tidak ada pemberitahuan baru",
        TradingVolume: "Volume Perdagangan",
        NumberOfTransactions: "Jumlah Transaksi",
        TradingProfitDetails: "Detail Keuntungan Perdagangan",
        LevelDiagram: "Diagram Level",
        YouWillReceiveTradingCommissions: "Anda akan menerima komisi perdagangan dari downline Anda segera.",
        Note: "Catatan",
        Notification: 'Pemberitahuan',
        EmailAddress: "Alamat Email",
        showBalance: "Tampilkan Saldo",
        Contact: "Kontak",
        Total: "Total",
        Month: "Bulan",
        CommissionStatistics: 'Statistik Komisi',
        CommissionShare: 'Terima komisi yang sesuai',
        CommissionEasy: 'Terima komisi dengan mudah',
        TotalVolume: "Total volume perdagangan 7 level per bulan.",
        LowerLevelTradingVolume: "Volume Perdagangan Level Bawah",
        TotalCommissions: "Komisi Total",
        New: "Baru",
        Guide: 'Panduan',
        Sound: 'Suara',
        RecentFigures: "Angka Terbaru",
        LastMonth: "Bulan Lalu",
        ThisMonth: "Bulan Ini",
        VIPCommission: "Komisi VIP",
        TotalCommissions: 'Total Komisi',
        TradingCommissions: "Komisi Perdagangan",
        TotalNumberOfAgents: "Total Jumlah Agen",
        TotalNumberOfTraders: "Total Jumlah Pedagang",
        Presenter: "Presenter",
        FriendRegistered: 'Teman Terdaftar',
        Agency: "Agen",
        TotalThisWeek: "Total (Minggu Ini)",
        Rank: "Peringkat",
        Condition: "Kondisi",
        YouSuccecced: 'Anda Berhasil Mengundang',
        To: 'Ke',
        SystemManagement: "Manajemen Sistem",
        Commission: "Komisi",
        MakeMoney: "Mendapatkan Uang",
        Overview: "Gambaran Umum",
        LoadNow: "Muat Sekarang",
        YourBalanceIsInsufficient: "Saldo Anda Tidak Cukup",
        TermsOfService: "Syarat Layanan",
        AcknowledgeAndAgree: "Saya Mengerti dan Setuju",
        YouNeedToPay: {
            "1": 'Anda Harus Membayar',
            "2": 'Untuk Menjadi Anggota VIP. Apakah Anda Ingin Melanjutkan?',
        },
        AcceptParticipation: "Terima Partisipasi",
        BecomeAVip: "Jadilah Anggota VIP",
        DisclaimerTheParty: "Penafian: Layanan pihak ketiga di atas dapat digunakan untuk membeli perdagangan terkelola. Dengan mendaftar di platform yang mereka sediakan, Anda menyetujui syarat dan ketentuan layanan mereka dan diminta untuk memverifikasi identitas Anda.",
        Trade: "Perdagangan",
        Help: "Bantuan",
        Shopping: "Belanja",
        Setting: "Pengaturan",
        Add: "Tambah",
        Vip: "VIP",
        Wallet: "Dompet",
        Exchange: "Pertukaran",
        Dashboard: "Dasbor",
        TransferValue: 'Nilai Transfer',
        Logout: "Keluar",
        Challenge: "Tantangan",
        Profile: "Profil",
        Settings: "Pengaturan",
        Command: "Perintah",
        PENDING: 'Tertunda',
        FINISH: 'Selesai',
        QuickRecharge: "Isi Ulang Cepat",
        Support: "Dukungan",
        RealAccount: "Akun Nyata",
        DemoAccount: "Akun Demo",
        Profit: "Keuntungan",
        OrderValue: 'Nilai Pesanan',
        Sentiment: "Sentimen",
        Buy: "Beli",
        Sell: "Jual",
        Bet: "Taruhan",
        Internal: 'Internal',
        Recharge: "Isi Ulang",
        Withdraw: "Tarik",
        BuyCrypto: "Beli Crypto",
        Money: "Uang",
        Network: "Jaringan",
        MemberVip: "Anda Harus Menjadi Anggota VIP Untuk Mendapatkan Komisi Perdagangan dan Komisi Referred",
        BuyNow: "Beli Sekarang",
        LinkRegister: "Tautan Pendaftaran",
        Copy: "Salin",
        ReferralCode: "Kode Rujukan",
        InviteFriend: "Undang Teman",
        InviteFriendRegister: "Undang Teman Melalui Tautan Pendaftaran PUTEX",
        TotalAssets: "Total Aset (USD)",
        Reload: "Muati Ulang",
        DepositComplaints: "Keluhan Setoran",
        Complain: "Keluhan",
        TransactionHistory: "Riwayat Transaksi",
        BOData: "Data BO",
        TotalRound: "Total Putaran",
        WinRate: "Tingkat Kemenangan",
        TotalTransaction: "Total Transaksi",
        NetProfit: "Keuntungan Bersih",
        TotalRevenue: "Pendapatan Total",
        Search: "Cari",
        Lang: "Bahasa",
        Currency: "Mata Uang",
        ChangePassword: "Ganti Kata Sandi",
        OldPassword: "Kata Sandi Lama",
        NewPassword: "Kata Sandi Baru",
        EnterPassword: "Masukkan Kata Sandi",
        Enable2FA: "Harus Mengaktifkan 2FA untuk Mengatur",
        NotOpen: "Anda Belum Mendaftar",
        Open: "Buka",
        Close: "Tutup",
        DepositHistory: "Riwayat Setoran",
        WithdrawHistory: "Riwayat Penarikan",
        ChangeAvatar: "Ganti Avatar",
        PersonalInformation: "Informasi Pribadi",
        Nickname: "Nama Panggilan",
        VerifyAccount: "Verifikasi Akun",
        EnsureTheSafety: "Untuk Menjamin Keamanan Anda.",
        Confirm: "Konfirmasi",
        AccountUnderReview: "Akun Sedang Ditinjau",
        AccountVerified: "Akun Diverifikasi",
        Security: "Keamanan",
        WantToChangePassword: "Apakah Anda Ingin Mengganti Kata Sandi Anda?",
        RequiredToEnable2FA: "Harus Mengaktifkan 2FA untuk Menarik atau Memperbarui Keamanan.",
        Open2FA: "Aktifkan 2FA",
        Change: "Ganti",
        Surname: "Nama Belakang",
        Name: "Nama Depan",
        CardPassport: "Nomor KTP / Paspor",
        Nation: "Negara",
        Next: "Selanjutnya",
        Back: "Kembali",
        Done: "Selesai",
        IdentityAuthentication: "Verifikasi Identitas",
        PleaseEnsureThePhoto1: "Pastikan Anda Mengunggah Foto Dengan Format JPG, PNG, JPEG",
        PleaseEnsureThePhoto2: "Ambil Foto KTP/Paspor Anda.",
        FrontCard: "Bagian Depan KTP/Paspor",
        BackCard: "Bagian Belakang KTP/Paspor",
        Consider: "Pertimbangkan",
        ApplySuccess: 'Aplikasi Berhasil',
        ClickDoneToComplete: "Kami akan memeriksa informasi Anda dan menyelesaikan verifikasi dalam waktu 7 hari kerja",
        YourAccountVerified: "Akun Anda Telah Diverifikasi!",
        Asset: "Aset",
        StartTime: "Waktu Mulai",
        Select: "Pilih",
        Selected: "Terpilih",
        OpenPrice: "Harga Pembukaan",
        ClosingPrice: "Harga Penutupan",
        Value: "Nilai",
        Pay: "Bayar",
        Time: "Waktu",
        Type: "Tipe",
        Description: "Txid/Deskripsi",
        Cryptocurrency: "Cryptocurrency",
        Address: "Alamat",
        GoogleAuthentication: "Verifikasi Google",
        GoogleAuthenticationIsEnabled: "Verifikasi Google Aktif",
        OpenYourGoogleAuthentication: "Buka Aplikasi Google Authenticator Anda",
        BackupCode: "Kode Cadangan",
        Password: "Kata Sandi",
        Verification: "Verifikasi",
        Code2FA: "Kode 2FA",
        SendCode: "Kirim Kode",
        TurnOn: "Aktifkan",
        Deactivate: "Nonaktifkan",
        AmountOfMoney: "Jumlah Uang",
        DepositAddress: "Alamat Deposit",
        Yours: "Milik Anda",
        SendOnly: "Hanya Kirim",
        ToThisAddress: "Ke Alamat Ini",
        ConfirmationsNeeded: "Konfirmasi Diperlukan",
        Max: "Maksimum",
        BalanceAmount: "Jumlah Saldo",
        MinimumWithdrawAmount: "Jumlah Penarikan Minimum",
        TransactionProcessingFee: "Biaya Pemrosesan Transaksi",
        FromYourRemainingBalance: "Akan Dikenakan dari Saldo Sisa Anda",
        DepositWithdraw: 'Transaksi Deposit Penarikan Menggunakan Jaringan',
        ClickToPay: "Klik di sini untuk melanjutkan pembayaran",
        MinValueWithdraw: "Jumlah minimum",
        NoteWithdraw: "Masukkan catatan Anda",
        Require2FA: "Anda harus mengaktifkan 2FA untuk meminta penarikan",
        ConfirmWithdraw: "Konfirmasi penarikan",
        WithdrawAmount: "Jumlah penarikan",
        WithdrawTime: "Waktu",
        WithdrawType: "Jenis penarikan",
        Input2FA: "Masukkan kode 2FA Anda",

        TradingIndicatorsBenefit: "Indikator perdagangan membantu klien menghasilkan lebih banyak uang",
        PUTEXAdvancedIndicators: "PUTEX mengembangkan indikator yang sangat c advanced dan mudah digunakan untuk membantu trader membuat keputusan perdagangan yang lebih baik",
        SmartTraining: "Pelatihan cerdas",
        EffectiveMoneyMaking: "Temukan cara paling efektif untuk menghasilkan uang",
        NewEarningOpportunities: "Jelajahi peluang menghasilkan uang baru, dari perdagangan harian hingga memperoleh pendapatan pasif dari komisi perdagangan atau komisi VIP",
        OurPlatform: "Platform kami",
        InnovativePlatform: "Platform yang dibangun berdasarkan inovasi",
        LatestTradingInnovations: "Kami selalu memperbarui inovasi terbaru di bidang perdagangan untuk membantu semua orang mendapatkan keuntungan dari perdagangan di PUTEX",
        StableSecure: "Stabil dan aman",
        ReferAndEarn: "Rujuk dan dapatkan uang",
        FastFree: "Cepat & Gratis",
        CustomerFeedback: "Pengalaman dan umpan balik pelanggan",
        UserFriendlyPlatform: "Platform perdagangan yang ramah pengguna",
        StreamlinedFeatures: "Fitur yang disederhanakan, mudah dicari dan diperdagangkan. Grafik intuitif dengan indikator lengkap membantu saya dengan cepat memahami tren. Pilihan yang bagus untuk pemula maupun investor profesional.",
        HighSecurityTrading: "Keamanan tinggi, perdagangan dengan percaya diri",
        SecureCryptoTrading: "Saya selalu khawatir tentang keamanan saat berdagang kripto, tetapi platform ini membuat saya benar-benar tenang. Setiap transaksi transparan. Saya tidak pernah mengalami masalah keamanan. Ini adalah keunggulan besar yang jarang dicapai platform lain.",
        DedicatedSupport: "Dukungan pelanggan yang berdedikasi",
        ResponsiveSupportTeam: "Salah satu hal yang membuat saya terkesan adalah respons cepat dari tim dukungan. Semua pertanyaan saya dijawab dalam hitungan menit. Baik itu tentang setoran, penarikan, atau fitur perdagangan, mereka menanganinya dengan sangat profesional.",
        QuickStartJourney: "Mulai perjalanan Anda dalam beberapa menit",
        MultipleIncomeStreams: "Ciptakan berbagai sumber pendapatan hari ini!",
        FAQ: "Pertanyaan yang Sering Diajukan",
        VIPMemberObligations: "Kewajiban anggota VIP",
        PrivacyPolicy: "Kebijakan Privasi",
        TermsConditions: "Syarat dan Ketentuan",
        RiskWarning: "Peringatan Risiko",
        Disclaimer: "Penafian",
        UpdateNotifications: "Terima pemberitahuan pembaruan",
        SubscribeUpdates: "Daftar untuk menerima pembaruan dan pemberitahuan tentang bursa dan produk kami",
        Submit: "Kirim",
        EnterEmailAddress: "Masukkan alamat email Anda"
    },
    lo: {
        NạptiềnTRANSFER: 'ລາຍຈ່າຍເພື່ອລາຍຈ່າຍ',
        PROCESSING: 'ກຳລັງປະຕິເສດ',
        Tout: "ໂອນອອກ",
        Tin: "ໂອນເຂົ້າ",
        ToBuy: "ຊື້ VIP",
        VipDuty: "ຄະນະ VIP",
        Rule: "ຜູ້ໃຊ້ສາມາດເຮັດການຊື້ຂາຍຂຶ້ນຫຼືລົງໄດ້ໃນໜຶ່ງເທົ້າເວລາເທົ່ານັ້ນ ແລະຈະຕ້ອງຊື້ຂາຍໃນເທົ້າຕໍ່ໆກັນ. ການຊື້ຂາຍໃນແຕ່ລະເທົ້າຈະຕ້ອງມີຈຳນວນໜ້ອຍທີ່ສຸດ $10. ສາຍຊະນະຫຼືສາຍເສຍຈະຕ້ອງມີຈຳນວນ 9 ເທື່ອຕິດຕໍ່ກັນ. ໃນກໍລະນີທີ່ມີຜູ້ໃຊ້ຈຳນວນຫຼາຍເຂົ້າມາຊະນະລາງວັນ Jackpot ໃນເທົ້າດຽວກັນ, ລາງວັນຈະຖືກແບ່ງໃຫ້ທຽງທຽມກັນລະຫວ່າງຜູ້ຊະນະທັງຫມົດ. ຜູ້ໃຊ້ຈະຕ້ອງສຳເລັດການຢືນຢັນຕົນຕົວ (KYC) ບໍລະລະບົບຂອງພວກເຮົາ ເພື່ອໃຫ້ມີສິດເຂົ້າຮ່ວມຄວາມທ້າທາຍນີ້.ຍິ່ງກວ່ານັ້ນ, ຈະມີລາງວັນ Mega ຄຸ້ນມູນຄ່າ 5 ທີ່ຖືກສຸ່ມເລືອກໃນໜຶ່ງວັນ, ຈາກຜູ້ໃຊ້ທີ່ຊະນະລາງວັນ Jackpot ໃນວັນນັ້ນ. ຖ້າບໍ່ມີຜູ້ໃຊ້ໄດ້ຮັບລາງວັນ Jackpot ໃນວັນນັ້ນ, ລາງວັນ Mega ຈະບໍ່ຖືກຈັດໃຫ້. ຂໍຊີ້ແຈງວ່າລາງວັນຈະໄດ້ຮັບການໂອນເຂົ້າກະເປົາຂອງບັນຊີໃນໄລຍະປະມານ 48 ຊົ່ວໂມງ.ພວກເຮົາຂອງສະຫຼຸດສິດທິໃນການປ່ຽນແປງ/ແກ້ໄຂຂໍ້ມູນໃນເງື່ອນໄຂ ຫຼືນະໂຍບາຍ/ຄູ່ມືຂອງແພລັດຟອມຂອງພວກເຮົາໄດ້ທຸກເວລາ, ຕາມດຸລິພິດຂອງພວກເຮົາເອງ. ການປ່ຽນແປງ/ແກ້ໄຂໃດໆ ຈະມີຜົນທັນທີຫຼັງຈາກມີການປະກາດຂໍ້ມູນດັ່ງກ່າວຢູ່ໃນແພລັດຟອມ ຫຼືຜ່ານອີເມລ.ລາຍການ Continuous Challenge ແລະຜົນປະໂຫຍດຂອງມັນຈະຖືກສະໜອງໃນດຸລິພິດຂອງພວກເຮົາ. ພວກເຮົາຂອງສິດທິໃນການແກ້ໄຂຫຼືຍົກເລີກລາງວັນ Jackpot ລວມໄປຮອດວິທີການປະເມີນແລະມອບລາງວັນສໍາລັບການຊື້ຂາຍທີ່ມີຄຸນສົມບັດ.ພວກເຮົາຂອງສິດທິໃນການຍົກເລີກຫຼືສິ້ນສຸດສິດທິຂອງທ່ານສໍາລັບລາງວັນ Jackpot ໃນກໍລະນີທີ່ມີການຄົ້ນພົບຄວາມປອມແລະບໍ່ສື່ສັດເພ",
        TradeandMakeProfit: "ຄືນແລະຈັດລຽນ",
        Prize: "ລາຍຮັບລາຍຮັບ",
        YourHistory: "ປະຫວັດຂອງທ່ານ",
        PrizeReceiveHistory: "ປະຫວັດການຮັບລາຍຮັບລາຍຮັບ",
        PrizeWinnerList: "ລາຍຊື່ຜູ້ລົງຝັນລາຍຮັບ",
        TradeandWin: "ຄືນແລະຈັດລຽນ",
        ViewMoreInfo: "ເບິ່ງຂໍ້ມູນເພີ່ມ",
        ShowBollingerBands: "ເບິ່ງ Bollinger Bands",
        OpenOrder: "ສັບສະນັ່ງເປີດ",
        CloseOrder: "ສັບສະນັ່ງປິດ",
        Up: "ເພີ່ມ",
        Down: "ຫຼຸດ",
        NạptiềnBANK: "ລາຍຈ່າຍເງິນ (USDT)",
        NạptiềnUSDT: "ລາຍຈ່າຍເງິນ (USDT)",
        Chuyểntiềntừvígiaodịchsangvíchính: "ໂອນເງິນຈາກກະເປົາການຄ້າໄປກະເປົາຫຼັກ",
        Chuyểntiềntừvíchínhsangvígiaodịch: "ໂອນເງິນຈາກກະເປົາຫຼັກໄປກະເປົາການຄ້າ",
        Last30days: "30 ມື້ຜ່ານ",
        Last7days: "7 ມື້ຜ່ານ",
        EnterUserName: "ປ້ອນຊື່ຜູ້ໃຊ້",
        TotalNewCommissions: "ລາຍຮັບໃໝ່ທັງໝົດ",
        New: "ໃໝ່",
        Week: "ອາທິດ",
        RejectedVerify: 'ການກວດສອບຖືກປະຕິບັດ',
        DevelopeSkill: "ພວກເຮົາກໍາລັງພວກເຮົາ",
        StartFree: "ເລີ່ມຟຣີ",
        Saying: "PUTEX ແມ່ນແພລັດຟອມການຄ້າຊັ້ນນຳຂອງໂລກ, ທີ່ປະສົມປະສານການປັບປຸງລ່າສຸດກັບເທັກໂນໂລຢີທີ່ທັນສະໄໝເພື່ອມອບປະສົບການການຄ້າທີ່ດີທີ່ສຸດໃຫ້ກັບຜູ້ຄ້າ",
        IdealPlatform: "ພື້ນຖານທີ່ເໝາະສົມສຳລັບການຫາເງິນ",
        VipNotice: "ລະດັບ VIP ຄ່າປະຕິບັດຂອງທ່ານຫຼັງຈາກການເປັນສະມາຊິກ VIP ແມ່ນລະດັບ 1. ເພື່ອທີ່ຈະຍົກລະດັບລະດັບ VIP, ທ່ານຕ້ອງຈ່າຍຄ່າທຳນຽມຍົກລະດັບແລະມີຈຳນວນ F1 ທີ່ຊື້ສະມາຊິກ VIP ພຽງພໍ. ໃນເວລາ 00:00:00 (UTC) ທຸກວັນອາທິດ, ລະດັບ VIP ທີ່ທ່ານໄດ້ຍົກລະດັບຈະໝົດອາຍຸ, ລະດັບໃໝ່ຂອງທ່ານຈະຖືກອັບເດດຕາມປະລິມານການຄ້າປະຈຳອາທິດຂອງ F1 ແລະຈຳນວນສະມາຊິກ VIP ທີ່ຊື້ໂດຍ F1 ໃນລະຫວ່າງ 7 ມື້ທີ່ຜ່ານມາ.",
        YouHaveReachMaxLevel: "ທ່ານໄດ້ຮັບຄ່ານາຍພາຍນາຍຄ່າຄືນສູງສຸດແລ້ວ",
        AmountF1BuyVip: "ຈຳນວນທີ່ຕ້ອງການໃຫ້ການຍົກລະດັບເປັນ VIP",
        UpgradeCharge: "ຄ່າທຳນຽມຍົກລະດັບ",
        Upgrade: "ຍົກລະດັບ",
        ShowReferersByName: "ສະແດງຜູ້ແນະນຳຕາມຊື່",
        ShowReferers: "ສະແດງຜູ້ແນະນຳຕາມລະດັບ",
        SearchBy: "ຄົ້ນຫາໂດຍ",
        VipMemberManagement: "ການຈັດການສະມາຊິກ VIP",
        TotalCommissionTrades: "ລາຍຮັບຄ່ານາຍພາຍນາຍຄ່າຄືນ",
        PhoneNumber: "ເບີໂທລະສັບ",
        Information: "ຂໍ້ມູນ",
        UpBranch: "ສາຂາຂ້າງເທິງ",
        TotalOfVipMembers: "ຈຳນວນສະມາຊິກ VIP ທັງໝົດ",
        NoVipAuthorization: "ບໍ່ມີສິດສະມາຊິກ VIP",
        TradeProfitDetail: "ລາຍລະອຽດການຄ້າຄືນ",
        ThisMonthReceived: "ຮັບເງິນເດືອນນີ້",
        Receive: "ຮັບ",
        TradingCommissionChart: "ການແຜນພາບຄ່ານາຍໜ້າການຄ້າ",
        CommissionNote: "ທຸກມື້ໃໝ່, ທ່ານຈະໄດ້ຮັບຄ່ານາຍໜ້າການຄ້າຈາກຜູ້ທີ່ຢູ່ພາຍໃຕ້ຂອງທ່ານຂອງມື້ກ່ອນ.",
        VipMemberCommissions: "ຄຳຕອບຂອງສະມາຊິກ VIP",
        Date: "ວັນທີ",
        InputTransferAmount: 'ປ້ອນຈຳນວນທີ່ຈະຖ້າການສົ່ງ',
        CreateBonaxAccount: 'ສ້າງບັນຊີ PUTEX',
        RequestNewEmail: "ຮ້ອງຂໍອີເມວໃໝ່",
        NoConfirmationEmail: "ບໍ່ໄດ້ຮັບອີເມວຢືນຢັນ?",
        InputRefererCode: "ປ້ອນລະຫັດຜູ້ແນະນຳ",
        InputNickname: "ປ້ອນຊື່ຫຼິ້ນ",
        HaveAnAccount: 'ມີບັນຊີບໍ?',
        NeedBonaxAccount: "ຕ້ອງການບັນຊີ PUTEX",
        ForgetPassword: "ລືມລະຫັດຜ່ານ",
        GoogleAuthInput: "ປ້ອນລະຫັດ Google Authenticator",
        InputPassword: "ປ້ອນລະຫັດຜ່ານ",
        InputEmail: "ປ້ອນອີເມວ",
        LoginToYourAccount: 'ເຂົ້າສູ່ບັນຊີຂອງທ່ານ',
        Send: 'ສົ່ງ',
        ApplySuccess: 'ສະໝັກສຳເລັດ',
        NextStep: 'ຂັ້ນຕອນຕໍ່ໄປ',
        IdAndPassport: 'ເລກບັດປະຈຳຕົວ/ເລກພາສະປອດ',
        InputName: 'ປ້ອນຊື່',
        InputName2: 'ປ້ອນຊື່ຕະກູນແລະຊື່ກາງ',
        TurnSettingOn: 'ເປີດການຕັ້ງຄ່ານີ້ເພື່ອປິດບັນຊີຂອງທ່ານ',
        Warn2FA: 'ບັງຄັບໃຊ້ສຳລັບການຖອນແລະອັບເດດຄວາມປອດໄພ',
        CurrentPassword: 'ລະຫັດຜ່ານປັດຈຸບັນ',
        Account: 'ບັນຊີ',
        Verified: 'ຢືນຢັນແລ້ວ',
        ChangeImage: 'ປ່ຽນຮູບ',
        Update: 'ອັບເດດ',
        UploadImgNote: 'ຮູບທີ່ອັບໂຫລດຕ້ອງມີຂະໜາດຕ່ຳກວ່າ 5MB*',
        UpLoadFromPc: 'ອັບໂຫລດຈາກຄອມພິວເຕີ',
        TradeSumary: 'ສະຫຼຸບການຄ້າ',
        TradeTurns: 'ຮອບການຄ້າ',
        OTPfromTele: 'ລະຫັດ OTP ຈາກແອັບ Telegram',
        AccountName: 'ຊື່ບັນຊີ',
        AmountOfMoneyLeft: 'ຈຳນວນເງິນທີ່ເຫຼືອ',
        WithdrawValue: 'ມູນຄ່າການຖອນ',
        WithdrawRequest: 'ຄຳຮ້ອງຂໍຖອນ',
        HideSensitiveContent: 'ປິດເນື້ອຫາທີ່ອ່ອນໄຫວ',
        TransferNote: "ທ່ານສາມາດຄ້າໄດ້ຫຼັງຈາກທີ່ໂອນຊັບສິນໄປບັນຊີທີ່ກຳນົດແລ້ວ. ການໂອນຊັບສິນເປັນຟຣີ.",
        Transfer: 'ໂອນ',
        CANCEL: 'ຍົກເລີກ',
        Status: 'ສະຖານະ',
        VerifyNow: 'ຢືນຢັນດຽວນີ້',
        NewPassword: 'ລະຫັດຜ່ານໃໝ່ (ຢ່າງນ້ອຍ 6 ຕົວອັກສອນ)',
        ReceiveBank: 'ທະນາຄານຮັບ',
        WithdrawalBank: 'ທະນາຄານຖອນ',
        Sender_Receiver: 'ຜູ້ສົ່ງ/ຜູ້ຮັບ',
        Size: 'ຂະໜາດ',
        VerifyIdentity: 'ຢືນຢັນຕົວຕົນ:',
        YouChoose: 'ທ່ານເລືອກ',
        OwnerName: 'ຊື່ເຈົ້າຂອງ',
        TotalRoundWin: 'ຈຳນວນຮອບທີ່ຊະນະ',
        TotalRoundDraw: 'ຈຳນວນຮອບທີ່ເສຍ',
        TotalRoundLose: 'ຈຳນວນຮອບທີ່ແພ້',
        Get: 'ໄດ້ຮັບ',
        Ensure: "ເພື່ອຮັບປະກັນຄວາມປອດໄພຂອງຊັບສິນຂອງທ່ານ, ກະລຸນາຢືນຢັນອີກຄັ້ງວ່າ blockchain ທີ່ທ່ານຕ້ອງໃຊ້ແມ່ນ BSC",
        NetworkIsNoAvailable: "ເຄືອຂ່າຍບໍ່ພ້ອມສຳລັບການໂອນເງິນ, ກະລຸນາເລືອກເຄືອຂ່າຍອື່ນຫຼືສະກຸນເງິນອື່ນ.",
        HHAccepted: "HH ຍອມຮັບ",
        TotalKLGD: "ລວມ KLGD",
        All: "ທັງໝົດ",
        CommissionType: "ປະເພດຄ່ານາຍໜ້າ",
        RecentDays: "ວັນທີ່ຜ່ານມາ",
        Yesterday: "ມື້ວານ",
        From: 'ຈາກ',
        AccountNumber: 'ເລກບັນຊີ',
        ReceiveAdress: {
            "1": 'ປ້ອນ',
            "2": 'ທີ່ຢູ່ຮັບ',
        },
        AccountType: 'ປະເພດບັນຊີ',
        Request: 'ຄຳຮ້ອງຂໍ',
        SideNote: 'ໝາຍເຫດ',
        Optional: 'ທາງເລືອກ',
        Period: "ໄລຍະເວລາ",
        ChooseWallet: 'ເລືອກກະເປົາເງິນ',
        SearchResults: "ຜົນການຄົ້ນຫາ",
        SeeWhoYouReferBy: "ເບິ່ງຜູ້ທີ່ທ່ານແນະນຳ",
        ManagementAgent: "ຕົວແທນຈັດການ",
        MainWallet: 'ກະເປົາເງິນຫຼັກ',
        TradeWallet: 'ກະເປົາເງິນຄ້າ',
        MainAccount: 'ບັນຊີຫຼັກ',
        Sales: "ການຂາຍ",
        HideBalance: 'ປິດຍອດເງິນ',
        ReceiverNickname: 'ຊື່ຫຼິ້ນຂອງຜູ້ຮັບ',
        FriendAccepted: 'ເພື່ອນຂອງທ່ານໄດ້ຍອມຮັບການເຊີນຂອງທ່ານແລ້ວ, ສຳເລັດການລົງທະບຽນແລະທຸລະກຳ',
        NoData: "ບໍ່ມີຂໍ້ມູນ",
        Register: 'ລົງທະບຽນ',
        TradeId: "ເລກທີ່ການຄ້າ",
        ViewAll: 'ເບິ່ງທັງໝົດ',
        TradeType: 'ປະເພດການຄ້າ',
        MinValue: 'ມູນຄ່າຕ່ຳສຸດ',
        TransferSuccess: 'ການໂອນສຳເລັດ',
        ReceiverNickname: 'ຊື່ຫຼິ້ນຂອງຜູ້ຮັບ',
        YourRechargeAddress: {
            "1": "ທີ່ຢູ່",
            "2": "ການບັນຈຸເງິນຂອງທ່ານ",
        },
        Login: 'ເຂົ້າລະບົບ',
        Charge: 'ເຕີມເງິນ',
        RequestSuccess: 'ຄຳຮ້ອງຂໍສຳເລັດ',
        PlaceOrder: 'ສັ່ງຊື້',
        TotalReceive: 'ຍອດຮັບທັງໝົດ',
        WaitingForResult: "ລໍຖ້າຜົນ",
        TransferInfo: {
            "Warn": 'ກະລຸນາໂອນເງິນຢ່າງແມ່ນຍຳ',
            "ToAccount": "ໄປບັນຊີຕໍ່ໄປນີ້",
            "Content": 'ເນື້ອຫາ',
            "Warning1": "ໝາຍເຫດ: ກະລຸນາປ້ອນເນື້ອຫາການໂອນເງິນທີ່ຖືກຕ້ອງເພື່ອຫຼີກລ້ຽງຄວາມຜິດພາດ",
            "Warning2": "ກະລຸນາຕິດຕໍ່ພວກເຮົາຜ່ານສາຍດ່ວນ 10 ນາທີຫຼັງການໂອນຖ້າບັນຊີຂອງທ່ານຍັງບໍ່ໄດ້ອັບເດດຄະແນນ",
        },
        DepositOn: "ຈຳນວນການບັນຈຸເງິນ",
        NoNewNotifications: "ບໍ່ມີແຈ້ງເຕືອນໃໝ່",
        TradingVolume: "ປະລິມານການຄ້າ",
        NumberOfTransactions: "ຈຳນວນທຸລະກຳ",
        TradingProfitDetails: "ລາຍລະອຽດກຳໄລການຄ້າ",
        LevelDiagram: "ແຜນພາບລະດັບ",
        YouWillReceiveTradingCommissions: "ທ່ານຈະໄດ້ຮັບຄ່ານາຍໜ້າການຄ້າຈາກຜູ້ທີ່ຢູ່ພາຍໃຕ້ຂອງທ່ານທັນທີ.",
        Note: "ໝາຍເຫດ",
        Notification: 'ແຈ້ງເຕືອນ',
        EmailAddress: "ທີ່ຢູ່ອີເມວ",
        showBalance: "ສະແດງຍອດເງິນ",
        Contact: "ຕິດຕໍ່",
        Total: "ລວມ",
        Month: "ເດືອນ",
        CommissionStatistics: 'ສະຖິຕິຄ່ານາຍໜ້າ',
        CommissionShare: 'ຮັບຄ່ານາຍໜ້າທີ່ສົມຄວນ',
        CommissionEasy: 'ຮັບຄ່ານາຍໜ້າງ່າຍໆ',
        TotalVolume: "ປະລິມານການຄ້າທັງໝົດຂອງ 7 ຊັ້ນຕໍ່ເດືອນ.",
        LowerLevelTradingVolume: "ປະລິມານການຄ້າຂອງລະດັບຕ່ຳ",
        TotalCommissions: "ຄ່ານາຍໜ້າທັງໝົດ",
        New: "ໃໝ່",
        Guide: 'ຄູ່ມື',
        Sound: 'ສຽງ',
        RecentFigures: "ຕົວເລກລ່າສຸດ",
        LastMonth: "ເດືອນກ່ອນ",
        ThisMonth: "ເດືອນນີ້",
        VIPCommission: "ຄ່ານາຍໜ້າ VIP",
        TotalCommissions: 'ຄ່ານາຍໜ້າທັງໝົດ',
        TradingCommissions: "ຄ່ານາຍໜ້າການຄ້າ",
        TotalNumberOfAgents: "ຈຳນວນຕົວແທນທັງໝົດ",
        TotalNumberOfTraders: "ຈຳນວນຜູ້ຄ້າທັງໝົດ",
        Presenter: "ຜູ້ນຳເສນ໌",
        FriendRegistered: 'ເພື່ອນລົງທະບຽນ',
        Agency: "ຕົວແທນ",
        TotalThisWeek: "ລວມ (ອາທິດນີ້)",
        Rank: "ອັນດັບ",
        Condition: "ເງື່ອນໄຂ",
        YouSuccecced: 'ທ່ານໄດ້ໂອນສຳເລັດແລ້ວ',
        To: 'ໄປຫາ',
        SystemManagement: "ການຈັດການລະບົບ",
        Commission: "ຄ່ານາຍໜ້າ",
        MakeMoney: "ຫາເງິນ",
        Overview: "ພາບລວມ",
        LoadNow: "ໂຫລດດຽວນີ້",
        YourBalanceIsInsufficient: "ຍອດເງິນຂອງທ່ານບໍ່ພຽງພໍ",
        TermsOfService: "ເງື່ອນໄຂການໃຊ້ບໍລິການ",
        AcknowledgeAndAgree: "ຂ້ອຍຮັບຮູ້ແລະຍອມຮັບ",
        YouNeedToPay: {
            "1": 'ທ່ານຕ້ອງຈ່າຍ',
            "2": 'ເພື່ອການເປັນສະມາຊິກ VIP. ທ່ານຕ້ອງການທີ່ຈະດຳເນີນການຕໍ່ໄປບໍ?',
        },
        AcceptParticipation: "ຍອມຮັບການເຂົ້າຮ່ວມ",
        BecomeAVip: "ເປັນສະມາຊິກ VIP",
        DisclaimerTheParty: "ຄຳປະກາດ: ການບໍລິການຂອງບຸກຄົນທີສາມຂ້າງເທິງອາດຈະໃຊ້ເພື່ອຊື້ສະກຸນເງິນດິຈິຕອນທີ່ອາດຈະໃຊ້ເພື່ອຫຼິ້ນຢູ່ Stake. ໂດຍການລົງທະບຽນຢູ່ແພລັດຟອມຂອງພວກເຂົາ, ທ່ານຍັງຍອມຮັບເງື່ອນໄຂການໃຊ້ບໍລິການຂອງພວກເຂົາແລະຈະຕ້ອງຜ່ານການກວດສອບ KYC ຂອງພວກເຂົາ, ທີ່ດຳເນີນການແຍກຕ່າງຫາກຈາກພວກເຮົາ.",
        Trade: "ຄ້າ",
        Help: "ຊ່ວຍເຫຼືອ",
        Shopping: "ຊື້ຂອງ",
        Setting: "ຕັ້ງຄ່າ",
        Add: "ເພີ່ມ",
        Vip: "ສະມາຊິກ VIP",
        Wallet: "ກະເປົາເງິນ",
        Exchange: "ແລກປ່ຽນ",
        Dashboard: "ແຜງຄວບຄຸມ",
        TransferValue: 'ມູນຄ່າການໂອນ',
        Logout: "ອອກຈາກລະບົບ",
        Challenge: "ທ້າທາຍ",
        Profile: "ໂປຣໄຟລ໌",
        Settings: "ຕັ້ງຄ່າ",
        Command: "ຄຳສັ່ງ",
        PENDING: 'ລໍຖ້າ',
        FINISH: 'ສຳເລັດ',
        QuickRecharge: "ເຕີມເງິນດ່ວນ",
        Support: "ສະໜັບສະໜູນ",
        RealAccount: "ບັນຊີຈິງ",
        DemoAccount: "ບັນຊີທົດລອງ",
        Profit: "ກຳໄລ",
        OrderValue: 'ມູນຄ່າຄຳສັ່ງ',
        Sentiment: "ຕົວຊີ້ວັດຄວາມຮູ້ສຶກ",
        Buy: "ຊື້",
        Sell: "ຂາຍ",
        Bet: "ພະນັນ",
        Internal: 'ພາຍໃນ',
        Recharge: "ເຕີມເງິນ",
        Withdraw: "ຖອນເງິນ",
        BuyCrypto: "ຊື້ສະກຸນເງິນດິຈິຕອນ",
        Money: "ເງິນ",
        Network: "ເຄືອຂ່າຍ",
        MemberVip: "ທ່ານຕ້ອງເປັນສະມາຊິກ VIP ເພື່ອຮັບຄ່ານາຍໜ້າ VIP ແລະຄ່ານາຍໜ້າການຄ້າ",
        BuyNow: "ຊື້ດຽວນີ້",
        LinkRegister: "ລິ້ງລົງທະບຽນ",
        Copy: "ຄັດລອກ",
        ReferralCode: "ລະຫັດແນະນຳ",
        InviteFriend: "ເຊີນເພື່ອນ",
        InviteFriendRegister: "ເຊີນເພື່ອນຜ່ານລິ້ງລົງທະບຽນ PUTEX",
        TotalAssets: "ຊັບສິນທັງໝົດ (USD)",
        Reload: "ໂຫລດໃໝ່",
        DepositComplaints: "ຮ້ອງທຸກການບັນຈຸເງິນ",
        Complain: "ຮ້ອງທຸກ",
        TransactionHistory: "ປະຫວັດທຸລະກຳ",
        BOData: "ຂໍ້ມູນ B.O.",
        TotalRound: "ຈຳນວນຮອບທັງໝົດ",
        WinRate: "ອັດຕາຊະນະ",
        TotalTransaction: "ທຸລະກຳທັງໝົດ",
        NetProfit: "ກຳໄລສຸດທິ",
        TotalRevenue: "ລາຍຮັບທັງໝົດ",
        Search: "ຄົ້ນຫາ",
        Lang: "ພາສາ",
        Currency: "ສະກຸນເງິນ",
        ChangePassword: "ປ່ຽນລະຫັດຜ່ານ",
        OldPassword: "ລະຫັດຜ່ານເກົ່າ",
        NewPassword: "ລະຫັດຜ່ານໃໝ່",
        EnterPassword: "ປ້ອນລະຫັດຜ່ານ",
        Enable2FA: "ທ່ານຕ້ອງເປີດ 2FA ເພື່ອປັບປຸງ",
        NotOpen: "ທ່ານຍັງບໍ່ມີຄຳສັ່ງເປີດໃດໆ",
        Open: "ເປີດ",
        Close: "ປິດ",
        DepositHistory: "ປະຫວັດການບັນຈຸເງິນ",
        WithdrawHistory: "ປະຫວັດການຖອນເງິນ",
        ChangeAvatar: "ປ່ຽນຮູບປະຈຳຕົວ",
        PersonalInformation: "ຂໍ້ມູນສ່ວນບຸກຄົນ",
        Nickname: "ຊື່ຫຼິ້ນ",
        VerifyAccount: "ຢືນຢັນບັນຊີ",
        EnsureTheSafety: "ເພື່ອຮັບປະກັນຄວາມປອດໄພຂອງຊັບສິນຂອງທ່ານ, ພວກເຮົາຕ້ອງການຢືນຢັນຕົວຕົນຂອງທ່ານ. ກະລຸນາກອກຂໍ້ມູນໃຫ້ຖືກຕ້ອງ, ຫຼັງຈາກການຢືນຢັນຕົວຕົນສຳເລັດ, ຂໍ້ມູນຈະບໍ່ສາມາດແກ້ໄຂໄດ້ອີກ.",
        Confirm: "ຢືນຢັນ",
        AccountUnderReview: "ບັນຊີຢູ່ໃນການກວດສອບ",
        AccountVerified: "ບັນຊີໄດ້ຖືກຢືນຢັນແລ້ວ",
        Security: "ຄວາມປອດໄພ",
        WantToChangePassword: "ທ່ານຕ້ອງການປ່ຽນລະຫັດຜ່ານບໍ? ກົດປຸ່ມຂ້າງລຸ່ມນີ້ເພື່ອປ່ຽນ.",
        RequiredToEnable2FA: "ຕ້ອງເປີດ 2FA ເພື່ອຖອນເງິນຫຼືອັບເດດຄວາມປອດໄພ.",
        Open2FA: "ເປີດ 2FA",
        Change: "ປ່ຽນ",
        Surname: "ນາມສະກຸນ",
        Name: "ຊື່",
        CardPassport: "ເລກບັດປະຈຳຕົວ / ເລກພາສະປອດ",
        Nation: "ປະເທດ",
        Next: "ຕໍ່ໄປ",
        Back: "ກັບຄືນ",
        Done: "ສຳເລັດ",
        IdentityAuthentication: "ການຢືນຢັນຕົວຕົນ",
        PleaseEnsureThePhoto1: "ກະລຸນາຮັບປະກັນວ່າຮູບພາບຄົບຖ້ວນແລະຊັດເຈນ, ໃນຮູບແບບ JPG, PNG, JPEG.",
        PleaseEnsureThePhoto2: " ຖ່າຍຮູບຂອງບັດປະຈຳຕົວ/ພາສະປອດຂອງທ່ານ. ຮູບພາບຕ້ອງສະແດງໃຫ້ເຫັນແຈ້ງແລະຊັດເຈນ, ບໍ່ມີມຸມຫາຍ.",
        FrontCard: "ດ້ານໜ້າຂອງບັດປະຈຳຕົວ/ພາສະປອດ",
        BackCard: "ດ້ານຫຼັງຂອງບັດປະຈຳຕົວ/ພາສະປອດ",
        Consider: "ພິຈາລະນາ",
        ApplySuccess: 'ສະໝັກສຳເລັດ',
        ClickDoneToComplete: "ພວກເຮົາຈະກວດສອບຂໍ້ມູນຂອງທ່ານແລະສຳເລັດການຢືນຢັນພາຍໃນ 7 ວັນທຳງານ!",
        YourAccountVerified: "ບັນຊີຂອງທ່ານໄດ້ຖືກຢືນຢັນແລ້ວ!",
        Asset: "ຊັບສິນ",
        StartTime: "ເວລາເລີ່ມຕົ້ນ",
        Select: "ເລືອກ",
        Selected: "ເລືອກແລ້ວ",
        OpenPrice: "ລາຄາເປີດ",
        ClosingPrice: "ລາຄາປິດ",
        Value: "ມູນຄ່າ",
        Pay: "ຈ່າຍ",
        Time: "ເວລາ",
        Type: "ປະເພດ",
        Description: "Txid/ລາຍລະອຽດ",
        Cryptocurrency: "ສະກຸນເງິນດິຈິຕອນ",
        Address: "ທີ່ຢູ່",
        GoogleAuthentication: "ການຢືນຢັນຂອງ Google",
        GoogleAuthenticationIsEnabled: "Google Authenticator ໄດ້ຖືກເປີດໃຊ້ງານ. ເພື່ອປິດໃຊ້ງານ, ປ້ອນລະຫັດ Google Authenticator ແລະແຕະປິດໃຊ້ງານ.",
        OpenYourGoogleAuthentication: "ເປີດແອັບ Google Authenticator ຂອງທ່ານແລະສະແກນ QR code ດ້ານລຸ່ມນີ້ຫຼືປ້ອນລະຫັດເຂົ້າໃນແອັບ. ລະຫັດນີ້ໃຊ້ເພື່ອກູ້ຄືນການຢືນຢັນຂອງ Google ຂອງທ່ານເມື່ອທ່ານປ່ຽນຫຼືເສຍໂທລະສັບ. ກະລຸນາສຳຮອງລະຫັດນີ້ກ່ອນທີ່ຈະເປີດໃຊ້ງານການຢືນຢັນຂອງ Google.",
        BackupCode: "ລະຫັດສຳຮອງ",
        Password: "ລະຫັດຜ່ານ",
        Verification: "ການຢືນຢັນ",
        Code2FA: "ລະຫັດ 2FA",
        SendCode: "ສົ່ງລະຫັດ",
        TurnOn: "ເປີດ",
        Deactivate: "ປິດໃຊ້ງານ",
        AmountOfMoney: "ຈຳນວນເງິນ",
        DepositAddress: "ທີ່ຢູ່ບັນຈຸເງິນ",
        Yours: "ຂອງທ່ານ",
        SendOnly: "ສົ່ງເທົ່ານັ້ນ",
        ToThisAddress: "ໄປຫາທີ່ຢູ່ນີ້",
        ConfirmationsNeeded: "ການຢືນຢັນທີ່ຕ້ອງການ.",
        Max: "ສູງສຸດ",
        BalanceAmount: "ຈຳນວນຍອດເງິນ",
        MinimumWithdrawAmount: "ຈຳນວນຖອນຕ່ຳສຸດແມ່ນ",
        TransactionProcessingFee: "ຄ່າທຳນຽມການດຳເນີນທຸລະກຳ",
        FromYourRemainingBalance: "ຈະຖືກຫັກອອກຈາກຍອດເງິນທີ່ເຫຼືອຂອງທ່ານ.",
        DepositWithdraw: 'ການເຮັດທຸລະກໍາ ເງິນຝາກ ຖອນເງິນໂດຍໃຊ້ເຄືອຂ່າຍ',
        ClickToPay: "ກົດທີ່ນີ້ເພື່ອດຳເນີນການຊຳລະ",
        MinValueWithdraw: "ຈຳນວນເງິນຕໍ່າສຸດ",
        NoteWithdraw: "ໃສ່ບັນທຶກຂອງທ່ານ",
        Require2FA: "ທ່ານຕ້ອງເປີດໃຊ້ 2FA ເພື່ອຮ້ອງຂໍການຖອນເງິນ",
        ConfirmWithdraw: "ຢືນຢັນການຖອນເງິນ",
        WithdrawAmount: "ຈຳນວນເງິນທີ່ຖອນ",
        WithdrawTime: "ເວລາ",
        WithdrawType: "ປະເພດການຖອນ",
        Input2FA: "ໃສ່ລະຫັດ 2FA ຂອງທ່ານ",

        TradingIndicatorsBenefit: "ຕົວຊີ້ວັດການຄ້າຊ່ວຍໃຫ້ລູກຄ້າສ້າງລາຍໄດ້ຫຼາຍຂຶ້ນ",
        PUTEXAdvancedIndicators: "PUTEX ພັດທະນາຕົວຊີ້ວັດທີ່ທັນສະໄໝສູງ ແລະ ງ່າຍຕໍ່ການໃຊ້ງານເພື່ອຊ່ວຍນັກຄ້າຕັດສິນໃຈການຄ້າໄດ້ດີຂຶ້ນ",
        SmartTraining: "ການຝຶກອບຣົມອັດສະລິຍະ",
        EffectiveMoneyMaking: "ຄົ້ນພົບວິທີທີ່ມີປະສິດທິພາບທີ່ສຸດໃນການສ້າງລາຍໄດ້",
        NewEarningOpportunities: "ສຳຫຼວດໂອກາດສ້າງລາຍໄດ້ໃໝ່ໆ ຕັ້ງແຕ່ການຄ້າປະຈຳວັນ ຈົນເຖິງການຮັບລາຍໄດ້ແບບພາສຊີບຈາກຄ່າຄອມມິຊຊັນການຄ້າ ຫຼື ຄ່າຄອມມິຊຊັນ VIP",
        OurPlatform: "ເວທີຂອງພວກເຮົາ",
        InnovativePlatform: "ເວທີທີ່ສ້າງຂຶ້ນດ້ວຍນະວັດຕະກຳ",
        LatestTradingInnovations: "ພວກເຮົາສະເໝີປັບປຸງນະວັດຕະກຳລ່າສຸດໃນດ້ານການຄ້າເພື່ອຊ່ວຍໃຫ້ທຸກຄົນສາມາດສ້າງກຳໄລຈາກການຄ້າໃນ PUTEX",
        StableSecure: "ສະຖຽນລະພາບ ແລະ ປອດໄພ",
        ReferAndEarn: "ແນະນຳ ແລະ ສ້າງລາຍໄດ້",
        FastFree: "ໄວ ແລະ ຟຣີ",
        CustomerFeedback: "ປະສົບການ ແລະ ຄຳຕິຊົມຈາກລູກຄ້າ",
        UserFriendlyPlatform: "ເວທີການຄ້າທີ່ເປັນມິດກັບຜູ້ໃຊ້",
        StreamlinedFeatures: "ຄຸນສົມບັດທີ່ຖືກປັບໃຫ້ງ່າຍດາຍ, ຄົ້ນຫາ ແລະ ຄ້າຂາຍໄດ້ສະດວກ. ກຣາຟທີ່ເຂົ້າໃຈງ່າຍພ້ອມຕົວຊີ້ວັດຄົບຖ້ວນຊ່ວຍໃຫ້ຂ້ອຍຈັບທິດທາງໄດ້ໄວ. ເປັນທາງເລືອກທີ່ດີສຳລັບທັງຜູ້ເລີ່ມຕົ້ນ ແລະ ນັກລົງທຶນມືອາຊີບ.",
        HighSecurityTrading: "ຄວາມປອດໄພສູງ, ຄ້າຂາຍດ້ວຍຄວາມໝັ້ນໃຈ",
        SecureCryptoTrading: "ຂ້ອຍສະເໝີກັງວົນເລື່ອງຄວາມປອດໄພໃນການຄ້າຄຣິບໂຕ, ແຕ່ເວທີນີ້ເຮັດໃຫ້ຂ້ອຍຮູ້ສຶກສະບາຍໃຈຢ່າງສົມບູນ. ທຸກການເຮັດທຸລະກຳແມ່ນໂປ່ງໃສ. ຂ້ອຍບໍ່ເຄີຍພົບບັນຫາດ້ານຄວາມປອດໄພໃດໆ. ນີ້ແມ່ນຈຸດເດັ່ນທີ່ເວທີອື່ນໆຍາກທີ່ຈະບັນລຸ.",
        DedicatedSupport: "ການສະໜັບສະໜຸນລູກຄ້າດ້ວຍຄວາມຕັ້ງໃຈ",
        ResponsiveSupportTeam: "ສິ່ງໜຶ່ງທີ່ເຮັດໃຫ້ຂ້ອຍປະທັບໃຈຄືທີມສະໜັບສະໜຸນທີ່ຕອບກັບໄວຫຼາຍ. ທຸກຄຳຖາມຂອງຂ້ອຍໄດ້ຮັບຄຳຕອບພາຍໃນສອງສາມນາທີ. ບໍ່ວ່າຈະເປັນເລື່ອງການຝາກ-ຖອນເງິນ ຫຼື ຄຸນສົມບັດການຄ້າ, ພວກເຂົາຈັດການດ້ວຍຄວາມເປັນມືອາຊີບ.",
        QuickStartJourney: "ເລີ່ມຕົ້ນການເດີນທາງຂອງທ່ານໃນສອງສາມນາທີ",
        MultipleIncomeStreams: "ສ້າງແຫຼ່ງລາຍໄດ້ຫຼາຍຢ່າງໃນມື້ນີ້!",
        FAQ: "ຄຳຖາມທີ່ພົບເລື້ອຍ",
        VIPMemberObligations: "ໜ້າທີ່ຂອງສະມາຊິກ VIP",
        PrivacyPolicy: "ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ",
        TermsConditions: "ຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂ",
        RiskWarning: "ຄຳເຕືອນເລື່ອງຄວາມສ່ຽງ",
        Disclaimer: "ການປະຕິເສດຄວາມຮັບຜິດຊອບ",
        UpdateNotifications: "ຮັບການແຈ້ງເຕືອນອັບເດດ",
        SubscribeUpdates: "ລົງທະບຽນເພື່ອຮັບການອັບເດດ ແລະ ການແຈ້ງເຕືອນກ່ຽວກັບການແລກປ່ຽນ ແລະ ຜະລິດຕະພັນຂອງພວກເຮົາ",
        Submit: "ສົ່ງ",
        EnterEmailAddress: "ໃສ່ທີ່ຢູ່ອີເມວຂອງທ່ານ"
    }
}